webpackJsonp([43],{

/***/ 1032:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('router-view')], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1036:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./auth.js": 610,
	"./business-profile.js": 584,
	"./business.js": 585,
	"./calibrate.js": 611,
	"./calibrationHomepageMessage.js": 612,
	"./chat.js": 613,
	"./connected-devices.js": 614,
	"./connectsync.js": 615,
	"./countries.js": 616,
	"./dashboard.js": 617,
	"./device.js": 618,
	"./deviceTypes.js": 619,
	"./files.js": 620,
	"./integration.js": 586,
	"./issues.js": 621,
	"./jato.js": 582,
	"./lookup.js": 622,
	"./maintenance.js": 623,
	"./openinghours.js": 624,
	"./report.js": 625,
	"./scanpro.js": 626,
	"./serviceElements.js": 627,
	"./servicerequest.js": 628,
	"./translation.js": 629,
	"./users.js": 630
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1036;

/***/ }),

/***/ 1037:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./admin/index.js": 636,
	"./auth/actions.js": 241,
	"./auth/getters.js": 242,
	"./auth/index.js": 637,
	"./auth/mutations.js": 243,
	"./auth/state.js": 244,
	"./auth/types.js": 147,
	"./business/actions.js": 245,
	"./business/getters.js": 246,
	"./business/index.js": 638,
	"./business/mutations.js": 247,
	"./business/state.js": 248,
	"./business/types.js": 148,
	"./calibrate/actions.js": 249,
	"./calibrate/getters.js": 250,
	"./calibrate/index.js": 639,
	"./calibrate/mutations.js": 251,
	"./calibrate/state.js": 252,
	"./calibrate/types.js": 253,
	"./chat/actions.js": 254,
	"./chat/getters.js": 255,
	"./chat/index.js": 640,
	"./chat/mutations.js": 256,
	"./chat/sendbird.js": 228,
	"./chat/state.js": 257,
	"./chat/types.js": 118,
	"./configuration/index.js": 641,
	"./configuration/types.js": 258,
	"./connecteddevices/actions.js": 259,
	"./connecteddevices/getters.js": 260,
	"./connecteddevices/index.js": 642,
	"./connecteddevices/mutations.js": 261,
	"./connecteddevices/state.js": 262,
	"./connecteddevices/types.js": 263,
	"./connectsync/index.js": 643,
	"./countries/index.js": 644,
	"./dashboard/actions.js": 264,
	"./dashboard/getters.js": 265,
	"./dashboard/index.js": 645,
	"./dashboard/mutations.js": 266,
	"./dashboard/state.js": 267,
	"./dashboard/types.js": 149,
	"./devices/actions.js": 268,
	"./devices/getters.js": 269,
	"./devices/index.js": 646,
	"./devices/mutations.js": 270,
	"./devices/state.js": 271,
	"./devices/types.js": 150,
	"./files/actions.js": 272,
	"./files/getters.js": 273,
	"./files/index.js": 647,
	"./files/mutations.js": 274,
	"./files/state.js": 275,
	"./files/types.js": 276,
	"./integrations/actions.js": 277,
	"./integrations/getters.js": 278,
	"./integrations/index.js": 648,
	"./integrations/mutations.js": 279,
	"./integrations/state.js": 280,
	"./integrations/types.js": 151,
	"./locales/index.js": 649,
	"./lookup/index.js": 650,
	"./maintenance/actions.js": 281,
	"./maintenance/getters.js": 282,
	"./maintenance/index.js": 651,
	"./maintenance/mutations.js": 283,
	"./maintenance/state.js": 284,
	"./maintenance/types.js": 152,
	"./make/actions.js": 285,
	"./make/getters.js": 286,
	"./make/index.js": 652,
	"./make/mutations.js": 287,
	"./make/state.js": 288,
	"./make/types.js": 289,
	"./message/actions.js": 290,
	"./message/getters.js": 291,
	"./message/index.js": 653,
	"./message/mutations.js": 292,
	"./message/state.js": 293,
	"./message/types.js": 294,
	"./notificationmessage/actions.js": 295,
	"./notificationmessage/getters.js": 296,
	"./notificationmessage/index.js": 654,
	"./notificationmessage/mutations.js": 297,
	"./notificationmessage/state.js": 298,
	"./notificationmessage/types.js": 153,
	"./openinghours/actions.js": 299,
	"./openinghours/getters.js": 300,
	"./openinghours/index.js": 655,
	"./openinghours/mutations.js": 301,
	"./openinghours/state.js": 302,
	"./openinghours/types.js": 154,
	"./report/actions.js": 303,
	"./report/getters.js": 304,
	"./report/index.js": 656,
	"./report/mutations.js": 305,
	"./report/state.js": 306,
	"./report/types.js": 307,
	"./scanpro/actions.js": 308,
	"./scanpro/getters.js": 309,
	"./scanpro/index.js": 657,
	"./scanpro/mutations.js": 310,
	"./scanpro/state.js": 311,
	"./scanpro/types.js": 155,
	"./serviceelements/index.js": 658,
	"./servicerequests/actions.js": 312,
	"./servicerequests/getters.js": 313,
	"./servicerequests/index.js": 659,
	"./servicerequests/mutations.js": 314,
	"./servicerequests/state.js": 315,
	"./servicerequests/types.js": 156,
	"./translation/actions.js": 316,
	"./translation/getters.js": 317,
	"./translation/index.js": 660,
	"./translation/mutations.js": 318,
	"./translation/state.js": 319,
	"./translation/types.js": 320,
	"./users/actions.js": 321,
	"./users/getters.js": 322,
	"./users/index.js": 661,
	"./users/mutations.js": 323,
	"./users/state.js": 324,
	"./users/types.js": 157
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1037;

/***/ }),

/***/ 1038:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./en.json": 1039,
	"./es.json": 1040
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1038;

/***/ }),

/***/ 1039:
/***/ (function(module, exports) {

module.exports = {"btn.save":"Save","btn.cancel":"Cancel","btn.close":"Close","btn.delete":"Delete","btn.addholidayschedule":"Add Public Holiday","tab.standardopeninghours.title":"Standard Opening Hours","tab.publicholidayopeninghours.title":"Public Holiday Opening Hours","error.openingtimessetorempty":"Both opening and closing times must be set or left empty.","error.openingtimeearlier":"Opening time must be earlier than closing time.","error.datealreadyscheduled":"The selected date has already been scheduled.","msg.deleteconfirmation":"Are you sure you want to delete this scheduled holiday?","dialog.header.confirmdeletion":"Confirm Deletion","dialog.header.createnewschedule":"Create New Holiday Opening Hours","dialog.header.editHolidayschedule":"Edit Holiday Opening Hours","openingtimes.title.platform":"Platform","openingtimes.title.supportemail":"Support Email"}

/***/ }),

/***/ 1040:
/***/ (function(module, exports) {

module.exports = {"btn.save":"Save","btn.cancel":"Cancel","btn.close":"Close","btn.delete":"Delete","btn.addholidayschedule":"Add Public Holiday","tab.standardopeninghours.title":"Horario de apertura estándar","tab.publicholidayopeninghours.title":"Horario de apertura en días festivos","error.openingtimessetorempty":"Both opening and closing times must be set or left empty.","error.openingtimeearlier":"Opening time must be earlier than closing time.","error.datealreadyscheduled":"The selected date has already been scheduled.","msg.deleteconfirmation":"Are you sure you want to delete this scheduled holiday?","dialog.header.confirmdeletion":"Confirm Deletion","dialog.header.createnewschedule":"Create New Holiday Opening Hours","dialog.header.editHolidayschedule":"Edit Holiday Opening Hours","openingtimes.title.platform":"Platform","openingtimes.title.supportemail":"Support Email"}

/***/ }),

/***/ 1041:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 1042:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 1043:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 1044:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 1045:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 1046:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 1047:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 1048:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 1049:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 1050:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 1051:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 1052:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 1053:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 1054:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 11:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__ = __webpack_require__(325);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);


var endpoints = {};
var files = __webpack_require__(1036);

files.keys().forEach(function (path) {
  var endpoint = files(path);
  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(endpoint).forEach(function (x) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(endpoint[x]).forEach(function (y) {
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default()(endpoints, y, { value: endpoint[x][y] });
    });
  });
});

/* harmony default export */ __webpack_exports__["a"] = (endpoints);

/***/ }),

/***/ 118:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "GLOBAL_HANDLER", function() { return GLOBAL_HANDLER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "GET_MESSAGE_LIMIT", function() { return GET_MESSAGE_LIMIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "INIT_SENDBIRD", function() { return INIT_SENDBIRD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MAX_COUNT", function() { return MAX_COUNT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ADD_MESSAGE", function() { return ADD_MESSAGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "RESET_CHANNELS", function() { return RESET_CHANNELS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "RESET_USERS", function() { return RESET_USERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "RESET_MESSAGES", function() { return RESET_MESSAGES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_TYPING", function() { return SET_TYPING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_PAGE_SIZE", function() { return SET_PAGE_SIZE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_SEARCH_TERM", function() { return SET_SEARCH_TERM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_PAGE_SIZE_USER", function() { return SET_PAGE_SIZE_USER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_SEARCH_TERM_USER", function() { return SET_SEARCH_TERM_USER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_CHANNEL_CHECKED", function() { return SET_CHANNEL_CHECKED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_USER_CHECKED", function() { return SET_USER_CHECKED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_MESSAGE_CHECKED", function() { return SET_MESSAGE_CHECKED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_CHANNELS", function() { return SET_CHANNELS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_USERS", function() { return SET_USERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_CHANNEL_MESSAGE_COUNT", function() { return SET_CHANNEL_MESSAGE_COUNT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_MESSAGES", function() { return SET_MESSAGES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "RESET_REQUESTS", function() { return RESET_REQUESTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_REQUESTS", function() { return SET_REQUESTS; });
var GLOBAL_HANDLER = 'GLOBAL_HANDLER';
var GET_MESSAGE_LIMIT = 30;
var INIT_SENDBIRD = 'INIT_SENDBIRD';
var MAX_COUNT = '+9';
var ADD_MESSAGE = 'ADD_MESSAGE';
var RESET_CHANNELS = 'RESET_CHANNELS';
var RESET_USERS = 'RESET_USERS';
var RESET_MESSAGES = 'RESET_MESSAGES';
var SET_TYPING = 'SET_TYPING';
var SET_PAGE_SIZE = 'SET_PAGE_SIZE';
var SET_SEARCH_TERM = 'SET_SEARCH_TERM';
var SET_PAGE_SIZE_USER = 'SET_PAGE_SIZE_USER';
var SET_SEARCH_TERM_USER = 'SET_SEARCH_TERM_USER';
var SET_CHANNEL_CHECKED = 'SET_CHANNEL_CHECKED';
var SET_USER_CHECKED = 'SET_USER_CHECKED';
var SET_MESSAGE_CHECKED = 'SET_MESSAGE_CHECKED';
var SET_CHANNELS = 'SET_CHANNELS';
var SET_USERS = 'SET_USERS';
var SET_CHANNEL_MESSAGE_COUNT = 'SET_CHANNEL_MESSAGE_COUNT';
var SET_MESSAGES = 'SET_MESSAGES';
var RESET_REQUESTS = 'RESET_REQUESTS';
var SET_REQUESTS = 'SET_REQUESTS';

/***/ }),

/***/ 147:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LOGOUT", function() { return LOGOUT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_USER", function() { return SET_USER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_USER_INFO", function() { return SET_USER_INFO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_PASSTHROUGH", function() { return SET_PASSTHROUGH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_ROLES", function() { return SET_ROLES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_SOLUTION", function() { return SET_SOLUTION; });
var LOGOUT = 'LOGOUT';
var SET_USER = 'SET_USER';
var SET_USER_INFO = 'SET_USER_INFO';
var SET_PASSTHROUGH = 'SET_PASSTHROUGH';
var SET_ROLES = 'SET_ROLES';
var SET_SOLUTION = 'SET_SOLUTION';

/***/ }),

/***/ 148:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "INIT_BUSINESS_DATA", function() { return INIT_BUSINESS_DATA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ADD_TO_CART", function() { return ADD_TO_CART; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_DISCOUNT_MODAL", function() { return SET_DISCOUNT_MODAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_LOADING", function() { return SET_LOADING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_ACTIVE_TAB", function() { return SET_ACTIVE_TAB; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_BUSINESSES", function() { return SET_BUSINESSES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "COPY_BILLING_ADDRESS_FROM_DEFAULT", function() { return COPY_BILLING_ADDRESS_FROM_DEFAULT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_BUSINESS_SID", function() { return SET_BUSINESS_SID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ADD_NEW_USER_TO_LIST", function() { return ADD_NEW_USER_TO_LIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_NEW_USER_ID", function() { return SET_NEW_USER_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ADD_MANUFACTURER", function() { return ADD_MANUFACTURER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "REMOVE_MANUFACTURER", function() { return REMOVE_MANUFACTURER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UPDATE_MANUFACTURER_PERCENT", function() { return UPDATE_MANUFACTURER_PERCENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_DISTRIBUTORS", function() { return SET_DISTRIBUTORS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_SALES_REPS", function() { return SET_SALES_REPS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ADD_DISCOUNT_BY_VOLUME_TO_PRODUCT", function() { return ADD_DISCOUNT_BY_VOLUME_TO_PRODUCT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "REMOVE_DISCOUNT_BY_VOLUME_TO_PRODUCT", function() { return REMOVE_DISCOUNT_BY_VOLUME_TO_PRODUCT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_LOCATION", function() { return SET_LOCATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_INFO", function() { return SET_INFO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_USERS", function() { return SET_USERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_BILLING", function() { return SET_BILLING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_DISCOUNTS", function() { return SET_DISCOUNTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_DISCOUNTS_PRODUCT_ADDS", function() { return SET_DISCOUNTS_PRODUCT_ADDS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_NOTES", function() { return SET_NOTES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ADD_NOTE_TO_LIST", function() { return ADD_NOTE_TO_LIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "RESET_PERIOD_DATA", function() { return RESET_PERIOD_DATA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_BUSINESS_STATUS", function() { return SET_BUSINESS_STATUS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_ROLES", function() { return SET_ROLES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_BUSINESSES_FOUND", function() { return SET_BUSINESSES_FOUND; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_SOURCE", function() { return SET_SOURCE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_SWAPSHOP", function() { return SET_SWAPSHOP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_PROMOTION", function() { return SET_PROMOTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_ALL_BUSINESSES", function() { return SET_ALL_BUSINESSES; });
var INIT_BUSINESS_DATA = 'INIT_BUSINESS_DATA';
var ADD_TO_CART = 'ADD_TO_CART';
var SET_DISCOUNT_MODAL = 'SET_DISCOUNT_MODAL';
var SET_LOADING = 'SET_LOADING';
var SET_ACTIVE_TAB = 'SET_ACTIVE_TAB';
var SET_BUSINESSES = 'SET_BUSINESSES';
var COPY_BILLING_ADDRESS_FROM_DEFAULT = 'COPY_BILLING_ADDRESS_FROM_DEFAULT';
var SET_BUSINESS_SID = 'SET_BUSINESS_SID';
var ADD_NEW_USER_TO_LIST = 'ADD_NEW_USER_TO_LIST';
var SET_NEW_USER_ID = 'SET_NEW_USER_ID';
var ADD_MANUFACTURER = 'ADD_MANUFACTURER';
var REMOVE_MANUFACTURER = 'REMOVE_MANUFACTURER';
var UPDATE_MANUFACTURER_PERCENT = 'UPDATE_MANUFACTURER_PERCENT';
var SET_DISTRIBUTORS = 'SET_DISTRIBUTORS';
var SET_SALES_REPS = 'SET_SALES_REPS';
var ADD_DISCOUNT_BY_VOLUME_TO_PRODUCT = 'ADD_DISCOUNT_BY_VOLUME_TO_PRODUCT';
var REMOVE_DISCOUNT_BY_VOLUME_TO_PRODUCT = 'REMOVE_DISCOUNT_BY_VOLUME_TO_PRODUCT';
var SET_LOCATION = 'SET_LOCATION';
var SET_INFO = 'SET_INFO';
var SET_USERS = 'SET_USERS';
var SET_BILLING = 'SET_BILLING';
var SET_DISCOUNTS = 'SET_DISCOUNTS';
var SET_DISCOUNTS_PRODUCT_ADDS = 'SET_DISCOUNTS_PRODUCT_ADDS';
var SET_NOTES = 'SET_NOTES';
var ADD_NOTE_TO_LIST = 'ADD_NOTE_TO_LIST';
var RESET_PERIOD_DATA = 'RESET_PERIOD_DATA';
var SET_BUSINESS_STATUS = 'SET_BUSINESS_STATUS';
var SET_ROLES = 'SET_ROLES';
var SET_BUSINESSES_FOUND = 'SET_BUSINESSES_FOUND';
var SET_SOURCE = 'SET_SOURCE';
var SET_SWAPSHOP = 'SET_SWAPSHOP';
var SET_PROMOTION = 'SET_PROMOTION';
var SET_ALL_BUSINESSES = 'SET_ALL_BUSINESSES';

/***/ }),

/***/ 149:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_SEARCH_TERM", function() { return SET_SEARCH_TERM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_PAGE_SIZE", function() { return SET_PAGE_SIZE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_SORT_DIR", function() { return SET_SORT_DIR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_ORDER_BY", function() { return SET_ORDER_BY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_STATUS", function() { return SET_STATUS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_FILTER_BY", function() { return SET_FILTER_BY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_REQUESTS", function() { return SET_REQUESTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_SCHEMA", function() { return SET_SCHEMA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_QUERY_TEMPLATES", function() { return SET_QUERY_TEMPLATES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_CURRENT_TEMPLATE", function() { return SET_CURRENT_TEMPLATE; });
var SET_SEARCH_TERM = 'SET_SEARCH_TERM';
var SET_PAGE_SIZE = 'SET_PAGE_SIZE';
var SET_SORT_DIR = 'SET_SORT_DIR';
var SET_ORDER_BY = 'SET_ORDER_BY';
var SET_STATUS = 'SET_STATUS';
var SET_FILTER_BY = 'SET_FILTER_BY';
var SET_REQUESTS = 'SET_REQUESTS';
var SET_SCHEMA = 'SET_SCHEMA';
var SET_QUERY_TEMPLATES = 'SET_QUERY_TEMPLATES';
var SET_CURRENT_TEMPLATE = 'SET_CURRENT_TEMPLATE';

/***/ }),

/***/ 150:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_SEARCH_TERM", function() { return SET_SEARCH_TERM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_PAGE_SIZE", function() { return SET_PAGE_SIZE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_SORT_DIR", function() { return SET_SORT_DIR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_ORDER_BY", function() { return SET_ORDER_BY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_STATUS", function() { return SET_STATUS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_FILTER_BY", function() { return SET_FILTER_BY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_DEVICE", function() { return SET_DEVICE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_DEVICES", function() { return SET_DEVICES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_DEVICE_TYPES", function() { return SET_DEVICE_TYPES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_DEVICEFILE", function() { return SET_DEVICEFILE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_DEVICEFILES", function() { return SET_DEVICEFILES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_CURRENT_DEVICE", function() { return SET_CURRENT_DEVICE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CLEAR_DEVICES", function() { return CLEAR_DEVICES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_TOOLS", function() { return SET_TOOLS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_TOOL_MAKES", function() { return SET_TOOL_MAKES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_FOUND_DEVICES", function() { return SET_FOUND_DEVICES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CLEAR_FOUND_DEVICES", function() { return CLEAR_FOUND_DEVICES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_ASSOCIATED_DEVICES", function() { return SET_ASSOCIATED_DEVICES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "INIT_DEVICE_DATA", function() { return INIT_DEVICE_DATA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_ACTIVE_TAB", function() { return SET_ACTIVE_TAB; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_SOURCE", function() { return SET_SOURCE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_LOCATION", function() { return SET_LOCATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_ASSIGNED_DEVICES", function() { return SET_ASSIGNED_DEVICES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_SHIPMENT", function() { return SET_SHIPMENT; });
var SET_SEARCH_TERM = 'SET_SEARCH_TERM';
var SET_PAGE_SIZE = 'SET_PAGE_SIZE';
var SET_SORT_DIR = 'SET_SORT_DIR';
var SET_ORDER_BY = 'SET_ORDER_BY';
var SET_STATUS = 'SET_STATUS';
var SET_FILTER_BY = 'SET_FILTER_BY';
var SET_DEVICE = 'SET_DEVICE';
var SET_DEVICES = 'SET_DEVICES';
var SET_DEVICE_TYPES = 'SET_DEVICE_TYPES';
var SET_DEVICEFILE = 'SET_DEVICEFILE';
var SET_DEVICEFILES = 'SET_DEVICEFILES';
var SET_CURRENT_DEVICE = 'SET_CURRENT_DEVICE';
var CLEAR_DEVICES = 'CLEAR_DEVICES';
var SET_TOOLS = 'SET_TOOLS';
var SET_TOOL_MAKES = 'SET_TOOL_MAKES';
var SET_FOUND_DEVICES = ' SET_FOUND_DEVICES';
var CLEAR_FOUND_DEVICES = 'CLEAR_FOUND_DEVICES';
var SET_ASSOCIATED_DEVICES = 'SET_ASSOCIATED_DEVICES';
var INIT_DEVICE_DATA = 'INIT_DEVICE_DATA';
var SET_ACTIVE_TAB = 'SET_ACTIVE_TAB';
var SET_SOURCE = 'SET_SOURCE';
var SET_LOCATION = 'SET_LOCATION';
var SET_ASSIGNED_DEVICES = 'SET_ASSIGNED_DEVICES';
var SET_SHIPMENT = 'SET_SHIPMENT';

/***/ }),

/***/ 151:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_SEARCH_TERM", function() { return SET_SEARCH_TERM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_PAGE_SIZE", function() { return SET_PAGE_SIZE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_SORT_DIR", function() { return SET_SORT_DIR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_ORDER_BY", function() { return SET_ORDER_BY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_STATUS", function() { return SET_STATUS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_FILTER_BY", function() { return SET_FILTER_BY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_INTEGRATION", function() { return SET_INTEGRATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_INTEGRATIONS", function() { return SET_INTEGRATIONS; });
var SET_SEARCH_TERM = 'SET_SEARCH_TERM';
var SET_PAGE_SIZE = 'SET_PAGE_SIZE';
var SET_SORT_DIR = 'SET_SORT_DIR';
var SET_ORDER_BY = 'SET_ORDER_BY';
var SET_STATUS = 'SET_STATUS';
var SET_FILTER_BY = 'SET_FILTER_BY';
var SET_INTEGRATION = 'SET_INTEGRATION';
var SET_INTEGRATIONS = 'SET_INTEGRATIONS';

/***/ }),

/***/ 152:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_WORKORDER", function() { return SET_WORKORDER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "INIT_WORKORDER", function() { return INIT_WORKORDER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_TECHNICIANS", function() { return SET_TECHNICIANS; });
var SET_WORKORDER = 'SET_WORKORDER';
var INIT_WORKORDER = 'INIT_WORKORDER';
var SET_TECHNICIANS = 'SET_TECHNICIANS';

/***/ }),

/***/ 153:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_CALIBRATION_HOMEPAGE_MESSAGE", function() { return SET_CALIBRATION_HOMEPAGE_MESSAGE; });
var SET_CALIBRATION_HOMEPAGE_MESSAGE = 'SET_CALIBRATION_HOMEPAGE_MESSAGE';

/***/ }),

/***/ 154:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_SORT_DIR", function() { return SET_SORT_DIR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_ORDER_BY", function() { return SET_ORDER_BY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_OUT_OF_HOURS_AUDIT_LOG", function() { return SET_OUT_OF_HOURS_AUDIT_LOG; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_PAGE_SIZE", function() { return SET_PAGE_SIZE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_STANDARD_OPENING_HOURS", function() { return SET_STANDARD_OPENING_HOURS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_HOLIDAY_OPENING_HOURS", function() { return SET_HOLIDAY_OPENING_HOURS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_TENANT_DETAILS", function() { return SET_TENANT_DETAILS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_SELECTED_TENANT", function() { return SET_SELECTED_TENANT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UPDATE_TENANT_SUPPORT_EMAIL", function() { return UPDATE_TENANT_SUPPORT_EMAIL; });
var SET_SORT_DIR = 'SET_SORT_DIR';
var SET_ORDER_BY = 'SET_ORDER_BY';
var SET_OUT_OF_HOURS_AUDIT_LOG = 'SET_OUT_OF_HOURS_AUDIT_LOG';
var SET_PAGE_SIZE = 'SET_PAGE_SIZE';
var SET_STANDARD_OPENING_HOURS = 'SET_STANDARD_OPENING_HOURS';
var SET_HOLIDAY_OPENING_HOURS = 'SET_HOLIDAY_OPENING_HOURS';
var SET_TENANT_DETAILS = 'SET_TENANT_DETAILS';
var SET_SELECTED_TENANT = 'SET_SELECTED_TENANT';
var UPDATE_TENANT_SUPPORT_EMAIL = 'UPDATE_TENANT_SUPPORT_EMAIL';

/***/ }),

/***/ 155:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_STEP", function() { return SET_STEP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_VISITED_STEP", function() { return SET_VISITED_STEP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "RESET_VISITED_STEP", function() { return RESET_VISITED_STEP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_DECODED_VIN", function() { return SET_DECODED_VIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_VEHICLE", function() { return SET_VEHICLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "RESET_SUBMODELS", function() { return RESET_SUBMODELS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_RECOMMENDATION", function() { return SET_RECOMMENDATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_SELECTED_CHECKLIST_ITEMS", function() { return SET_SELECTED_CHECKLIST_ITEMS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_CORPORATE_ID", function() { return SET_CORPORATE_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_SCANPRO_CONFIGURATION", function() { return SET_SCANPRO_CONFIGURATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_SCANPRO_CHECKLIST", function() { return SET_SCANPRO_CHECKLIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_SCANPRO_CRITERIA", function() { return SET_SCANPRO_CRITERIA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_CRITERIA_CHANGED", function() { return SET_CRITERIA_CHANGED; });
var SET_STEP = 'SET_STEP';
var SET_VISITED_STEP = 'SET_VISITED_STEP';
var RESET_VISITED_STEP = 'RESET_VISITED_STEP';
var SET_DECODED_VIN = 'SET_DECODED_VIN';
var SET_VEHICLE = 'SET_VEHICLE';
var RESET_SUBMODELS = 'RESET_SUBMODELS';
var SET_RECOMMENDATION = 'SET_RECOMMENDATION';
var SET_SELECTED_CHECKLIST_ITEMS = 'SET_SELECTED_CHECKLIST_ITEMS';
var SET_CORPORATE_ID = 'SET_CORPORATE_ID';
var SET_SCANPRO_CONFIGURATION = 'SET_SCANPRO_CONFIGURATION';
var SET_SCANPRO_CHECKLIST = 'SET_SCANPRO_CHECKLIST';
var SET_SCANPRO_CRITERIA = 'SET_SCANPRO_CRITERIA';
var SET_CRITERIA_CHANGED = 'SET_CRITERIA_CHANGED';

/***/ }),

/***/ 156:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_SEARCH_TERM", function() { return SET_SEARCH_TERM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_PAGE_SIZE", function() { return SET_PAGE_SIZE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_SORT_DIR", function() { return SET_SORT_DIR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_ORDER_BY", function() { return SET_ORDER_BY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_STATUS", function() { return SET_STATUS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_FILTER_BY", function() { return SET_FILTER_BY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_SERVICE_REQUEST", function() { return SET_SERVICE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_SERVICE_REQUESTS", function() { return SET_SERVICE_REQUESTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_SERVICE_REQUEST_HISTORY", function() { return SET_SERVICE_REQUEST_HISTORY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_SERVICE_REQUEST_ISSUES", function() { return SET_SERVICE_REQUEST_ISSUES; });
var SET_SEARCH_TERM = 'SET_SEARCH_TERM';
var SET_PAGE_SIZE = 'SET_PAGE_SIZE';
var SET_SORT_DIR = 'SET_SORT_DIR';
var SET_ORDER_BY = 'SET_ORDER_BY';
var SET_STATUS = 'SET_STATUS';
var SET_FILTER_BY = 'SET_FILTER_BY';
var SET_SERVICE_REQUEST = 'SET_SERVICE_REQUEST';
var SET_SERVICE_REQUESTS = 'SET_SERVICE_REQUESTS';
var SET_SERVICE_REQUEST_HISTORY = 'SET_SERVICE_REQUEST_HISTORY';
var SET_SERVICE_REQUEST_ISSUES = 'SET_SERVICE_REQUEST_ISSUES';

/***/ }),

/***/ 157:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_SEARCH_TERM", function() { return SET_SEARCH_TERM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_PAGE_SIZE", function() { return SET_PAGE_SIZE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_SORT_DIR", function() { return SET_SORT_DIR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_ORDER_BY", function() { return SET_ORDER_BY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_STATUS", function() { return SET_STATUS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_FILTER_BY", function() { return SET_FILTER_BY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_USER", function() { return SET_USER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_USERS", function() { return SET_USERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_CURRENT_USER", function() { return SET_CURRENT_USER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "INIT_USER", function() { return INIT_USER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_HIGHLIGHT", function() { return SET_HIGHLIGHT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_HIGHLIGHT_PASSWORD", function() { return SET_HIGHLIGHT_PASSWORD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_USER_ROLE", function() { return SET_USER_ROLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_SOURCE", function() { return SET_SOURCE; });
var SET_SEARCH_TERM = 'SET_SEARCH_TERM';
var SET_PAGE_SIZE = 'SET_PAGE_SIZE';
var SET_SORT_DIR = 'SET_SORT_DIR';
var SET_ORDER_BY = 'SET_ORDER_BY';
var SET_STATUS = 'SET_STATUS';
var SET_FILTER_BY = 'SET_FILTER_BY';
var SET_USER = 'SET_USER';
var SET_USERS = 'SET_USERS';
var SET_CURRENT_USER = 'SET_CURRENT_USER';
var INIT_USER = 'INIT_USER';
var SET_HIGHLIGHT = 'SET_HIGHLIGHT';
var SET_HIGHLIGHT_PASSWORD = 'SET_HIGHLIGHT_PASSWORD';
var SET_USER_ROLE = 'SET_USER_ROLE';
var SET_SOURCE = 'SET_SOURCE';

/***/ }),

/***/ 225:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(1033);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__routes__ = __webpack_require__(635);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__guard_route__ = __webpack_require__(634);





__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',
  routes: __WEBPACK_IMPORTED_MODULE_2__routes__["a" /* default */]
});

router.beforeEach(function (to, from, next) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__guard_route__["a" /* default */])(to, from, next);
});

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),

/***/ 228:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__types__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_sendbird__ = __webpack_require__(559);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_sendbird___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_sendbird__);




/* harmony default export */ __webpack_exports__["default"] = ({
  strict: false,
  namespaced: true,
  sendbird: null,
  channel: null,
  channelSet: null,
  channelListQuery: null,
  memberCount: 0,
  memberList: [],

  initSendBird: function initSendBird(callback) {
    this.sendbird = new __WEBPACK_IMPORTED_MODULE_2_sendbird___default.a({
      appId: window.config.sendbirdToken
    });
  },
  connectChat: function connectChat(register, callback) {
    var _this = this;

    var self = this;
    if (this.sendbird === undefined || this.sendbird === null) {
      this.initSendBird();
    }
    this.sendbird.connect(register.userId.trim(), function (user, error) {
      if (error) {
        console.error(error);
        return;
      }
      _this.sendbird.updateCurrentUserInfo(register.nickname.trim(), '', function (response, error) {
        if (error) {
          console.error(error);
        } else {
          callback(response);
        }
      });
      var channelHandler = new _this.sendbird.ChannelHandler();
      channelHandler.onMessageReceived = function (channel, message) {
        console.log('Message Received', message);
        __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].dispatch('chat/addMessageToList', message);
        if ('Notification' in window) {
          document.getElementById('notifierSound').play();
        }
      };
      channelHandler.onMessageUpdated = function (channel, message) {
        console.log('Message Updated', message);
      };
      channelHandler.onMessageDeleted = function (channel, messageId) {
        console.log('Message Deleted', messageId);
      };
      channelHandler.onChannelChanged = function (channel) {
        console.log('Channel Changed', channel);
        self.getTotalUnreadCount(function (counts) {});
        __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].dispatch('serviceRequests/updateRequestUnread', { id: channel.name, count: channel.unreadMessageCount });
      };
      channelHandler.onTypingStatusUpdated = function (channel) {
        __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].dispatch('chat/setTyping', channel);
      };
      channelHandler.onReadReceiptUpdated = function (channel) {
        console.log('Message Read');
      };
      channelHandler.onUserLeft = function (channel, user) {
        console.log('User Left', user);
      };
      channelHandler.onUserJoined = function (channel, user) {
        console.log('User Joined', user);
      };
      _this.sendbird.addChannelHandler([__WEBPACK_IMPORTED_MODULE_0__types__["GLOBAL_HANDLER"]], channelHandler);
    });
  },

  setChannel: function setChannel(channel) {
    this.channel = channel;
  },
  getChannelInfo: function getChannelInfo(channelUrl, callback) {
    this.sendbird.GroupChannel.getChannel(channelUrl, function (channel, error) {
      if (error) {
        console.error(error);
        callback(null, error);
      }
      callback(channel, null);
    });
  },
  getChannelUnreadCount: function getChannelUnreadCount(channel) {
    return channel.unreadMessageCount;
  },
  getMessageList: function getMessageList(channelSet, callback) {
    if (!channelSet.query) {
      channelSet.query = channelSet.channel.createPreviousMessageListQuery();
    }
    if (channelSet.query.hasMore && !channelSet.query.isLoading) {
      channelSet.query.load(__WEBPACK_IMPORTED_MODULE_0__types__["GET_MESSAGE_LIMIT"], false, function (messageList, error) {
        if (error) {
          console.error(error);
        }
        callback(messageList);
      });
    }
  },

  insertMessageInList: function insertMessageInList(target, index, item) {
    return target.splice(index, 0, item);
  },
  getTotalUnreadCount: function getTotalUnreadCount(callback) {
    this.sendbird.getTotalUnreadMessageCount(function (unreadCount) {
      if (callback) {
        callback(unreadCount);
      }
    });
  },

  getUserList: function getUserList(search, action) {
    var self = this;
    var processUsers = function processUsers(data) {
      var query = [];
      if (data !== undefined && data !== null) {
        data.forEach(function (item) {
          query.push({
            userId: item.email,
            nickname: item.firstName + ' ' + item.lastName,
            profileUrl: item.profileUrl !== null ? item.profileUrl : '',
            isOnline: item.isOnline
          });
        });
      }
      return query;
    };
    if (!self.userListQuery) {
      var xmlHttp = new XMLHttpRequest();
      var url = this.api.url + 'chat/Users';
      if (search !== undefined && search !== null) {
        url += '?token=&pagesize=5&search=' + search;
      } else {
        url += '?token=&pagesize=50';
      }
      xmlHttp.open('GET', url, true);
      xmlHttp.setRequestHeader('Authorization', this.api.token);
      xmlHttp.onload = function () {
        if (xmlHttp.readyState === 4) {
          if (xmlHttp.status === 200) {
            var data = JSON.parse(xmlHttp.responseText);
            if (data !== undefined && data !== null) {
              self.userListQuery = processUsers(data);
              self.userListQuery.isLoading = false;
              self.userListQuery.limit = 50;
              self.userListQuery.hasNext = false;
              self.userListQuery.next = null;
              action(self.userListQuery);
            }
          } else {
            console.error(xmlHttp.statusText);
          }
        }
      };
      xmlHttp.onerror = function (e) {
        console.error(xmlHttp.statusText);
      };
      xmlHttp.send(null);
    }
  },
  xssEscape: function xssEscape(target) {
    if (typeof target === 'string') {
      return target.split('&').join('&amp').split('#').join('&#35').split('<').join('&lt').split('>').join('&gt').split('"').join('&quot').split("'").join('&apos').split('+').join('&#43').split('-').join('&#45').split('(').join('&#40').split(')').join('&#41').split('%').join('&#37');
    } else {
      return target;
    }
  },
  getMessageTime: function getMessageTime(message) {
    var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    var _getDay = function _getDay(val) {
      var day = parseInt(val);
      if (day === 1) {
        return day + 'st';
      } else if (day === 2) {
        return day + 'en';
      } else if (day === 3) {
        return day + 'rd';
      } else {
        return day + 'th';
      }
    };
    var _checkTime = function _checkTime(val) {
      return +val < 10 ? '0' + val : val;
    };
    if (message) {
      var LAST_MESSAGE_TODAY = 'today';
      var LAST_MESSAGE_YESTERDAY = 'yesterday';
      var _nowDate = new Date();
      var _date = new Date(message.createdAt);
      var _time = _checkTime(_date.getHours()) + ':' + _checkTime(_date.getMinutes());
      if (_nowDate.getDate() - _date.getDate() === 1) {
        return LAST_MESSAGE_YESTERDAY + ' at ' + _time;
      } else if (_nowDate.getFullYear() === _date.getFullYear() && _nowDate.getMonth() === _date.getMonth() && _nowDate.getDate() === _date.getDate()) {
        return LAST_MESSAGE_TODAY + ' at ' + _time;
      } else {
        return months[_date.getMonth()] + ' ' + _getDay(_date.getDate()) + ' at ' + _time;
      }
    }
    return '';
  }
});

/***/ }),

/***/ 241:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__types__ = __webpack_require__(147);





function collectChildValidation($this, validations) {
  $this.$children.forEach(function (vm) {
    validations.push(vm.$validator.validateAll());
    if (vm.$children.length) {
      collectChildValidation(vm, validations);
    }
  });
}
/* harmony default export */ __webpack_exports__["default"] = ({
  veeValidateAll: function veeValidateAll(_ref, $this) {
    var commit = _ref.commit;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      var validations = [$this.$validator.validateAll()];
      collectChildValidation($this, validations);
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all(validations).then(function (r) {
        return resolve(r.every(function (i) {
          return i === true;
        }));
      }).catch(reject);
    });
  },
  setPassthrough: function setPassthrough(_ref2, passthrough) {
    var commit = _ref2.commit;

    commit(__WEBPACK_IMPORTED_MODULE_3__types__["SET_PASSTHROUGH"], passthrough);
  },
  checkAuth: function checkAuth(_ref3) {
    var commit = _ref3.commit,
        state = _ref3.state;

    if (!localStorage.getItem('token')) {
      commit(__WEBPACK_IMPORTED_MODULE_3__types__["LOGOUT"]);
    } else {
      commit(__WEBPACK_IMPORTED_MODULE_3__types__["SET_USER"], localStorage.getItem('token'));
      if (!localStorage.getItem('userProfile')) {
        __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].getUserInfo(state.loggedUser.username).then(function (response) {
          commit(__WEBPACK_IMPORTED_MODULE_3__types__["SET_USER_INFO"], response.data);
          commit(__WEBPACK_IMPORTED_MODULE_3__types__["SET_ROLES"], JSON.parse(localStorage.getItem('userProfile')));
        });
      }
    }
  },
  authUser: function authUser(_ref4, data) {
    var commit = _ref4.commit,
        state = _ref4.state;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].authUser(data, function (response) {
        commit(__WEBPACK_IMPORTED_MODULE_3__types__["SET_USER"], response.data);

        resolve(response);
      }, function (error) {
        reject(error);
      });
    }).then(function () {
      __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].getUserInfo(state.loggedUser.username).then(function (response) {
        commit(__WEBPACK_IMPORTED_MODULE_3__types__["SET_USER_INFO"], response.data);
        commit(__WEBPACK_IMPORTED_MODULE_3__types__["SET_ROLES"], JSON.parse(localStorage.getItem('userProfile')));
        console.log('Route Home 2');
        __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push('/');
      });
    });
  },
  setSolution: function setSolution(_ref5, solution) {
    var commit = _ref5.commit;

    commit(__WEBPACK_IMPORTED_MODULE_3__types__["SET_SOLUTION"], solution);
  },
  logout: function logout(_ref6) {
    var commit = _ref6.commit;

    commit(__WEBPACK_IMPORTED_MODULE_3__types__["LOGOUT"]);
    __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push('/login');
  }
});

/***/ }),

/***/ 242:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);

var PAGE_PERMISSIONS = {
  '/partner': ['SuperAdmin', 'Admin'],
  '/partner/create': ['SuperAdmin', 'Admin'],
  '/partner/update': ['SuperAdmin', 'Admin'],
  '/business': ['SuperAdmin', 'Admin'],
  '/business/create': ['SuperAdmin', 'Admin'],
  '/business/update': ['SuperAdmin', 'Admin'],
  '/dashboard/requests': ['SuperAdmin', 'Admin'],
  '/dashboard/statistics': ['SuperAdmin', 'Admin'],
  '/dashboard/devicestatistics': ['SuperAdmin', 'Admin'],
  '/dashboard/activationcardstatistics': ['SuperAdmin', 'Admin'],
  '/dashboard/businessaccountsinfo': ['SuperAdmin', 'Admin'],
  '/dashboard/deviceshipments': ['SuperAdmin', 'Admin'],
  '/admin/defaults': ['SuperAdmin', 'Admin'],
  '/admin/salesreps': ['SuperAdmin', 'Admin'],
  '/admin/translation': ['SuperAdmin', 'Admin'],
  '/admin/service-element-translation': ['SuperAdmin', 'Admin'],
  '/admin/message': ['SuperAdmin', 'Admin'],
  '/admin/devices': ['SuperAdmin', 'Admin'],
  '/admin/device-files': ['SuperAdmin', 'Admin'],
  '/admin/integrations': ['SuperAdmin', 'Admin'],
  '/admin/device-file-detail': ['SuperAdmin', 'Admin'],
  '/admin/integration-detail': ['SuperAdmin', 'Admin'],
  '/admin/report': ['SuperAdmin', 'Admin'],
  '/admin/maintenance': ['SuperAdmin', 'Admin'],
  '/admin/calibrate': ['SuperAdmin', 'Admin'],
  '/admin/mobile': ['SuperAdmin', 'Admin'],
  '/admin/files': ['SuperAdmin', 'Admin'],
  '/admin/chat': ['SuperAdmin', 'Admin'],
  '/admin/scanpro': ['SuperAdmin', 'Admin'],
  '/users': ['SuperAdmin', 'Admin'],
  '/users/create': ['SuperAdmin', 'Admin'],
  '/users/update': ['SuperAdmin', 'Admin'],
  '/admin/makes': ['SuperAdmin', 'Admin'],
  '/admin/calibration-homepage-message': ['SuperAdmin', 'Admin'],
  '/admin/openinghours': ['SuperAdmin', 'Admin'],
  '/admin/openinghours/opening-hours': ['SuperAdmin', 'Admin'],
  '/admin/openinghours/auditLog': ['SuperAdmin', 'Admin'],
  '/admin/rag': ['SuperAdmin', 'Admin'],
  '/admin/rag/auditLog': ['SuperAdmin', 'Admin'],
  '/admin/rag/maintenance': ['SuperAdmin', 'Admin'],
  '/admin/rag/Translations (Service Elements)': ['SuperAdmin', 'Admin'],
  '/admin/device-detail': ['SuperAdmin', 'Admin'],
  '/admin/issues': ['SuperAdmin', 'Admin'],
  '/admin/business-profiles': ['SuperAdmin', 'Admin'],
  '/admin/connected-devices': ['SuperAdmin', 'Admin']
};
/* harmony default export */ __webpack_exports__["default"] = ({
  passthrough: function passthrough(state) {
    return state.passthrough;
  },
  token: function token(state) {
    return state.token;
  },
  loggedUser: function loggedUser(state) {
    return state.loggedUser;
  },
  userProfile: function userProfile(state) {
    return state.userProfile;
  },
  primaryRole: function primaryRole(state) {
    return state.primaryRole;
  },
  roles: function roles(state) {
    return state.roles;
  },
  solutions: function solutions(state) {
    return state.solutions;
  },
  solution: function solution(state) {
    return state.solution;
  },
  channelType: function channelType(state) {
    return state.channelType;
  },
  isAllowed: function isAllowed(state) {
    return function () {
      var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

      var pageArray = page.split('/');
      var checkPage = '';
      var cnt = 0;
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(pageArray), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var item = _step.value;

          if (item !== '' && cnt < 2) {
            if (isNaN(item)) {
              checkPage += '/' + item;
            }
            cnt++;
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      if (!PAGE_PERMISSIONS[checkPage]) {
        console.log('Page does not exist', checkPage);
        return false;
      }
      if (state.roles && state.roles.length) {
        console.log('Checking Roles');
        return state.roles.some(function (r) {
          return PAGE_PERMISSIONS[checkPage].includes(r);
        });
      }
      return false;
    };
  }
});

/***/ }),

/***/ 243:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__types__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jwt_decode__ = __webpack_require__(986);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jwt_decode___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_jwt_decode__);



var _types$SET_PASSTHROUG;



/* harmony default export */ __webpack_exports__["default"] = (_types$SET_PASSTHROUG = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$SET_PASSTHROUG, __WEBPACK_IMPORTED_MODULE_2__types__["SET_PASSTHROUGH"], function (state, passthrough) {
  state.passthrough = passthrough;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$SET_PASSTHROUG, __WEBPACK_IMPORTED_MODULE_2__types__["SET_USER"], function (state, token) {
  state.loggedUser.username = __WEBPACK_IMPORTED_MODULE_3_jwt_decode___default()(token).prn;
  state.loggedUser.role = 'user';
  localStorage.setItem('token', token);
  state.token = token;
  if (localStorage.getItem('userProfile') !== undefined && localStorage.getItem('userProfile') !== null) {
    state.userProfile = JSON.parse(localStorage.getItem('userProfile'));
    state.loggedUser.role = state.userProfile.Role;
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$SET_PASSTHROUG, __WEBPACK_IMPORTED_MODULE_2__types__["SET_USER_INFO"], function (state, data) {
  if (data.length > 0) {
    state.userProfile = data[0];
    localStorage.setItem('userProfile', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(data[0]));
    state.loggedUser.role = state.userProfile.Role;
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$SET_PASSTHROUG, __WEBPACK_IMPORTED_MODULE_2__types__["LOGOUT"], function (state) {
  state.token = '';
  state.role = '';
  state.roles = null;
  state.userProfile = null;
  state.loggedUser = { username: null, role: null };
  localStorage.removeItem('token');
  localStorage.removeItem('roles');
  localStorage.removeItem('role');
  localStorage.removeItem('userProfile');
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$SET_PASSTHROUG, __WEBPACK_IMPORTED_MODULE_2__types__["SET_ROLES"], function (state, profile) {
  state.primaryRole = '';
  if (profile && profile.Roles && profile.Roles.length) {
    var roles = profile.Roles.map(function (r) {
      return r.Name;
    });
    state.roles = roles;
    localStorage.setItem('roles', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(roles));
    if (roles.length > 0) {
      state.primaryRole = roles[0];
    }
    localStorage.setItem('role', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(state.primaryRole));
    console.log('Saving Roles', { roles: state.roles, role: state.primaryRole });
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$SET_PASSTHROUG, __WEBPACK_IMPORTED_MODULE_2__types__["SET_SOLUTION"], function (state, solution) {
  state.solution = solution;
  state.solutions.forEach(function (element) {
    if (parseInt(element.value) === parseInt(solution)) {
      localStorage.setItem('solution', solution);
      state.channelType = element.type;
      localStorage.setItem('channelType', element.type);
    }
  });
}), _types$SET_PASSTHROUG);

/***/ }),

/***/ 244:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = (function () {
  return {
    passthrough: '',
    token: localStorage.getItem('token'),
    loggedUser: {
      username: null,
      role: null
    },
    userProfile: JSON.parse(localStorage.getItem('userProfile')),
    primaryRole: JSON.parse(localStorage.getItem('role')),
    roles: JSON.parse(localStorage.getItem('roles')),
    solutions: [{
      id: 1,
      name: 'UK/Europe',
      value: 1,
      type: 'ServiceRequest'
    }, {
      id: 2,
      name: 'Glass US/Canada',
      value: 2,
      type: 'ServiceRequestGlass'
    }, {
      id: 3,
      name: 'Calibration US/Canada',
      value: 4,
      type: 'ServiceRequestCalibration'
    }, {
      id: 4,
      name: 'ProTech',
      value: 5,
      type: 'ServiceRequestProTech'
    }],
    channelType: localStorage.getItem('channelType') || 'ServiceRequest',
    solution: localStorage.getItem('solution') || 1
  };
});

/***/ }),

/***/ 245:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__types__ = __webpack_require__(148);







/* harmony default export */ __webpack_exports__["default"] = ({
  initBusinessModel: function initBusinessModel(_ref, data) {
    var commit = _ref.commit;

    commit(__WEBPACK_IMPORTED_MODULE_5__types__["INIT_BUSINESS_DATA"], data);
  },
  setActiveTab: function setActiveTab(_ref2, tab) {
    var commit = _ref2.commit,
        state = _ref2.state;

    commit(__WEBPACK_IMPORTED_MODULE_5__types__["SET_ACTIVE_TAB"], tab);
  },
  showModal: function showModal(_ref3, modal) {
    var commit = _ref3.commit;

    commit(__WEBPACK_IMPORTED_MODULE_5__types__["SET_DISCOUNT_MODAL"], modal);
  },
  setSource: function setSource(_ref4, source) {
    var commit = _ref4.commit;

    commit(__WEBPACK_IMPORTED_MODULE_5__types__["SET_SOURCE"], source);
  },
  addNewUserToList: function addNewUserToList(_ref5, defaultTitleId) {
    var commit = _ref5.commit,
        rootState = _ref5.rootState;

    if (defaultTitleId) {
      commit('admin/ADD_SALES_REPRESENTATIVE', defaultTitleId, { root: true });
    } else {
      commit(__WEBPACK_IMPORTED_MODULE_5__types__["ADD_NEW_USER_TO_LIST"], defaultTitleId);
    }
  },
  copyBillingAddressFromDefault: function copyBillingAddressFromDefault(_ref6, isBillingSameAsDefault) {
    var commit = _ref6.commit,
        state = _ref6.state;

    var address;
    if (isBillingSameAsDefault) {
      address = state.business.primaryAddress;
    } else {
      address = {
        street: null,
        city: null,
        state: null,
        postalCode: null,
        country: null,
        language: 1
      };
    }

    commit(__WEBPACK_IMPORTED_MODULE_5__types__["COPY_BILLING_ADDRESS_FROM_DEFAULT"], address);
  },
  getBusinesses: function getBusinesses(_ref7, data) {
    var commit = _ref7.commit;

    __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].getBusinesses(data).then(function (response) {
      commit(__WEBPACK_IMPORTED_MODULE_5__types__["SET_BUSINESSES"], response.data);
    });
  },
  upsertBusiness: function upsertBusiness(_ref8) {
    var commit = _ref8.commit,
        state = _ref8.state;

    commit(__WEBPACK_IMPORTED_MODULE_5__types__["SET_LOADING"], { button: 'upsertBusiness', show: true });
    return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].upsertBusiness(state.business).then(function (response) {
        commit(__WEBPACK_IMPORTED_MODULE_5__types__["SET_BUSINESS_SID"], response.data);

        alert('Saved successfully!');

        resolve(response);
      }).catch(function (error) {
        alert(error.response.data);
        reject(error);
      }).then(function () {
        return commit(__WEBPACK_IMPORTED_MODULE_5__types__["SET_LOADING"], { button: 'upsertBusiness', show: false });
      });
    });
  },
  swapShop: function swapShop(_ref9) {
    var commit = _ref9.commit,
        state = _ref9.state;

    commit(__WEBPACK_IMPORTED_MODULE_5__types__["SET_LOADING"], { button: 'swapShop', show: true });
    return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].swapShop({ oldShopId: state.business.id, newShopId: state.business.shopId }).then(function (response) {
        __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].getBusinessLocation(state.business.sid).then(function (response) {
          if (response.status === 200) {
            commit(__WEBPACK_IMPORTED_MODULE_5__types__["SET_LOCATION"], response.data);
          }
          resolve(response);
        });
        alert('Saved successfully!');

        resolve(response);
      }).catch(function (error) {
        alert(error.response.data.errorMessage);
        reject(error);
      }).then(function () {
        return commit(__WEBPACK_IMPORTED_MODULE_5__types__["SET_LOADING"], { button: 'swapShop', show: false });
      });
    });
  },
  setBusinessStatus: function setBusinessStatus(_ref10, data) {
    var commit = _ref10.commit;

    return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].setBusinessStatus(data).then(function (response) {
        commit(__WEBPACK_IMPORTED_MODULE_5__types__["SET_BUSINESS_STATUS"], data);
        resolve(response);
      }).catch(function (error) {
        alert(error.response.data);
        reject(error);
      });
    });
  },
  upsertBusinessUser: function upsertBusinessUser(_ref11) {
    var commit = _ref11.commit,
        state = _ref11.state;

    commit(__WEBPACK_IMPORTED_MODULE_5__types__["SET_LOADING"], { button: 'upsertBusinessUser', show: true });

    var promises = state.business.users.map(function (user) {
      user.sid = state.business.sid;

      if (user.receivesReportsOnly === undefined || user.receivesReportsOnly === null) {
        user.receivesReportsOnly = false;
      }
      if (user.receivesChatReports === undefined || user.receivesChatReports === null) {
        user.receivesChatReports = false;
      }
      if (user.showRAG === undefined || user.showRAG === null) {
        user.showRAG = false;
      }
      if (user.isTechpro === undefined || user.isTechpro === null) {
        user.isTechpro = false;
      }
      if (user.isTexa === undefined || user.isTexa === null) {
        user.isTexa = false;
      }
      console.log('upsertBusinessUser', __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(user));

      return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].upsertBusinessUser(user).then(function (response) {
          resolve({ user: user, data: response.data });
        }).catch(function (error) {
          resolve({ user: user, data: new Error(error.response.data) });
        });
      });
    });

    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a.all(promises).then(function (responses) {
      var errors = [];
      responses.forEach(function (response) {
        if (response.data instanceof Error) {
          errors.push({ user: response.user, error: response.data });
        } else {
          commit(__WEBPACK_IMPORTED_MODULE_5__types__["SET_NEW_USER_ID"], { user: response.user, newId: response.data.id });
        }
      });
      return errors;
    }).then(function (errors) {
      if (errors.length > 0) {
        var msg = 'Error(s) on the following user(s): \n';
        errors.forEach(function (x) {
          msg += x.user.firstName + ' ' + x.user.lastName + ': ' + x.error.message + ' \n';
        });

        alert(msg);
      } else {
        alert('Saved successfully!');
      }
    }).then(function () {
      return commit(__WEBPACK_IMPORTED_MODULE_5__types__["SET_LOADING"], { button: 'upsertBusinessUser', show: false });
    });
  },
  removeUser: function removeUser(_ref12, user) {
    var commit = _ref12.commit,
        state = _ref12.state;

    state.business.users.splice(state.business.users.indexOf(user), 1);
  },
  resetUserPassword: function resetUserPassword(_ref13, user) {
    var commit = _ref13.commit,
        state = _ref13.state;

    if (user.password === null) {
      alert('Password must be provided.');
      return null;
    }
    return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      var data = {
        password: user.password,
        resetLockout: user.isLockout,
        id: user.userId
      };
      __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].resetUserPassword(data).then(function (response) {
        alert('User password has been reset successfully!');
        resolve(response);
      }).catch(function (error) {
        alert(error.response.data);
        reject(error);
      });
    });
  },
  upsertBusinessNote: function upsertBusinessNote(_ref14, _ref15) {
    var commit = _ref14.commit,
        state = _ref14.state;
    var note = _ref15.note,
        hasFiles = _ref15.hasFiles;

    commit(__WEBPACK_IMPORTED_MODULE_5__types__["SET_LOADING"], { button: 'upsertBusinessNote', show: true });

    var body = {
      sid: state.business.sid,
      noteId: null,
      text: note.get('note')
    };

    return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].upsertBusinessNote(body).then(function (response) {
        if (response.status === 200) {
          var dateCreated = new Date().toISOString();

          var newNote = {
            id: parseInt(response.data),
            text: note.get('note'),
            files: null,
            dateCreated: dateCreated
          };
        }
        resolve(newNote);
      }).catch(function (error) {
        alert(error);
        reject(error);
      });
    }).then(function (newNote) {
      return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        if (hasFiles) {
          note.append('commentId', newNote.id);

          __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].upsertBusinessDocument(note).then(function (response) {
            commit(__WEBPACK_IMPORTED_MODULE_5__types__["ADD_NOTE_TO_LIST"], newNote);
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
              for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(state.business.notes), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                var _note = _step.value;

                if (_note.id === newNote.id) {
                  _note.files = response.data;
                  break;
                }
              }
            } catch (err) {
              _didIteratorError = true;
              _iteratorError = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion && _iterator.return) {
                  _iterator.return();
                }
              } finally {
                if (_didIteratorError) {
                  throw _iteratorError;
                }
              }
            }

            commit(__WEBPACK_IMPORTED_MODULE_5__types__["SET_LOADING"], { button: 'upsertBusinessNote', show: false });
            resolve();
          }).catch(function (error) {
            alert('Something went wrong with the files.');
            reject(error);
          });
        } else {
          commit(__WEBPACK_IMPORTED_MODULE_5__types__["ADD_NOTE_TO_LIST"], newNote);
          resolve();
        }
      });
    }).then(function () {
      return commit(__WEBPACK_IMPORTED_MODULE_5__types__["SET_LOADING"], { button: 'upsertBusinessNote', show: false });
    });
  },
  upsertBusinessInfo: function upsertBusinessInfo(_ref16) {
    var commit = _ref16.commit,
        state = _ref16.state;

    commit(__WEBPACK_IMPORTED_MODULE_5__types__["SET_LOADING"], { button: 'upsertBusinessInfo', show: true });

    return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].upsertBusinessInfo(state.business).then(function (response) {
        alert('Saved successfully!');

        resolve(response);
      }).catch(function (error) {
        alert(error.response.data);
        reject(error.response.data);
      }).then(function () {
        return commit(__WEBPACK_IMPORTED_MODULE_5__types__["SET_LOADING"], { button: 'upsertBusinessInfo', show: false });
      });
    });
  },
  upsertBusinessPromotion: function upsertBusinessPromotion(_ref17) {
    var commit = _ref17.commit,
        state = _ref17.state;

    commit(__WEBPACK_IMPORTED_MODULE_5__types__["SET_LOADING"], { button: 'upsertBusinessPromotion', show: true });
    return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      var body = state.business.promotion;
      body.sid = state.business.sid;
      body.id = state.business.id;
      body.startDate = new Date(state.business.promotion.startDate);
      body.endDate = new Date(state.business.promotion.endDate);

      console.log(body.sid);
      __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].upsertBusinessPromotion(body).then(function (response) {
        alert('Saved successfully!');

        resolve(response);
      }).catch(function (error) {
        alert(error.response.data);
        reject(error.response.data);
      }).then(function () {
        return commit(__WEBPACK_IMPORTED_MODULE_5__types__["SET_LOADING"], { button: 'upsertBusinessPromotion', show: false });
      });
    });
  },
  upsertBusinessBilling: function upsertBusinessBilling(_ref18) {
    var commit = _ref18.commit,
        state = _ref18.state;

    commit(__WEBPACK_IMPORTED_MODULE_5__types__["SET_LOADING"], { button: 'upsertBusinessBilling', show: true });

    var body = state.business.billing;
    body.sid = state.business.sid;

    return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].upsertBusinessBilling(body).then(function (response) {
        commit(__WEBPACK_IMPORTED_MODULE_5__types__["SET_BILLING"], state.business.billing);

        console.log('Saved successfully!');

        resolve(response);
      }).catch(function (error) {
        alert(error.response.data);
        reject(error.response.data);
      }).then(function () {
        return commit(__WEBPACK_IMPORTED_MODULE_5__types__["SET_LOADING"], { button: 'upsertBusinessBilling', show: false });
      });
    });
  },
  upsertBusinessDiscount: function upsertBusinessDiscount(_ref19, _ref20) {
    var commit = _ref19.commit,
        state = _ref19.state;
    var mappingTypeId = _ref20.mappingTypeId,
        otherDescriptorId = _ref20.otherDescriptorId;

    var body = {
      mappingTypeId: mappingTypeId,
      otherDescriptorId: otherDescriptorId,
      products: state.business.discounts,
      sid: state.business.sid
    };

    return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].upsertBusinessDiscount(body).then(function (response) {
        response.data.forEach(function (x, i) {
          if (!x.success) {
            response.data[i] = state.business.discounts.filter(function (discount) {
              return discount.id === x.id;
            })[0];
            response.data[i].success = false;
          }
        });

        alert('Saved successfully!');

        resolve(response);
      }).catch(function (error) {
        alert('Something went wrong!');
        reject(error);
      }).then(function () {
        return commit(__WEBPACK_IMPORTED_MODULE_5__types__["SET_LOADING"], { button: 'upsertBusinessBilling', show: false });
      });
    });
  },
  upsertBusinessProductAddDiscount: function upsertBusinessProductAddDiscount(_ref21) {
    var commit = _ref21.commit,
        state = _ref21.state;

    var body = {
      productAdds: [],
      id: parseInt(state.business.id)
    };
    state.business.discountsProductAdds.forEach(function (element) {
      if (element.isChanged) {
        body.productAdds.push({
          id: parseInt(element.id),
          isTriggerDTC: element.isTriggerDTC,
          isActive: element.isActive === null ? 1 : element.isActive,
          discount: {
            typeId: parseInt(element.discount.typeId),
            amount: parseFloat(element.discount.amount)
          }
        });
      }
    });
    console.log('Saving Product Add Discounts', body);
    return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].upsertDiscountProductAdd(body).then(function (response) {
        response.data.forEach(function (x, i) {
          if (!x.success) {
            response.data[i] = state.business.discountsProductAdds.filter(function (discount) {
              return discount.id === x.id;
            })[0];
            response.data[i].success = false;
          }
        });

        alert('Saved successfully!');

        resolve(response);
      }).catch(function (error) {
        alert('Something went wrong!');
        reject(error);
      }).then(function () {
        return commit(__WEBPACK_IMPORTED_MODULE_5__types__["SET_LOADING"], { button: 'upsertBusinessBilling', show: false });
      });
    });
  },
  modifyManufacturer: function modifyManufacturer(_ref22, _ref23) {
    var commit = _ref22.commit;
    var manufacturer = _ref23.manufacturer,
        event = _ref23.event;

    var obj = { id: manufacturer.id, percent: document.getElementById('manufacturer_percent_' + manufacturer.name).value };
    if (event.target.checked) {
      commit(__WEBPACK_IMPORTED_MODULE_5__types__["ADD_MANUFACTURER"], obj);
    } else {
      commit(__WEBPACK_IMPORTED_MODULE_5__types__["REMOVE_MANUFACTURER"], obj);
    }
  },
  updateManufacturerPercent: function updateManufacturerPercent(_ref24, _ref25) {
    var commit = _ref24.commit;
    var id = _ref25.id,
        event = _ref25.event;

    commit(__WEBPACK_IMPORTED_MODULE_5__types__["UPDATE_MANUFACTURER_PERCENT"], { id: id, percent: event.target.value });
  },
  getDistributors: function getDistributors(_ref26) {
    var commit = _ref26.commit;

    __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].getDistributors().then(function (response) {
      if (response.status === 200) {
        commit(__WEBPACK_IMPORTED_MODULE_5__types__["SET_DISTRIBUTORS"], response.data);
      }
    });
  },
  getSalesReps: function getSalesReps(_ref27) {
    var commit = _ref27.commit;

    __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].getSalesReps().then(function (response) {
      if (response.status === 200) {
        commit(__WEBPACK_IMPORTED_MODULE_5__types__["SET_SALES_REPS"], response.data);
      }
    });
  },
  addDiscountByVolumeToProduct: function addDiscountByVolumeToProduct(_ref28, productIndex) {
    var commit = _ref28.commit;

    commit(__WEBPACK_IMPORTED_MODULE_5__types__["ADD_DISCOUNT_BY_VOLUME_TO_PRODUCT"], productIndex);
  },
  removeDiscountByVolumeToProduct: function removeDiscountByVolumeToProduct(_ref29, _ref30) {
    var commit = _ref29.commit;
    var discountIndex = _ref30.discountIndex,
        productIndex = _ref30.productIndex;

    commit(__WEBPACK_IMPORTED_MODULE_5__types__["REMOVE_DISCOUNT_BY_VOLUME_TO_PRODUCT"], { discountIndex: discountIndex, productIndex: productIndex });
  },
  getBusinessLocation: function getBusinessLocation(_ref31, sid) {
    var commit = _ref31.commit,
        state = _ref31.state;

    return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].getBusinessLocation(sid).then(function (response) {
        if (response.status === 200) {
          commit(__WEBPACK_IMPORTED_MODULE_5__types__["SET_LOCATION"], response.data);
        }
        resolve(response);
      }).catch(function (error) {
        return reject(error);
      });
    });
  },
  getBusinessInfo: function getBusinessInfo(_ref32, sid) {
    var commit = _ref32.commit;

    return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].getBusinessInfo(sid).then(function (response) {
        commit(__WEBPACK_IMPORTED_MODULE_5__types__["SET_INFO"], response.data);
        resolve(response);
      }).catch(function (error) {
        return reject(error);
      });
    });
  },
  getBusinessPromotion: function getBusinessPromotion(_ref33, sid) {
    var commit = _ref33.commit;

    return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].getBusinessPromotion(sid).then(function (response) {
        commit(__WEBPACK_IMPORTED_MODULE_5__types__["SET_PROMOTION"], response.data);
        resolve(response);
      }).catch(function (error) {
        return reject(error);
      });
    });
  },
  getBusinessUsers: function getBusinessUsers(_ref34, sid) {
    var commit = _ref34.commit;

    return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].getBusinessUsers(sid).then(function (response) {
        if (response.status === 200) {
          commit(__WEBPACK_IMPORTED_MODULE_5__types__["SET_USERS"], response.data);
        }
        resolve(response);
      }).catch(function (error) {
        return reject(error);
      });
    });
  },
  getBusinessBilling: function getBusinessBilling(_ref35, sid) {
    var commit = _ref35.commit;

    return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].getBusinessBilling(sid).then(function (response) {
        if (response.status === 200) {
          commit(__WEBPACK_IMPORTED_MODULE_5__types__["SET_BILLING"], response.data);
        }
        resolve(response);
      }).catch(function (error) {
        return reject(error);
      });
    });
  },
  getBusinessDiscounts: function getBusinessDiscounts(_ref36, _ref37) {
    var commit = _ref36.commit,
        state = _ref36.state;
    var type = _ref37.type,
        other = _ref37.other;

    return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].getBusinessDiscounts({ sid: state.business.sid, type: type, other: other }).then(function (response) {
        if (response.status === 200) {
          commit(__WEBPACK_IMPORTED_MODULE_5__types__["SET_DISCOUNTS"], response.data);
        }
        resolve(response);
      }).catch(function (error) {
        return reject(error);
      });
    });
  },
  getBusinessProductAddDiscounts: function getBusinessProductAddDiscounts(_ref38) {
    var commit = _ref38.commit,
        state = _ref38.state;

    return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].getBusinessDiscountsProductAdds({ sid: state.business.sid }).then(function (response) {
        if (response.status === 200) {
          commit(__WEBPACK_IMPORTED_MODULE_5__types__["SET_DISCOUNTS_PRODUCT_ADDS"], response.data);
        }
        resolve(response);
      }).catch(function (error) {
        return reject(error);
      });
    });
  },
  getBusinessNotes: function getBusinessNotes(_ref39, sid) {
    var commit = _ref39.commit;

    return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].getBusinessNotes(sid).then(function (response) {
        if (response.status === 200) {
          commit(__WEBPACK_IMPORTED_MODULE_5__types__["SET_NOTES"], response.data);
        }
        resolve(response);
      }).catch(function (error) {
        return reject(error);
      });
    });
  },
  getDownloadToken: function getDownloadToken(_ref40, fileId) {
    var commit = _ref40.commit;

    return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].getDownloadToken(fileId).then(function (response) {
        resolve(response);
      }).catch(function (error) {
        return reject(error);
      });
    });
  },
  resetPeriodData: function resetPeriodData(_ref41) {
    var commit = _ref41.commit;

    commit(__WEBPACK_IMPORTED_MODULE_5__types__["RESET_PERIOD_DATA"]);
  },
  lookupBusiness: function lookupBusiness(_ref42, search) {
    var commit = _ref42.commit,
        dispatch = _ref42.dispatch;

    return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].lookupBusiness(search).then(function (response) {
        resolve(response);
      }).catch(function (error) {
        return reject(error);
      });
    });
  },
  getRoles: function getRoles(_ref43, type) {
    var commit = _ref43.commit,
        dispatch = _ref43.dispatch;

    return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      if (type === undefined || type === null) {
        type = '1';
      }
      __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].getRoles(type).then(function (response) {
        if (response.status === 200) {
          commit(__WEBPACK_IMPORTED_MODULE_5__types__["SET_ROLES"], response.data);
        }
        resolve(response);
      }).catch(function (error) {
        return reject(error);
      });
    });
  },
  searchBusinesses: function searchBusinesses(_ref44, search) {
    var commit = _ref44.commit,
        dispatch = _ref44.dispatch;

    return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].searchBusinesses(search).then(function (response) {
        if (response.status === 200) {
          commit(__WEBPACK_IMPORTED_MODULE_5__types__["SET_BUSINESSES_FOUND"], response.data);
        }
        resolve(response);
      }).catch(function (error) {
        return reject(error);
      });
    });
  },
  getAllBusinessesForDropdowns: function getAllBusinessesForDropdowns(_ref45) {
    var commit = _ref45.commit;

    return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].getBusinesses({
        params: {
          search: '',
          orderBy: 'name',
          sortBy: 'asc',
          status: '',
          pageSize: 10000,
          offset: 0
        }
      }).then(function (response) {
        console.log('getAllBusinessesForDropdowns response:', response.data);
        console.log('Response data structure:', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(response.data || {}));
        if (response.data && response.data.results) {
          console.log('Sample business item:', response.data.results[0]);
          console.log('Total businesses loaded:', response.data.results.length);
        }

        commit(__WEBPACK_IMPORTED_MODULE_5__types__["SET_ALL_BUSINESSES"], response.data);
        resolve(response.data);
      }).catch(function (error) {
        console.error('Failed to load all businesses for dropdowns:', error);
        reject(error);
      });
    });
  }
});

/***/ }),

/***/ 246:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ({
  searchKey: function searchKey(state) {
    return state.searchKey;
  },
  activeTab: function activeTab(state) {
    return state.activeTab;
  },
  tabs: function tabs(state) {
    return state.tabs;
  },
  activeMappingType: function activeMappingType(state) {
    return state.activeMappingType;
  },

  business: function business(state) {
    return state.business;
  },

  loading: function loading(state) {
    return state.loading;
  },
  businesses: function businesses(state) {
    return state.businesses;
  },
  distributors: function distributors(state) {
    return state.distributors;
  },
  salesReps: function salesReps(state) {
    return state.salesReps;
  },
  vehicleManufacturers: function vehicleManufacturers(state) {
    return state.vehicleManufacturers;
  },
  insuranceCompanies: function insuranceCompanies(state) {
    return state.insuranceCompanies;
  },
  products: function products(state) {
    return state.products;
  },
  roles: function roles(state) {
    return state.roles;
  },
  businessesFound: function businessesFound(state) {
    return state.businessesFound;
  },
  source: function source(state) {
    return state.source;
  },
  allBusinesses: function allBusinesses(state) {
    return state.allBusinesses || { results: [] };
  }
});

/***/ }),

/***/ 247:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__types__ = __webpack_require__(148);



var _types$INIT_BUSINESS_;



/* harmony default export */ __webpack_exports__["default"] = (_types$INIT_BUSINESS_ = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$INIT_BUSINESS_, __WEBPACK_IMPORTED_MODULE_2__types__["INIT_BUSINESS_DATA"], function (state, data) {
  state.business = {
    id: 0,
    shopId: '',
    sid: null,
    statusId: null,
    name: null,
    timezone: null,
    phone: null,
    phoneCC: null,
    billSameAsPrimary: false,
    dispatchPriorityId: null,
    distributorId: null,
    salesRepId: null,
    referralSourceId: null,
    isMobileClient: false,
    isEnterpriseClient: false,
    isAstechClient: false,
    isHunterClient: false,
    isSafeliteClient: false,
    isCorporateAccount: false,
    isCapLinkMember: false,
    isSolera: false,
    soleraSiteIdReference: null,
    isOnyxClient: false,
    onyxClientReference: null,
    useConnect: false,
    capricornNumber: '',
    accountId: null,
    annualRevenueId: null,
    monthlyRoId: null,
    locationCountId: null,
    reportingGroupId: null,
    parentId: null,
    grandparentId: null,
    serialNumber: null,
    source: null,
    externalCustomerId: null,
    manufacturers: [],
    oemCertifications: [],
    insuranceDepartments: [],
    services: [],
    primaryAddress: {
      id: 0,
      street: null,
      city: null,
      state: null,
      postalCode: null,
      country: null,
      language: 1
    },
    billingAddress: {
      id: 0,
      street: null,
      city: null,
      state: null,
      postalCode: null,
      country: null,
      language: 1
    },
    users: [],
    billing: {
      isDemo: false,
      isRecurring: false,
      periodId: null,
      periodAmount: null,
      currencyId: null,
      isCurrencyIdSavedInDatabase: false,
      oemChargeableProducts: []
    },
    promotion: {
      startDate: new Date(),
      endDate: new Date(),
      startProductId: 0,
      endProductId: 0,
      promotionType: 0,
      numberOfScans: 0
    },
    discounts: [],
    notes: []
  };
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$INIT_BUSINESS_, __WEBPACK_IMPORTED_MODULE_2__types__["SET_DISCOUNT_MODAL"], function (state, modal) {
  state.activeMappingType = modal;
  if (modal === null) {
    state.business.discounts = [];
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$INIT_BUSINESS_, __WEBPACK_IMPORTED_MODULE_2__types__["SET_LOADING"], function (state, _ref) {
  var button = _ref.button,
      show = _ref.show;

  state.loading[button] = show;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$INIT_BUSINESS_, __WEBPACK_IMPORTED_MODULE_2__types__["SET_ACTIVE_TAB"], function (state, tab) {
  state.activeTab = tab;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$INIT_BUSINESS_, __WEBPACK_IMPORTED_MODULE_2__types__["SET_BUSINESSES"], function (state, businesses) {
  state.businesses = businesses;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$INIT_BUSINESS_, __WEBPACK_IMPORTED_MODULE_2__types__["SET_BUSINESS_STATUS"], function (state, data) {
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(state.businesses), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var business = _step.value;

      if (business.id === data.id) {
        business.statusId = data.status;
        break;
      }
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$INIT_BUSINESS_, __WEBPACK_IMPORTED_MODULE_2__types__["COPY_BILLING_ADDRESS_FROM_DEFAULT"], function (state, address) {
  state.business.billingAddress = address;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$INIT_BUSINESS_, __WEBPACK_IMPORTED_MODULE_2__types__["SET_BUSINESS_SID"], function (state, sid) {
  state.business.sid = sid;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$INIT_BUSINESS_, __WEBPACK_IMPORTED_MODULE_2__types__["ADD_NEW_USER_TO_LIST"], function (state) {
  state.business.users.push({
    id: 0,
    firstName: null,
    lastName: null,
    hasLogin: false,
    username: null,
    email: null,
    password: null,
    requiresPasswordOnSubmit: false,
    isPrimary: false,
    isEnabled: false,
    isLockout: false,
    isDeleted: false,
    isMahle: false,
    receivesInvoices: false,
    receivesReports: false,
    receivesReportsOnly: false,
    receivesChatReports: false,
    isAstechUser: false,
    titleId: null,
    phone: null,
    phoneCC: null,
    showRAG: false,
    isTechpro: false,
    isTexa: false
  });
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$INIT_BUSINESS_, __WEBPACK_IMPORTED_MODULE_2__types__["SET_NEW_USER_ID"], function (state, _ref2) {
  var user = _ref2.user,
      newId = _ref2.newId;

  var index = state.business.users.findIndex(function (u) {
    return u === user;
  });
  if (state.business.users[index].id === 0) {
    state.business.users[index].id = newId;
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$INIT_BUSINESS_, __WEBPACK_IMPORTED_MODULE_2__types__["ADD_MANUFACTURER"], function (state, manufacturer) {
  state.business.manufacturers.push(manufacturer);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$INIT_BUSINESS_, __WEBPACK_IMPORTED_MODULE_2__types__["REMOVE_MANUFACTURER"], function (state, manufacturer) {
  var index = state.business.manufacturers.findIndex(function (x) {
    return x.id === manufacturer.id;
  });
  state.business.manufacturers.splice(index, 1);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$INIT_BUSINESS_, __WEBPACK_IMPORTED_MODULE_2__types__["UPDATE_MANUFACTURER_PERCENT"], function (state, _ref3) {
  var id = _ref3.id,
      percent = _ref3.percent;
  var _iteratorNormalCompletion2 = true;
  var _didIteratorError2 = false;
  var _iteratorError2 = undefined;

  try {
    for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(state.business.manufacturers), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
      var manufacturer = _step2.value;

      if (manufacturer.id === id) {
        manufacturer.percent = percent;
        break;
      }
    }
  } catch (err) {
    _didIteratorError2 = true;
    _iteratorError2 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion2 && _iterator2.return) {
        _iterator2.return();
      }
    } finally {
      if (_didIteratorError2) {
        throw _iteratorError2;
      }
    }
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$INIT_BUSINESS_, __WEBPACK_IMPORTED_MODULE_2__types__["SET_DISTRIBUTORS"], function (state, distributors) {}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$INIT_BUSINESS_, __WEBPACK_IMPORTED_MODULE_2__types__["SET_SALES_REPS"], function (state, salesReps) {}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$INIT_BUSINESS_, __WEBPACK_IMPORTED_MODULE_2__types__["ADD_DISCOUNT_BY_VOLUME_TO_PRODUCT"], function (state, productIndex) {
  state.business.discounts[productIndex].discountsByVolume.push({
    id: null,
    typeId: null,
    amount: null,
    volumeBreak: null,
    isActive: true
  });
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$INIT_BUSINESS_, __WEBPACK_IMPORTED_MODULE_2__types__["REMOVE_DISCOUNT_BY_VOLUME_TO_PRODUCT"], function (state, _ref4) {
  var discountIndex = _ref4.discountIndex,
      productIndex = _ref4.productIndex;

  state.business.discounts[productIndex].discountsByVolume.splice(discountIndex, 1);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$INIT_BUSINESS_, __WEBPACK_IMPORTED_MODULE_2__types__["SET_LOCATION"], function (state, location) {
  state.business.id = location.id;
  state.business.sid = location.sid;
  state.business.shopId = location.shopId;
  state.business.name = location.name;
  state.business.timezone = location.timezone;
  state.business.phone = location.phone;
  state.business.phoneCC = location.phoneCC;
  state.business.language = location.language;
  state.business.billSameAsPrimary = location.billSameAsPrimary;
  state.business.primaryAddress = location.primaryAddress;

  state.business.billingAddress = state.business.billSameAsPrimary ? location.primaryAddress : location.billingAddress;
  state.business.billingAddress.state = state.business.billSameAsPrimary ? location.primaryAddress.state : location.billingAddress.state;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$INIT_BUSINESS_, __WEBPACK_IMPORTED_MODULE_2__types__["SET_INFO"], function (state, info) {
  if (info) {
    state.business.statusId = info.statusId;
    state.business.annualRevenueId = info.annualRevenueId;
    state.business.dispatchPriorityId = info.dispatchPriorityId;
    state.business.distributorId = info.distributorId;
    state.business.accountId = info.accountId;
    state.business.monthlyRoId = info.monthlyRoId;
    state.business.manufacturers = info.manufacturers || [];
    state.business.services = info.services || [];

    state.business.isCorporateAccount = info.isCorporateAccount;
    state.business.isAstechClient = info.isAstechClient;
    state.business.isMobileClient = info.isMobileClient;
    state.business.isHunterClient = info.isHunterClient;
    state.business.isSafeliteClient = info.isSafeliteClient;
    state.business.isEnterpriseClient = info.isEnterpriseClient;
    state.business.isSolera = info.isSolera;
    state.business.soleraSiteIdReference = info.soleraSiteIdReference;
    state.business.isOnyxClient = info.IsOnyxClient;
    state.business.useConnect = info.useConnect;
    state.business.onyxClientReference = info.OnyxClientReference;
    state.business.isCapLinkMember = info.isCaplinkMember;
    state.business.capricornNumber = info.capricornNumber;
    state.business.salesRepId = info.salesRepId;
    state.business.referralSourceId = info.referralSourceId;
    state.business.locationCountId = info.locationCountId;
    state.business.oemCertifications = info.oemCertifications || [];
    state.business.insuranceDepartments = info.insuranceDepartments || [];

    state.business.billing.currencyId = info.billing.currencyId;
    state.business.billing.isDemo = info.billing.isDemo;
    state.business.billing.isRecurring = info.billing.isRecurring === null ? false : info.billing.isRecurring;
    state.business.billing.periodAmount = info.billing.periodAmount;
    state.business.billing.periodId = info.billing.periodId;

    state.business.reportingGroupId = info.reportingGroupId;
    state.business.parentId = info.ParentId;
    state.business.grandparentId = info.GrandparentId;
    state.business.serialNumber = info.SerialNumber;
    state.business.source = info.Source;
    state.business.externalCustomerId = info.ExternalCustomerId;
  } else {
    state.business.annualRevenueId = null;
    state.business.dispatchPriorityId = null;
    state.business.distributorId = null;
    state.business.accountId = null;
    state.business.monthlyRoId = null;
    state.business.manufacturers = [];
    state.business.services = [];

    state.business.isAstechClient = false;
    state.business.isMobileClient = false;
    state.business.isEnterpriseClient = false;
    state.business.isHunterClient = false;
    state.business.isSafeliteClient = false;
    state.business.isSolera = false;
    state.business.soleraSiteIdReference = null;
    state.business.salesRepId = null;
    state.business.referralSourceId = null;
    state.business.locationCountId = null;
    state.business.isCapLinkMember = false;
    state.business.capricornNumber = null;
    state.business.isOnyxClient = false;
    state.business.onyxClientReference = null;
    state.business.useConnect = false;
    state.business.oemCertifications = [];
    state.business.insuranceDepartments = [];

    state.business.billing.currencyId = null;
    state.business.billing.isDemo = false;
    state.business.billing.isRecurring = false;
    state.business.billing.periodAmount = null;
    state.business.billing.periodId = null;

    state.business.reportingGroupId = null;
    state.business.parentId = null;
    state.business.grandparentId = null;
    state.business.serialNumber = null;
    state.business.source = null;
    state.business.externalCustomerId = null;
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$INIT_BUSINESS_, __WEBPACK_IMPORTED_MODULE_2__types__["SET_USERS"], function (state, users) {
  state.business.users = users || [];
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$INIT_BUSINESS_, __WEBPACK_IMPORTED_MODULE_2__types__["SET_BILLING"], function (state, billing) {
  state.business.billing = billing;
  state.business.billing.oemChargeableProducts = billing.oemChargeableProducts || [];
  state.business.billing.isCurrencyIdSavedInDatabase = billing.currencyId > 0;
  state.business.billing.initialCurrencyId = billing.currencyId;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$INIT_BUSINESS_, __WEBPACK_IMPORTED_MODULE_2__types__["SET_PROMOTION"], function (state, promotion) {
  if (promotion) {
    state.business.promotion = promotion;
    var date = new Date(promotion.startDate);
    var dateStart = '' + date.getFullYear() + '-' + (date.getMonth() + 1 > 9 ? '' : '0') + (date.getMonth() + 1) + '-' + (date.getDate() > 9 ? '' : '0') + date.getDate();
    date = new Date(promotion.endDate);
    state.business.promotion.startDate = dateStart;
    var dateEnd = '' + date.getFullYear() + '-' + (date.getMonth() + 1 > 9 ? '' : '0') + (date.getMonth() + 1) + '-' + (date.getDate() > 9 ? '' : '0') + date.getDate();
    state.business.promotion.endDate = dateEnd;
    console.log(dateStart);
  } else {
    var defaultDate = new Date();

    var dateformat = '' + defaultDate.getFullYear() + '-' + (defaultDate.getMonth() + 1 > 9 ? '' : '0') + (defaultDate.getMonth() + 1) + '-' + (defaultDate.getDate() > 9 ? '' : '0') + defaultDate.getDate();
    state.business.promotion.endDate = dateformat;
    state.business.promotion.startDate = dateformat;
    state.business.promotion.startProductId = 0;
    state.business.promotion.endProductId = 0;
    state.business.promotion.promotionType = 0;
    state.business.promotion.numberOfScans = 0;
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$INIT_BUSINESS_, __WEBPACK_IMPORTED_MODULE_2__types__["SET_DISCOUNTS"], function (state, discounts) {
  state.business.discounts = discounts;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$INIT_BUSINESS_, __WEBPACK_IMPORTED_MODULE_2__types__["SET_DISCOUNTS_PRODUCT_ADDS"], function (state, discounts) {
  state.business.discountsProductAdds = discounts;
  state.business.discountsProductAdds.forEach(function (element) {
    element.isChanged = false;
  });
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$INIT_BUSINESS_, __WEBPACK_IMPORTED_MODULE_2__types__["SET_NOTES"], function (state, notes) {
  state.business.notes = notes;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$INIT_BUSINESS_, __WEBPACK_IMPORTED_MODULE_2__types__["ADD_NOTE_TO_LIST"], function (state, note) {
  state.business.notes.unshift(note);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$INIT_BUSINESS_, __WEBPACK_IMPORTED_MODULE_2__types__["RESET_PERIOD_DATA"], function (state) {
  state.business.billing.periodId = null;
  state.business.billing.periodAmount = null;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$INIT_BUSINESS_, __WEBPACK_IMPORTED_MODULE_2__types__["SET_ROLES"], function (state, roles) {
  state.roles = roles;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$INIT_BUSINESS_, __WEBPACK_IMPORTED_MODULE_2__types__["SET_BUSINESSES_FOUND"], function (state, found) {
  state.businessesFound = found;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$INIT_BUSINESS_, __WEBPACK_IMPORTED_MODULE_2__types__["SET_SOURCE"], function (state, source) {
  state.source = source;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$INIT_BUSINESS_, __WEBPACK_IMPORTED_MODULE_2__types__["SET_ALL_BUSINESSES"], function (state, businesses) {
  state.allBusinesses = businesses;
}), _types$INIT_BUSINESS_);

/***/ }),

/***/ 248:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

/* harmony default export */ __webpack_exports__["default"] = ({
  searchKey: { value: '' },
  activeTab: 'Location',
  tabs: ['Location', 'Biz Info', 'User List', 'Billing', 'Promotion', 'Devices', 'Notes', 'Requests'],
  activeMappingType: null,
  loading: {
    upsertBusiness: false,
    upsertBusinessUser: false,
    upsertBusinessBilling: false,
    upsertBusinessNote: false,
    upsertBusinessInfo: false,
    upsertBusinessPromotion: false,
    swapShop: false
  },

  business: {},
  businesses: [],
  products: [],
  roles: [],
  businessesFound: [],
  source: null,
  allBusinesses: { results: [] }
});

/***/ }),

/***/ 249:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api__ = __webpack_require__(11);





/* harmony default export */ __webpack_exports__["default"] = ({
  cancelNewRecommendation: function cancelNewRecommendation(_ref) {
    var commit = _ref.commit;

    commit('CANCEL_NEWRECOMMENDATION');
  },
  setRecommendationActivation: function setRecommendationActivation(_ref2, data) {
    var commit = _ref2.commit;

    commit('SET_RECOMMENDATIONACTIVATION', data);
  },
  addRecommendation: function addRecommendation(_ref3, data) {
    var commit = _ref3.commit,
        state = _ref3.state;

    commit('ADD_RECOMMENDATION', data);
  },
  setRecommendation: function setRecommendation(_ref4, data) {
    var commit = _ref4.commit,
        state = _ref4.state;

    commit('SET_RECOMMENDATION', data);
  },
  getCalibrationRecommendation: function getCalibrationRecommendation(_ref5, id) {
    var _this = this;

    var commit = _ref5.commit,
        state = _ref5.state;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].getCalibrationRecommendation(id).then(function (response) {
                  commit('SET_RECOMMENDATION', response.data);
                  resolve(response);
                });
              }));

            case 1:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  getCalibrationRecommendations: function getCalibrationRecommendations(_ref6, make) {
    var _this2 = this;

    var commit = _ref6.commit,
        state = _ref6.state;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              return _context2.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].getCalibrationRecommendations(make).then(function (response) {
                  commit('SET_RECOMMENDATIONS', response.data);
                  resolve(response);
                });
              }));

            case 1:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }))();
  },
  saveCalibrationRecommendations: function saveCalibrationRecommendations(_ref7, data) {
    var _this3 = this;

    var commit = _ref7.commit,
        dispatch = _ref7.dispatch;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              return _context3.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].saveCalibrationRecommendations(data).then(function (response) {
                  resolve(response);
                });
              }));

            case 1:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this3);
    }))();
  },
  deleteCalibrationRecommendation: function deleteCalibrationRecommendation(_ref8, id) {
    var _this4 = this;

    var commit = _ref8.commit,
        state = _ref8.state;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              return _context4.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].deleteCalibrationRecommendation(id).then(function (response) {
                  resolve(response);
                });
              }));

            case 1:
            case 'end':
              return _context4.stop();
          }
        }
      }, _callee4, _this4);
    }))();
  }
});

/***/ }),

/***/ 250:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ({
  recommendations: function recommendations(state) {
    return state.recommendations;
  },
  recommendation: function recommendation(state) {
    return state.recommendation;
  }
});

/***/ }),

/***/ 251:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__types__ = __webpack_require__(253);



var _types$CANCEL_NEWRECO;


/* harmony default export */ __webpack_exports__["default"] = (_types$CANCEL_NEWRECO = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$CANCEL_NEWRECO, __WEBPACK_IMPORTED_MODULE_2__types__["CANCEL_NEWRECOMMENDATION"], function (state) {
  state.recommendations = state.recommendations.filter(function (item) {
    return item.id !== 0;
  });
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$CANCEL_NEWRECO, __WEBPACK_IMPORTED_MODULE_2__types__["SET_RECOMMENDATIONACTIVATION"], function (state, data) {
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(state.recommendations), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var item = _step.value;

      if (item.id === data.id) {
        item.isChanged = true;
        break;
      }
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$CANCEL_NEWRECO, __WEBPACK_IMPORTED_MODULE_2__types__["ADD_RECOMMENDATION"], function (state, recommendation) {
  var cnt = 0;
  var _iteratorNormalCompletion2 = true;
  var _didIteratorError2 = false;
  var _iteratorError2 = undefined;

  try {
    for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(state.recommendations), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
      var item = _step2.value;

      if (item.id === 0) {
        cnt++;
      }
    }
  } catch (err) {
    _didIteratorError2 = true;
    _iteratorError2 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion2 && _iterator2.return) {
        _iterator2.return();
      }
    } finally {
      if (_didIteratorError2) {
        throw _iteratorError2;
      }
    }
  }

  if (cnt === 0) {
    state.recommendations.unshift(recommendation);
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$CANCEL_NEWRECO, __WEBPACK_IMPORTED_MODULE_2__types__["SET_RECOMMENDATIONS"], function (state, data) {
  state.recommendations = [];
  if (data !== undefined && data !== null) {
    if (data !== '') {
      state.recommendations = data;
      var _iteratorNormalCompletion3 = true;
      var _didIteratorError3 = false;
      var _iteratorError3 = undefined;

      try {
        for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(state.recommendations), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
          var item = _step3.value;

          item.isChanged = false;
        }
      } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion3 && _iterator3.return) {
            _iterator3.return();
          }
        } finally {
          if (_didIteratorError3) {
            throw _iteratorError3;
          }
        }
      }
    }
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$CANCEL_NEWRECO, __WEBPACK_IMPORTED_MODULE_2__types__["SET_RECOMMENDATION"], function (state, data) {
  var _iteratorNormalCompletion4 = true;
  var _didIteratorError4 = false;
  var _iteratorError4 = undefined;

  try {
    for (var _iterator4 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(state.recommendations), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
      var item = _step4.value;

      if (item.id === data.id) {
        switch (data.name) {
          case 'IsInactive':
            item.isInactive = data.value;
            break;
          case 'Nickname':
            item.nickname = data.value;
            break;
          case 'VehicleMake':
            item.vehicleMake = data.value;
            break;
          case 'VehicleMakeName':
            item.vehicleMakeName = parseInt(data.value);
            break;
          case 'Recommendation':
            item.recommendation = data.value;
            break;
        }
        item.isChanged = true;
      }
    }
  } catch (err) {
    _didIteratorError4 = true;
    _iteratorError4 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion4 && _iterator4.return) {
        _iterator4.return();
      }
    } finally {
      if (_didIteratorError4) {
        throw _iteratorError4;
      }
    }
  }
}), _types$CANCEL_NEWRECO);

/***/ }),

/***/ 252:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = (function () {
  return {
    recommendations: [],
    recommendation: null
  };
});

/***/ }),

/***/ 253:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_RECOMMENDATION", function() { return SET_RECOMMENDATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_RECOMMENDATIONS", function() { return SET_RECOMMENDATIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ADD_RECOMMENDATION", function() { return ADD_RECOMMENDATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CANCEL_NEWRECOMMENDATION", function() { return CANCEL_NEWRECOMMENDATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_RECOMMENDATIONACTIVATION", function() { return SET_RECOMMENDATIONACTIVATION; });
var SET_RECOMMENDATION = 'SET_RECOMMENDATION';
var SET_RECOMMENDATIONS = 'SET_RECOMMENDATIONS';
var ADD_RECOMMENDATION = 'ADD_RECOMMENDATION';
var CANCEL_NEWRECOMMENDATION = 'CANCEL_NEWRECOMMENDATION';
var SET_RECOMMENDATIONACTIVATION = 'SET_RECOMMENDATIONACTIVATION';

/***/ }),

/***/ 254:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__types__ = __webpack_require__(118);






/* harmony default export */ __webpack_exports__["default"] = ({
  initSendBird: function initSendBird(_ref, apiId) {
    var commit = _ref.commit;

    commit(__WEBPACK_IMPORTED_MODULE_4__types__["INIT_SENDBIRD"], apiId);
  },
  setSearchTerm: function setSearchTerm(_ref2, search) {
    var commit = _ref2.commit;

    if (search.for === 'user') {
      commit(__WEBPACK_IMPORTED_MODULE_4__types__["SET_SEARCH_TERM_USER"], search.text);
    } else {
      commit(__WEBPACK_IMPORTED_MODULE_4__types__["SET_SEARCH_TERM"], search.text);
    }
  },
  setPageSize: function setPageSize(_ref3, page) {
    var commit = _ref3.commit;

    if (page.for === 'user') {
      commit(__WEBPACK_IMPORTED_MODULE_4__types__["SET_PAGE_SIZE_USER"], page.size);
    } else {
      commit(__WEBPACK_IMPORTED_MODULE_4__types__["SET_PAGE_SIZE"], page.size);
    }
  },
  resetChannels: function resetChannels(_ref4) {
    var commit = _ref4.commit;

    commit(__WEBPACK_IMPORTED_MODULE_4__types__["RESET_CHANNELS"]);
  },
  getChannels: function getChannels(_ref5, searchOptions) {
    var _this = this;

    var commit = _ref5.commit;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].getChannels(searchOptions).then(function (response) {
                  commit(__WEBPACK_IMPORTED_MODULE_4__types__["SET_CHANNELS"], response.data);
                  resolve(response);
                });
              }));

            case 1:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  setChannelChecked: function setChannelChecked(_ref6, data) {
    var commit = _ref6.commit;

    commit(__WEBPACK_IMPORTED_MODULE_4__types__["SET_CHANNEL_CHECKED"], data);
  },
  resetUsers: function resetUsers(_ref7) {
    var commit = _ref7.commit;

    commit(__WEBPACK_IMPORTED_MODULE_4__types__["RESET_USERS"]);
  },
  getUsers: function getUsers(_ref8, searchOptions) {
    var _this2 = this;

    var commit = _ref8.commit;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              return _context2.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].getChatUsers(searchOptions).then(function (response) {
                  commit(__WEBPACK_IMPORTED_MODULE_4__types__["SET_USERS"], response.data);
                  resolve(response);
                });
              }));

            case 1:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }))();
  },
  setUserChecked: function setUserChecked(_ref9, data) {
    var commit = _ref9.commit;

    commit(__WEBPACK_IMPORTED_MODULE_4__types__["SET_USER_CHECKED"], data);
  },
  getUserChannels: function getUserChannels(_ref10, options) {
    var commit = _ref10.commit;

    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].getChatUserChannels(options).then(function (response) {
        commit(__WEBPACK_IMPORTED_MODULE_4__types__["SET_CHANNELS"], response.data);
        resolve(response);
      });
    });
  },
  setMessageChecked: function setMessageChecked(_ref11, data) {
    var commit = _ref11.commit;

    commit(__WEBPACK_IMPORTED_MODULE_4__types__["SET_MESSAGE_CHECKED"], data);
  },
  resetMessageList: function resetMessageList(_ref12) {
    var commit = _ref12.commit;

    commit(__WEBPACK_IMPORTED_MODULE_4__types__["RESET_MESSAGES"]);
  },
  addMessageToList: function addMessageToList(_ref13, message, hasmore) {
    var commit = _ref13.commit;

    commit(__WEBPACK_IMPORTED_MODULE_4__types__["ADD_MESSAGE"], message, hasmore);
  },
  setTyping: function setTyping(_ref14, channel) {
    var commit = _ref14.commit;

    commit(__WEBPACK_IMPORTED_MODULE_4__types__["SET_TYPING"], channel);
  },
  removeChannels: function removeChannels(_ref15, data) {
    var commit = _ref15.commit;

    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].removeChannels(data).then(function (response) {
        resolve(response);
      });
    });
  },
  removeUsers: function removeUsers(_ref16, data) {
    var commit = _ref16.commit;

    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].removeUsers(data).then(function (response) {
        resolve(response);
      });
    });
  },
  saveMessage: function saveMessage(_ref17, data) {
    var commit = _ref17.commit;

    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].saveMessage(data).then(function (response) {
        resolve(response);
      });
    });
  },
  saveTranslatedMessage: function saveTranslatedMessage(_ref18, data) {
    var commit = _ref18.commit;

    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].saveTranslatedMessage(data).then(function (response) {
        resolve(response);
      });
    });
  },
  updateChannelMessageCount: function updateChannelMessageCount(_ref19, data) {
    var commit = _ref19.commit;

    commit(__WEBPACK_IMPORTED_MODULE_4__types__["SET_CHANNEL_MESSAGE_COUNT"], data);
  },
  getChatHistory: function getChatHistory(_ref20, id) {
    var commit = _ref20.commit;

    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].getChatHistory(id).then(function (response) {
        commit(__WEBPACK_IMPORTED_MODULE_4__types__["SET_MESSAGES"], response.data);
        resolve(response);
      });
    });
  },
  resetRequests: function resetRequests(_ref21) {
    var commit = _ref21.commit;

    commit(__WEBPACK_IMPORTED_MODULE_4__types__["RESET_REQUESTS"]);
  },
  getServiceRequestsWithMessages: function getServiceRequestsWithMessages(_ref22, search) {
    var commit = _ref22.commit;

    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].getServiceRequestsWithMessages(search).then(function (response) {
        commit(__WEBPACK_IMPORTED_MODULE_4__types__["SET_REQUESTS"], response.data);
        resolve(response);
      });
    });
  },
  saveChatMessages: function saveChatMessages(_ref23, data) {
    var commit = _ref23.commit;

    commit(__WEBPACK_IMPORTED_MODULE_4__types__["RESET_CHANNELS"]);
    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].saveChatMessages(data).then(function (response) {
        resolve(response);
      });
    });
  }
});

/***/ }),

/***/ 255:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ({
  channels: function channels(state) {
    return state.channels;
  },
  users: function users(state) {
    return state.users;
  },
  userChannels: function userChannels(state) {
    return state.userChannels;
  },
  messages: function messages(state) {
    return state.messages;
  },
  isTyping: function isTyping(state) {
    return state.isTyping;
  },
  pageSize: function pageSize(state) {
    return state.pageSize;
  },
  searchTerm: function searchTerm(state) {
    return state.searchTerm;
  },
  token: function token(state) {
    return state.token;
  },
  pageSizeUser: function pageSizeUser(state) {
    return state.pageSizeUser;
  },
  searchTermUser: function searchTermUser(state) {
    return state.searchTermUser;
  },
  tokenUser: function tokenUser(state) {
    return state.tokenUser;
  },
  isChannelChecked: function isChannelChecked(state) {
    return state.isChannelChecked;
  },
  isChannelNotSaved: function isChannelNotSaved(state) {
    return state.isChannelNotSaved;
  },
  isUserChecked: function isUserChecked(state) {
    return state.isUserChecked;
  },
  requests: function requests(state) {
    return state.requests;
  }
});

/***/ }),

/***/ 256:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__types__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_sendbird__ = __webpack_require__(559);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_sendbird___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_sendbird__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__sendbird_js__ = __webpack_require__(228);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store__ = __webpack_require__(94);



var _types$INIT_SENDBIRD$;






/* harmony default export */ __webpack_exports__["default"] = (_types$INIT_SENDBIRD$ = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$INIT_SENDBIRD$, __WEBPACK_IMPORTED_MODULE_2__types__["INIT_SENDBIRD"], function (state, apiId) {
  __WEBPACK_IMPORTED_MODULE_4__sendbird_js__["default"].sendbird = new __WEBPACK_IMPORTED_MODULE_3_sendbird___default.a({
    appId: apiId
  });
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$INIT_SENDBIRD$, __WEBPACK_IMPORTED_MODULE_2__types__["SET_SEARCH_TERM"], function (state, text) {
  state.searchTerm = text;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$INIT_SENDBIRD$, __WEBPACK_IMPORTED_MODULE_2__types__["SET_PAGE_SIZE"], function (state, pageSize) {
  state.pageSize = pageSize;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$INIT_SENDBIRD$, __WEBPACK_IMPORTED_MODULE_2__types__["SET_SEARCH_TERM_USER"], function (state, text) {
  state.searchTermUser = text;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$INIT_SENDBIRD$, __WEBPACK_IMPORTED_MODULE_2__types__["SET_PAGE_SIZE_USER"], function (state, pageSize) {
  state.pageSizeUser = pageSize;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$INIT_SENDBIRD$, __WEBPACK_IMPORTED_MODULE_2__types__["RESET_CHANNELS"], function (state) {
  state.channels = [];
  state.token = '';
  state.searchTerm = '';
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$INIT_SENDBIRD$, __WEBPACK_IMPORTED_MODULE_2__types__["SET_CHANNELS"], function (state, data) {
  if (data !== undefined && data !== null) {
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(data.channels), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var channel = _step.value;

        channel.isChecked = false;
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }

    state.channels = state.channels.concat(data.channels);
    state.token = data.next;
  }
  state.isChannelChecked = false;
  state.isChannelNotSaved = false;
  var anyChecked = false;
  var anyNotSaved = false;
  var _iteratorNormalCompletion2 = true;
  var _didIteratorError2 = false;
  var _iteratorError2 = undefined;

  try {
    for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(state.channels), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
      var _channel = _step2.value;

      if (_channel.isChecked) {
        anyChecked = true;
        if ((_channel.status.includes('Completed') || _channel.status === 'Cancelled' || _channel.status === 'Voided RO') && parseInt(_channel.chatMessageCount) === 0) {
          anyNotSaved = true;
        }
      }
    }
  } catch (err) {
    _didIteratorError2 = true;
    _iteratorError2 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion2 && _iterator2.return) {
        _iterator2.return();
      }
    } finally {
      if (_didIteratorError2) {
        throw _iteratorError2;
      }
    }
  }

  state.isChannelNotSaved = anyNotSaved;
  state.isChannelChecked = anyChecked;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$INIT_SENDBIRD$, __WEBPACK_IMPORTED_MODULE_2__types__["SET_CHANNEL_MESSAGE_COUNT"], function (state, data) {
  var _iteratorNormalCompletion3 = true;
  var _didIteratorError3 = false;
  var _iteratorError3 = undefined;

  try {
    for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(state.channels), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
      var channel = _step3.value;

      if (channel.name === data.channel) {
        if (channel.chatMessageCount > 0) {
          channel.chatMessageCount += data.count;
        } else {
          channel.chatMessageCount = data.count;
        }
        break;
      }
    }
  } catch (err) {
    _didIteratorError3 = true;
    _iteratorError3 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion3 && _iterator3.return) {
        _iterator3.return();
      }
    } finally {
      if (_didIteratorError3) {
        throw _iteratorError3;
      }
    }
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$INIT_SENDBIRD$, __WEBPACK_IMPORTED_MODULE_2__types__["SET_CHANNEL_CHECKED"], function (state, data) {
  state.isChannelChecked = false;
  state.isChannelNotSaved = false;
  var _iteratorNormalCompletion4 = true;
  var _didIteratorError4 = false;
  var _iteratorError4 = undefined;

  try {
    for (var _iterator4 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(state.channels), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
      var channel = _step4.value;

      if (channel.name === data.name) {
        channel.isChecked = data.isChecked;
        break;
      }
    }
  } catch (err) {
    _didIteratorError4 = true;
    _iteratorError4 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion4 && _iterator4.return) {
        _iterator4.return();
      }
    } finally {
      if (_didIteratorError4) {
        throw _iteratorError4;
      }
    }
  }

  var anyChecked = false;
  var anyNotSaved = false;
  var _iteratorNormalCompletion5 = true;
  var _didIteratorError5 = false;
  var _iteratorError5 = undefined;

  try {
    for (var _iterator5 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(state.channels), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
      var _channel2 = _step5.value;

      if (_channel2.isChecked) {
        anyChecked = true;
        if ((_channel2.status.includes('Completed') || _channel2.status === 'Cancelled' || _channel2.status === 'Voided RO') && parseInt(_channel2.chatMessageCount) === 0) {
          anyNotSaved = true;
        }
      }
    }
  } catch (err) {
    _didIteratorError5 = true;
    _iteratorError5 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion5 && _iterator5.return) {
        _iterator5.return();
      }
    } finally {
      if (_didIteratorError5) {
        throw _iteratorError5;
      }
    }
  }

  state.isChannelNotSaved = anyNotSaved;
  state.isChannelChecked = anyChecked;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$INIT_SENDBIRD$, __WEBPACK_IMPORTED_MODULE_2__types__["RESET_USERS"], function (state) {
  state.users = [];
  state.tokenUser = '';
  state.searchTermUser = '';
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$INIT_SENDBIRD$, __WEBPACK_IMPORTED_MODULE_2__types__["SET_USERS"], function (state, data) {
  if (data !== undefined && data !== null) {
    var _iteratorNormalCompletion6 = true;
    var _didIteratorError6 = false;
    var _iteratorError6 = undefined;

    try {
      for (var _iterator6 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(data.users), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
        var user = _step6.value;

        user.isChecked = false;
      }
    } catch (err) {
      _didIteratorError6 = true;
      _iteratorError6 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion6 && _iterator6.return) {
          _iterator6.return();
        }
      } finally {
        if (_didIteratorError6) {
          throw _iteratorError6;
        }
      }
    }

    state.users = state.users.concat(data.users);
    state.tokenUser = data.next;
    state.isUserChecked = false;
    var anyChecked = false;
    var _iteratorNormalCompletion7 = true;
    var _didIteratorError7 = false;
    var _iteratorError7 = undefined;

    try {
      for (var _iterator7 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(state.users), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
        var _user = _step7.value;

        if (_user.isChecked) {
          anyChecked = true;
          break;
        }
      }
    } catch (err) {
      _didIteratorError7 = true;
      _iteratorError7 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion7 && _iterator7.return) {
          _iterator7.return();
        }
      } finally {
        if (_didIteratorError7) {
          throw _iteratorError7;
        }
      }
    }

    state.isUserChecked = anyChecked;
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$INIT_SENDBIRD$, __WEBPACK_IMPORTED_MODULE_2__types__["SET_USER_CHECKED"], function (state, data) {
  state.isUserChecked = false;
  var _iteratorNormalCompletion8 = true;
  var _didIteratorError8 = false;
  var _iteratorError8 = undefined;

  try {
    for (var _iterator8 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(state.users), _step8; !(_iteratorNormalCompletion8 = (_step8 = _iterator8.next()).done); _iteratorNormalCompletion8 = true) {
      var user = _step8.value;

      if (user.user_id === data.userId) {
        user.isChecked = data.isChecked;
        break;
      }
    }
  } catch (err) {
    _didIteratorError8 = true;
    _iteratorError8 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion8 && _iterator8.return) {
        _iterator8.return();
      }
    } finally {
      if (_didIteratorError8) {
        throw _iteratorError8;
      }
    }
  }

  var anyChecked = false;
  var _iteratorNormalCompletion9 = true;
  var _didIteratorError9 = false;
  var _iteratorError9 = undefined;

  try {
    for (var _iterator9 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(state.users), _step9; !(_iteratorNormalCompletion9 = (_step9 = _iterator9.next()).done); _iteratorNormalCompletion9 = true) {
      var _user2 = _step9.value;

      if (_user2.isChecked) {
        anyChecked = true;
        break;
      }
    }
  } catch (err) {
    _didIteratorError9 = true;
    _iteratorError9 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion9 && _iterator9.return) {
        _iterator9.return();
      }
    } finally {
      if (_didIteratorError9) {
        throw _iteratorError9;
      }
    }
  }

  state.isUserChecked = anyChecked;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$INIT_SENDBIRD$, __WEBPACK_IMPORTED_MODULE_2__types__["RESET_MESSAGES"], function (state) {
  state.messages = [];
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$INIT_SENDBIRD$, __WEBPACK_IMPORTED_MODULE_2__types__["SET_MESSAGE_CHECKED"], function (state, data) {
  console.log('Set Message Checked');
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$INIT_SENDBIRD$, __WEBPACK_IMPORTED_MODULE_2__types__["ADD_MESSAGE"], function (state, message) {
  var userProfile = __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].getters['authorize/userProfile'];
  var language = __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].getters['authorize/language'];
  var type = 'received';
  var name = message._sender.nickname;
  if (userProfile.email === message._sender.userId) {
    type = 'sent';
    name = 'me';
  }
  var messageText = message.message;
  if (message.translations[language] !== undefined && message.translations[language] !== null) {
    messageText = message.translations[language];
  }
  var data = {
    name: name,
    type: type,
    text: messageText,
    avatar: '',
    createdAt: message.createdAt,
    email: message._sender.userId,
    messageId: message.messageId
  };
  state.messages.push(data);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$INIT_SENDBIRD$, __WEBPACK_IMPORTED_MODULE_2__types__["SET_TYPING"], function (state, channel) {
  state.isTyping = channel.isTyping();
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$INIT_SENDBIRD$, __WEBPACK_IMPORTED_MODULE_2__types__["SET_MESSAGES"], function (state, data) {}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$INIT_SENDBIRD$, __WEBPACK_IMPORTED_MODULE_2__types__["RESET_REQUESTS"], function (state) {
  state.requests = [];
  state.token = '';
  state.searchTerm = '';
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$INIT_SENDBIRD$, __WEBPACK_IMPORTED_MODULE_2__types__["SET_REQUESTS"], function (state, data) {
  state.requests = data;
}), _types$INIT_SENDBIRD$);

/***/ }),

/***/ 257:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = (function () {
  return {
    channels: [],
    users: [],
    userChannels: [],
    messages: [],
    isTyping: false,
    pageSize: 20,
    searchTerm: '',
    token: '',
    pageSizeUser: 20,
    searchTermUser: '',
    tokenUser: '',
    isChannelChecked: false,
    isChannelNotSaved: false,
    isUserChecked: false,
    requests: []
  };
});

/***/ }),

/***/ 258:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CONFIGURATION", function() { return CONFIGURATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_CONFIGURATION", function() { return SET_CONFIGURATION; });
var CONFIGURATION = 'CONFIGURATION';
var SET_CONFIGURATION = 'SET_CONFIGURATION';

/***/ }),

/***/ 259:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api__ = __webpack_require__(11);




/* harmony default export */ __webpack_exports__["default"] = ({
  getContext: function getContext(_ref) {
    var _this = this;

    var commit = _ref.commit,
        state = _ref.state;
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var response;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              commit('SET_LOADING', true);
              commit('SET_ERROR', null);

              _context.prev = 2;
              _context.next = 5;
              return __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].getContext();

            case 5:
              response = _context.sent;

              commit('SET_CONTEXT', response.data);
              _context.next = 13;
              break;

            case 9:
              _context.prev = 9;
              _context.t0 = _context['catch'](2);

              commit('SET_ERROR', 'Error loading connected devices context.');
              throw _context.t0;

            case 13:
              _context.prev = 13;

              commit('SET_LOADING', false);
              return _context.finish(13);

            case 16:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this, [[2, 9, 13, 16]]);
    }))();
  },
  saveConnectedDevices: function saveConnectedDevices(_ref2, _ref3) {
    var _this2 = this;

    var commit = _ref2.commit;
    var manufacturerDeviceId = _ref3.manufacturerDeviceId,
        deviceIds = _ref3.deviceIds;
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              commit('SET_LOADING', true);
              commit('SET_ERROR', null);

              _context2.prev = 2;
              _context2.next = 5;
              return __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].saveConnectedDevices(manufacturerDeviceId, deviceIds);

            case 5:
              _context2.next = 11;
              break;

            case 7:
              _context2.prev = 7;
              _context2.t0 = _context2['catch'](2);

              commit('SET_ERROR', 'Error saving connected devices.');
              throw _context2.t0;

            case 11:
              _context2.prev = 11;

              commit('SET_LOADING', false);
              return _context2.finish(11);

            case 14:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2, [[2, 7, 11, 14]]);
    }))();
  },
  upsertManufacturerDevice: function upsertManufacturerDevice(_ref4, manufacturerDevice) {
    var _this3 = this;

    var dispatch = _ref4.dispatch;
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].upsertManufacturerDevice(manufacturerDevice);

            case 2:
              _context3.next = 4;
              return dispatch('getContext');

            case 4:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this3);
    }))();
  },
  removeManufacturerDevice: function removeManufacturerDevice(_ref5, manufacturerDeviceId) {
    var _this4 = this;

    var dispatch = _ref5.dispatch;
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].removeManufacturerDevice(manufacturerDeviceId);

            case 2:
              _context4.next = 4;
              return dispatch('getContext');

            case 4:
            case 'end':
              return _context4.stop();
          }
        }
      }, _callee4, _this4);
    }))();
  }
});

/***/ }),

/***/ 260:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ({
  manufacturerDevices: function manufacturerDevices(state) {
    return state.manufacturerDevices;
  },
  connectedDevices: function connectedDevices(state) {
    return state.connectedDevices;
  },
  isLoading: function isLoading(state) {
    return state.loading;
  },
  contextError: function contextError(state) {
    return state.error;
  }
});

/***/ }),

/***/ 261:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__types__ = __webpack_require__(263);


var _types$SET_LOADING$ty;



/* harmony default export */ __webpack_exports__["default"] = (_types$SET_LOADING$ty = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$SET_LOADING$ty, __WEBPACK_IMPORTED_MODULE_1__types__["SET_LOADING"], function (state, isLoading) {
  state.loading = isLoading;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$SET_LOADING$ty, __WEBPACK_IMPORTED_MODULE_1__types__["SET_ERROR"], function (state, error) {
  state.error = error;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$SET_LOADING$ty, __WEBPACK_IMPORTED_MODULE_1__types__["SET_CONTEXT"], function (state, payload) {
  var md = payload.manufacturerDevices || payload.ManufacturerDevices || [];
  var cd = payload.connectedDevices || payload.ConnectedDevices || [];

  state.manufacturerDevices = md;
  state.connectedDevices = cd;
}), _types$SET_LOADING$ty);

/***/ }),

/***/ 262:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ({
  manufacturerDevices: [],
  connectedDevices: [],
  loading: false,
  error: null
});

/***/ }),

/***/ 263:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_CONTEXT", function() { return SET_CONTEXT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_LOADING", function() { return SET_LOADING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_ERROR", function() { return SET_ERROR; });
var SET_CONTEXT = 'SET_CONTEXT';
var SET_LOADING = 'SET_LOADING';
var SET_ERROR = 'SET_ERROR';

/***/ }),

/***/ 264:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__types__ = __webpack_require__(149);






/* harmony default export */ __webpack_exports__["default"] = ({
  setSearchTerm: function setSearchTerm(_ref, text) {
    var commit = _ref.commit;

    commit(__WEBPACK_IMPORTED_MODULE_4__types__["SET_SEARCH_TERM"], text);
  },
  setPageSize: function setPageSize(_ref2, pageSize) {
    var commit = _ref2.commit;

    commit(__WEBPACK_IMPORTED_MODULE_4__types__["SET_PAGE_SIZE"], pageSize);
  },
  setSortDir: function setSortDir(_ref3, sortDir) {
    var commit = _ref3.commit;

    commit(__WEBPACK_IMPORTED_MODULE_4__types__["SET_SORT_DIR"], sortDir);
  },
  setOrderBy: function setOrderBy(_ref4, orderBy) {
    var commit = _ref4.commit;

    commit(__WEBPACK_IMPORTED_MODULE_4__types__["SET_ORDER_BY"], orderBy);
  },
  setStatus: function setStatus(_ref5, status) {
    var commit = _ref5.commit;

    commit(__WEBPACK_IMPORTED_MODULE_4__types__["SET_STATUS"], status);
  },
  setFilterBy: function setFilterBy(_ref6, filterBy) {
    var commit = _ref6.commit;

    commit(__WEBPACK_IMPORTED_MODULE_4__types__["SET_FILTER_BY"], filterBy);
  },
  downloadRequests: function downloadRequests(_ref7, data) {
    var _this = this;

    var commit = _ref7.commit;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].downloadRequests(data).then(function (response) {
                  resolve(response);
                });
              }));

            case 1:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  downloadRequestStatistics: function downloadRequestStatistics(_ref8, data) {
    var _this2 = this;

    var commit = _ref8.commit;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              return _context2.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].downloadRequestStatistics(data).then(function (response) {
                  resolve(response);
                });
              }));

            case 1:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }))();
  },
  downloadDeviceStatistics: function downloadDeviceStatistics(_ref9, data) {
    var _this3 = this;

    var commit = _ref9.commit;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              return _context3.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].downloadDeviceStatistics(data).then(function (response) {
                  resolve(response);
                });
              }));

            case 1:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this3);
    }))();
  },
  downloadActivationCardStatistics: function downloadActivationCardStatistics(_ref10, data) {
    var _this4 = this;

    var commit = _ref10.commit;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              return _context4.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].downloadActivationCardStatistics(data).then(function (response) {
                  resolve(response);
                });
              }));

            case 1:
            case 'end':
              return _context4.stop();
          }
        }
      }, _callee4, _this4);
    }))();
  },
  downloadBusinessAccountInfo: function downloadBusinessAccountInfo(_ref11, data) {
    var _this5 = this;

    var commit = _ref11.commit;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              return _context5.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].downloadBusinessAccountInfo(data).then(function (response) {
                  resolve(response);
                });
              }));

            case 1:
            case 'end':
              return _context5.stop();
          }
        }
      }, _callee5, _this5);
    }))();
  },
  downloadDeviceShipments: function downloadDeviceShipments(_ref12, data) {
    var _this6 = this;

    var commit = _ref12.commit;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              return _context6.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].downloadDeviceShipments(data).then(function (response) {
                  resolve(response);
                });
              }));

            case 1:
            case 'end':
              return _context6.stop();
          }
        }
      }, _callee6, _this6);
    }))();
  },
  downloadRequestsAdhoc: function downloadRequestsAdhoc(_ref13, data) {
    var _this7 = this;

    var commit = _ref13.commit;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee7() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              return _context7.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].downloadRequestsAdhoc(data).then(function (response) {
                  resolve(response);
                });
              }));

            case 1:
            case 'end':
              return _context7.stop();
          }
        }
      }, _callee7, _this7);
    }))();
  },
  getDataSchema: function getDataSchema(_ref14, name) {
    var _this8 = this;

    var commit = _ref14.commit;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee8() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              return _context8.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].getDataSchema(name).then(function (response) {
                  commit(__WEBPACK_IMPORTED_MODULE_4__types__["SET_SCHEMA"], response.data);
                  resolve(response);
                });
              }));

            case 1:
            case 'end':
              return _context8.stop();
          }
        }
      }, _callee8, _this8);
    }))();
  },
  getChoices: function getChoices(_ref15, data) {
    var _this9 = this;

    var commit = _ref15.commit;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee9() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
        while (1) {
          switch (_context9.prev = _context9.next) {
            case 0:
              return _context9.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].getChoices(data).then(function (response) {
                  resolve(response);
                });
              }));

            case 1:
            case 'end':
              return _context9.stop();
          }
        }
      }, _callee9, _this9);
    }))();
  },
  getQueryTemplates: function getQueryTemplates(_ref16) {
    var _this10 = this;

    var commit = _ref16.commit;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee10() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10) {
        while (1) {
          switch (_context10.prev = _context10.next) {
            case 0:
              return _context10.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].getQueryTemplates().then(function (response) {
                  commit(__WEBPACK_IMPORTED_MODULE_4__types__["SET_QUERY_TEMPLATES"], response.data);
                  resolve(response);
                });
              }));

            case 1:
            case 'end':
              return _context10.stop();
          }
        }
      }, _callee10, _this10);
    }))();
  },
  saveQueryTemplate: function saveQueryTemplate(_ref17, data) {
    var _this11 = this;

    var commit = _ref17.commit;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee11() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee11$(_context11) {
        while (1) {
          switch (_context11.prev = _context11.next) {
            case 0:
              return _context11.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].saveQueryTemplate(data).then(function (response) {
                  resolve(response);
                });
              }));

            case 1:
            case 'end':
              return _context11.stop();
          }
        }
      }, _callee11, _this11);
    }))();
  },
  removeQueryTemplate: function removeQueryTemplate(_ref18, data) {
    var _this12 = this;

    var commit = _ref18.commit;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee12() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee12$(_context12) {
        while (1) {
          switch (_context12.prev = _context12.next) {
            case 0:
              return _context12.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].removeQueryTemplate(data).then(function (response) {
                  resolve(response);
                });
              }));

            case 1:
            case 'end':
              return _context12.stop();
          }
        }
      }, _callee12, _this12);
    }))();
  },
  setCurrentTemplate: function setCurrentTemplate(_ref19, template) {
    var commit = _ref19.commit;

    commit(__WEBPACK_IMPORTED_MODULE_4__types__["SET_CURRENT_TEMPLATE"], template);
  }
});

/***/ }),

/***/ 265:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ({
  searchTerm: function searchTerm(state) {
    return state.searchTerm;
  },
  pageSize: function pageSize(state) {
    return state.pageSize;
  },
  sortDir: function sortDir(state) {
    return state.sortDir;
  },
  orderBy: function orderBy(state) {
    return state.orderBy;
  },
  status: function status(state) {
    return state.status;
  },
  filterBy: function filterBy(state) {
    return state.filterBy;
  },
  requests: function requests(state) {
    return state.requests;
  },
  totalRequests: function totalRequests(state) {
    return state.totalRequests;
  },
  schema: function schema(state) {
    return state.schema;
  },
  queryTemplates: function queryTemplates(state) {
    return state.queryTemplates;
  },
  logicChoices: function logicChoices(state) {
    return state.logicChoices;
  },
  categoryChoices: function categoryChoices(state) {
    return state.categoryChoices;
  },
  currentTemplate: function currentTemplate(state) {
    return state.currentTemplate;
  }
});

/***/ }),

/***/ 266:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__types__ = __webpack_require__(149);



var _types$SET_SEARCH_TER;



/* harmony default export */ __webpack_exports__["default"] = (_types$SET_SEARCH_TER = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$SET_SEARCH_TER, __WEBPACK_IMPORTED_MODULE_2__types__["SET_SEARCH_TERM"], function (state, text) {
  if (text !== undefined && text !== null) {
    state.searchTerm = text;
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$SET_SEARCH_TER, __WEBPACK_IMPORTED_MODULE_2__types__["SET_PAGE_SIZE"], function (state, value) {
  if (value !== undefined && value !== null) {
    state.pageSize = parseInt(value);
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$SET_SEARCH_TER, __WEBPACK_IMPORTED_MODULE_2__types__["SET_SORT_DIR"], function (state, text) {
  if (text !== undefined && text !== null) {
    state.sortDir = text;
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$SET_SEARCH_TER, __WEBPACK_IMPORTED_MODULE_2__types__["SET_ORDER_BY"], function (state, text) {
  if (text !== undefined && text !== null) {
    state.orderBy = text;
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$SET_SEARCH_TER, __WEBPACK_IMPORTED_MODULE_2__types__["SET_STATUS"], function (state, value) {
  if (value !== undefined && value !== null) {
    state.status = value;
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$SET_SEARCH_TER, __WEBPACK_IMPORTED_MODULE_2__types__["SET_FILTER_BY"], function (state, value) {
  if (value !== undefined && value !== null) {
    state.filterBy = parseInt(value);
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$SET_SEARCH_TER, __WEBPACK_IMPORTED_MODULE_2__types__["SET_SCHEMA"], function (state, data) {
  state.schema = data;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$SET_SEARCH_TER, __WEBPACK_IMPORTED_MODULE_2__types__["SET_QUERY_TEMPLATES"], function (state, data) {
  state.queryTemplates = data;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$SET_SEARCH_TER, __WEBPACK_IMPORTED_MODULE_2__types__["SET_REQUESTS"], function (state, data) {
  state.totalRequests = 0;
  state.requests = [];
  if (data !== undefined && data !== null) {
    if (data.length > 0) {
      state.totalRequests = data[0].TotalItems;
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(data), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var item = _step.value;

          item.isChecked = false;
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      state.requests = data;
    }
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$SET_SEARCH_TER, __WEBPACK_IMPORTED_MODULE_2__types__["SET_CURRENT_TEMPLATE"], function (state, template) {
  state.currentTemplate = template;
}), _types$SET_SEARCH_TER);

/***/ }),

/***/ 267:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = (function () {
  return {
    requests: [],
    totalRequests: 0,
    searchTerm: '',
    pageSize: 10,
    sortDir: 'asc',
    orderBy: 'Id',
    status: '',
    filterBy: 0,
    schema: [],
    queryTemplates: [],
    logicChoices: [{ name: '', value: 0 }, { name: 'and', value: 1 }, { name: 'or', value: 2 }],
    categoryChoices: [{ name: 'All', value: 0, checked: false }, { name: 'Scan Type', value: 1, checked: false }, { name: 'Status', value: 2, checked: false }, { name: 'Tech', value: 3, checked: false }, { name: 'Location', value: 4, checked: false }, { name: 'Country', value: 5, checked: false }, { name: 'Make', value: 6, checked: false }, { name: 'Time Stats', value: 7, checked: false }],
    currentTemplate: null
  };
});

/***/ }),

/***/ 268:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(669);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__api__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__types__ = __webpack_require__(150);








/* harmony default export */ __webpack_exports__["default"] = ({
  setSearchTerm: function setSearchTerm(_ref, text) {
    var commit = _ref.commit;

    commit(__WEBPACK_IMPORTED_MODULE_6__types__["SET_SEARCH_TERM"], text);
  },
  setPageSize: function setPageSize(_ref2, pageSize) {
    var commit = _ref2.commit;

    commit(__WEBPACK_IMPORTED_MODULE_6__types__["SET_PAGE_SIZE"], pageSize);
  },
  setSortDir: function setSortDir(_ref3, sortDir) {
    var commit = _ref3.commit;

    commit(__WEBPACK_IMPORTED_MODULE_6__types__["SET_SORT_DIR"], sortDir);
  },
  setOrderBy: function setOrderBy(_ref4, orderBy) {
    var commit = _ref4.commit;

    commit(__WEBPACK_IMPORTED_MODULE_6__types__["SET_ORDER_BY"], orderBy);
  },
  setStatus: function setStatus(_ref5, status) {
    var commit = _ref5.commit;

    commit(__WEBPACK_IMPORTED_MODULE_6__types__["SET_STATUS"], status);
  },
  setFilterBy: function setFilterBy(_ref6, filterBy) {
    var commit = _ref6.commit;

    commit(__WEBPACK_IMPORTED_MODULE_6__types__["SET_FILTER_BY"], filterBy);
  },
  clearDevices: function clearDevices(_ref7) {
    var commit = _ref7.commit;

    commit(__WEBPACK_IMPORTED_MODULE_6__types__["CLEAR_DEVICES"]);
  },
  clearFound: function clearFound(_ref8) {
    var commit = _ref8.commit;

    commit(__WEBPACK_IMPORTED_MODULE_6__types__["CLEAR_FOUND_DEVICES"]);
  },
  initDeviceModel: function initDeviceModel(_ref9, data) {
    var commit = _ref9.commit;

    console.log('test', data);
    return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_5__api__["a" /* default */].getDeviceById(data).then(function (response) {
        commit(__WEBPACK_IMPORTED_MODULE_6__types__["INIT_DEVICE_DATA"], response.data);
        resolve(response);
      });
    });
  },
  setActiveTab: function setActiveTab(_ref10, tab) {
    var commit = _ref10.commit,
        state = _ref10.state;

    commit(__WEBPACK_IMPORTED_MODULE_6__types__["SET_ACTIVE_TAB"], tab);
  },
  setSource: function setSource(_ref11, source) {
    var commit = _ref11.commit;

    commit(__WEBPACK_IMPORTED_MODULE_6__types__["SET_SOURCE"], source);
  },
  getDeviceTypes: function getDeviceTypes(_ref12) {
    var _this = this;

    var commit = _ref12.commit,
        dispatch = _ref12.dispatch;
    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt('return', new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                __WEBPACK_IMPORTED_MODULE_5__api__["a" /* default */].getAllDeviceTypes().then(function (response) {
                  commit(__WEBPACK_IMPORTED_MODULE_6__types__["SET_DEVICE_TYPES"], response.data);
                  resolve(response);
                }).catch(function (error) {
                  return reject(error);
                });
              }));

            case 1:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  getDevice: function getDevice(_ref13, serialNumber) {
    var _this2 = this;

    var commit = _ref13.commit,
        dispatch = _ref13.dispatch;
    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee2() {
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              return _context2.abrupt('return', new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                __WEBPACK_IMPORTED_MODULE_5__api__["a" /* default */].getDevice(serialNumber).then(function (response) {
                  commit(__WEBPACK_IMPORTED_MODULE_6__types__["SET_DEVICE"], response.data);
                  resolve(response);
                });
              }));

            case 1:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }))();
  },
  getDeviceById: function getDeviceById(_ref14, id) {
    var _this3 = this;

    var commit = _ref14.commit,
        dispatch = _ref14.dispatch;
    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee3() {
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              return _context3.abrupt('return', new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                __WEBPACK_IMPORTED_MODULE_5__api__["a" /* default */].getDeviceById(id).then(function (response) {
                  commit(__WEBPACK_IMPORTED_MODULE_6__types__["SET_DEVICE"], response.data);
                  resolve(response);
                }).catch(function (error) {
                  return reject(error);
                });
              }));

            case 1:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this3);
    }))();
  },
  getDeviceFileById: function getDeviceFileById(_ref15, id) {
    var _this4 = this;

    var commit = _ref15.commit,
        dispatch = _ref15.dispatch;
    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee4() {
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              return _context4.abrupt('return', new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                __WEBPACK_IMPORTED_MODULE_5__api__["a" /* default */].getDeviceFileById(id).then(function (response) {
                  commit(__WEBPACK_IMPORTED_MODULE_6__types__["SET_DEVICEFILE"], response.data);
                  resolve(response);
                });
              }));

            case 1:
            case 'end':
              return _context4.stop();
          }
        }
      }, _callee4, _this4);
    }))();
  },
  getDevices: function getDevices(_ref16, searchOptions) {
    var _this5 = this;

    var commit = _ref16.commit,
        dispatch = _ref16.dispatch;
    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee5() {
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              return _context5.abrupt('return', new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                __WEBPACK_IMPORTED_MODULE_5__api__["a" /* default */].getDevices(searchOptions).then(function (response) {
                  commit(__WEBPACK_IMPORTED_MODULE_6__types__["SET_DEVICES"], response.data);
                  resolve(response);
                });
              }));

            case 1:
            case 'end':
              return _context5.stop();
          }
        }
      }, _callee5, _this5);
    }))();
  },
  getDevicefiles: function getDevicefiles(_ref17, searchOptions) {
    var _this6 = this;

    var commit = _ref17.commit,
        dispatch = _ref17.dispatch;
    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee6() {
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              return _context6.abrupt('return', new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                __WEBPACK_IMPORTED_MODULE_5__api__["a" /* default */].getdevicefiles(searchOptions).then(function (response) {
                  commit(__WEBPACK_IMPORTED_MODULE_6__types__["SET_DEVICEFILES"], response.data);
                  resolve(response);
                });
              }));

            case 1:
            case 'end':
              return _context6.stop();
          }
        }
      }, _callee6, _this6);
    }))();
  },
  searchDevices: function searchDevices(_ref18, searchOptions) {
    var _this7 = this;

    var commit = _ref18.commit,
        dispatch = _ref18.dispatch;
    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee7() {
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              return _context7.abrupt('return', new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                __WEBPACK_IMPORTED_MODULE_5__api__["a" /* default */].getDevices(searchOptions).then(function (response) {
                  commit(__WEBPACK_IMPORTED_MODULE_6__types__["SET_FOUND_DEVICES"], response.data);
                  resolve(response);
                });
              }));

            case 1:
            case 'end':
              return _context7.stop();
          }
        }
      }, _callee7, _this7);
    }))();
  },
  getAssociatedDevices: function getAssociatedDevices(_ref19, searchOptions) {
    var _this8 = this;

    var commit = _ref19.commit,
        dispatch = _ref19.dispatch;
    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee8() {
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              return _context8.abrupt('return', new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                __WEBPACK_IMPORTED_MODULE_5__api__["a" /* default */].getDevices(searchOptions).then(function (response) {
                  if (searchOptions.deviceId > 0) {
                    response.data = response.data.filter(function (obj) {
                      return obj.Id !== searchOptions.deviceId;
                    });
                  }

                  commit(__WEBPACK_IMPORTED_MODULE_6__types__["SET_ASSOCIATED_DEVICES"], response.data);
                  resolve(response);
                });
              }));

            case 1:
            case 'end':
              return _context8.stop();
          }
        }
      }, _callee8, _this8);
    }))();
  },
  activateDevice: function activateDevice(_ref20, data) {
    var _this9 = this;

    var commit = _ref20.commit,
        dispatch = _ref20.dispatch;
    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee9() {
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
        while (1) {
          switch (_context9.prev = _context9.next) {
            case 0:
              return _context9.abrupt('return', new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                __WEBPACK_IMPORTED_MODULE_5__api__["a" /* default */].activateDevice(data).then(function (response) {
                  resolve(response);
                });
              }));

            case 1:
            case 'end':
              return _context9.stop();
          }
        }
      }, _callee9, _this9);
    }))();
  },
  getDeviceActivation: function getDeviceActivation(_ref21, data) {
    var _this10 = this;

    var commit = _ref21.commit,
        dispatch = _ref21.dispatch;
    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee10() {
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10) {
        while (1) {
          switch (_context10.prev = _context10.next) {
            case 0:
              return _context10.abrupt('return', new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                __WEBPACK_IMPORTED_MODULE_5__api__["a" /* default */].getDeviceActivation(data).then(function (response) {
                  resolve(response);
                });
              }));

            case 1:
            case 'end':
              return _context10.stop();
          }
        }
      }, _callee10, _this10);
    }))();
  },
  downloadAllTools: function downloadAllTools(_ref22, payload) {
    var _this11 = this;

    var commit = _ref22.commit,
        dispatch = _ref22.dispatch;
    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee11() {
      var isObject, id, filter;
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee11$(_context11) {
        while (1) {
          switch (_context11.prev = _context11.next) {
            case 0:
              isObject = (typeof payload === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(payload)) === 'object' && payload !== null;
              id = isObject ? payload.id : payload;
              filter = isObject ? payload.filter : 0;
              return _context11.abrupt('return', new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                __WEBPACK_IMPORTED_MODULE_5__api__["a" /* default */].downloadAllTools(id, filter).then(function (response) {
                  resolve(response);
                });
              }));

            case 4:
            case 'end':
              return _context11.stop();
          }
        }
      }, _callee11, _this11);
    }))();
  },
  getTools: function getTools(_ref23, searchOptions) {
    var _this12 = this;

    var commit = _ref23.commit,
        dispatch = _ref23.dispatch;
    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee12() {
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee12$(_context12) {
        while (1) {
          switch (_context12.prev = _context12.next) {
            case 0:
              return _context12.abrupt('return', new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                __WEBPACK_IMPORTED_MODULE_5__api__["a" /* default */].getTools(searchOptions).then(function (response) {
                  commit(__WEBPACK_IMPORTED_MODULE_6__types__["SET_TOOLS"], response.data);
                  resolve(response);
                });
              }));

            case 1:
            case 'end':
              return _context12.stop();
          }
        }
      }, _callee12, _this12);
    }))();
  },
  updateDeviceFile: function updateDeviceFile(_ref24, data) {
    var _this13 = this;

    var commit = _ref24.commit,
        dispatch = _ref24.dispatch;
    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee13() {
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee13$(_context13) {
        while (1) {
          switch (_context13.prev = _context13.next) {
            case 0:
              return _context13.abrupt('return', new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                __WEBPACK_IMPORTED_MODULE_5__api__["a" /* default */].updateDeviceFile(data).then(function (response) {
                  resolve(response);
                });
              }));

            case 1:
            case 'end':
              return _context13.stop();
          }
        }
      }, _callee13, _this13);
    }))();
  },
  RequeueDeviceFile: function RequeueDeviceFile(_ref25, data) {
    var _this14 = this;

    var commit = _ref25.commit,
        dispatch = _ref25.dispatch;
    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee14() {
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee14$(_context14) {
        while (1) {
          switch (_context14.prev = _context14.next) {
            case 0:
              return _context14.abrupt('return', new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                __WEBPACK_IMPORTED_MODULE_5__api__["a" /* default */].requeueDeviceFileById(data).then(function (response) {
                  resolve(response);
                });
              }));

            case 1:
            case 'end':
              return _context14.stop();
          }
        }
      }, _callee14, _this14);
    }))();
  },
  updateDevice: function updateDevice(_ref26, data) {
    var _this15 = this;

    var commit = _ref26.commit,
        dispatch = _ref26.dispatch;
    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee15() {
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee15$(_context15) {
        while (1) {
          switch (_context15.prev = _context15.next) {
            case 0:
              return _context15.abrupt('return', new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                __WEBPACK_IMPORTED_MODULE_5__api__["a" /* default */].updateDevice(data).then(function (response) {
                  resolve(response);
                }).catch(function (error) {
                  return reject(error);
                });
              }));

            case 1:
            case 'end':
              return _context15.stop();
          }
        }
      }, _callee15, _this15);
    }))();
  },
  upsertDeviceShipment: function upsertDeviceShipment(_ref27, data) {
    var _this16 = this;

    var commit = _ref27.commit,
        dispatch = _ref27.dispatch;
    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee16() {
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee16$(_context16) {
        while (1) {
          switch (_context16.prev = _context16.next) {
            case 0:
              return _context16.abrupt('return', new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                __WEBPACK_IMPORTED_MODULE_5__api__["a" /* default */].upsertDeviceShipment(data).then(function (response) {
                  resolve(response);
                });
              }));

            case 1:
            case 'end':
              return _context16.stop();
          }
        }
      }, _callee16, _this16);
    }))();
  },
  createDevice: function createDevice(_ref28, data) {
    var _this17 = this;

    var commit = _ref28.commit;
    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee17() {
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee17$(_context17) {
        while (1) {
          switch (_context17.prev = _context17.next) {
            case 0:
              return _context17.abrupt('return', new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                __WEBPACK_IMPORTED_MODULE_5__api__["a" /* default */].createDevice(data).then(function (response) {
                  resolve(response);
                }).catch(function (error) {
                  return reject(error);
                });
              }));

            case 1:
            case 'end':
              return _context17.stop();
          }
        }
      }, _callee17, _this17);
    }))();
  },
  getToolMakes: function getToolMakes(_ref29, id) {
    var _this18 = this;

    var commit = _ref29.commit,
        dispatch = _ref29.dispatch;
    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee18() {
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee18$(_context18) {
        while (1) {
          switch (_context18.prev = _context18.next) {
            case 0:
              return _context18.abrupt('return', new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                __WEBPACK_IMPORTED_MODULE_5__api__["a" /* default */].getToolMakes(id).then(function (response) {
                  commit(__WEBPACK_IMPORTED_MODULE_6__types__["SET_TOOL_MAKES"], response.data);
                  resolve(response);
                });
              }));

            case 1:
            case 'end':
              return _context18.stop();
          }
        }
      }, _callee18, _this18);
    }))();
  },
  addToolMake: function addToolMake(_ref30, data) {
    var _this19 = this;

    var commit = _ref30.commit,
        dispatch = _ref30.dispatch;
    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee19() {
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee19$(_context19) {
        while (1) {
          switch (_context19.prev = _context19.next) {
            case 0:
              return _context19.abrupt('return', new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                __WEBPACK_IMPORTED_MODULE_5__api__["a" /* default */].addToolMake(data).then(function (response) {
                  resolve(response);
                });
              }));

            case 1:
            case 'end':
              return _context19.stop();
          }
        }
      }, _callee19, _this19);
    }))();
  },
  deleteToolMake: function deleteToolMake(_ref31, id) {
    var _this20 = this;

    var commit = _ref31.commit,
        dispatch = _ref31.dispatch;
    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee20() {
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee20$(_context20) {
        while (1) {
          switch (_context20.prev = _context20.next) {
            case 0:
              return _context20.abrupt('return', new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                __WEBPACK_IMPORTED_MODULE_5__api__["a" /* default */].deleteToolMake(id).then(function (response) {
                  resolve(response);
                });
              }));

            case 1:
            case 'end':
              return _context20.stop();
          }
        }
      }, _callee20, _this20);
    }))();
  },
  assignDevice: function assignDevice(_ref32, data) {
    var _this21 = this;

    var commit = _ref32.commit;
    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee21() {
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee21$(_context21) {
        while (1) {
          switch (_context21.prev = _context21.next) {
            case 0:
              return _context21.abrupt('return', new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                __WEBPACK_IMPORTED_MODULE_5__api__["a" /* default */].assignDevice(data).then(function (response) {
                  resolve(response);
                });
              }));

            case 1:
            case 'end':
              return _context21.stop();
          }
        }
      }, _callee21, _this21);
    }))();
  },
  getAssignedDevices: function getAssignedDevices(_ref33, payload) {
    var _this22 = this;

    var commit = _ref33.commit;
    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee22() {
      var businessId, searchOptions;
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee22$(_context22) {
        while (1) {
          switch (_context22.prev = _context22.next) {
            case 0:
              businessId = payload.businessId, searchOptions = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default()(payload, ['businessId']);
              return _context22.abrupt('return', new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                __WEBPACK_IMPORTED_MODULE_5__api__["a" /* default */].getDevicesForBusiness(businessId, searchOptions).then(function (response) {
                  console.log('[devices] getAssignedDevices response.data:', response.data);
                  commit(__WEBPACK_IMPORTED_MODULE_6__types__["SET_ASSIGNED_DEVICES"], response.data);
                  resolve(response);
                }).catch(function (err) {
                  console.error('[devices] getAssignedDevices error:', err);
                  reject(err);
                });
              }));

            case 2:
            case 'end':
              return _context22.stop();
          }
        }
      }, _callee22, _this22);
    }))();
  }
});

/***/ }),

/***/ 269:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ({
  searchTerm: function searchTerm(state) {
    return state.searchTerm;
  },
  pageSize: function pageSize(state) {
    return state.pageSize;
  },
  sortDir: function sortDir(state) {
    return state.sortDir;
  },
  orderBy: function orderBy(state) {
    return state.orderBy;
  },
  status: function status(state) {
    return state.status;
  },
  filterBy: function filterBy(state) {
    return state.filterBy;
  },
  activeTab: function activeTab(state) {
    return state.activeTab;
  },
  tabs: function tabs(state) {
    return state.tabs;
  },
  source: function source(state) {
    return state.source;
  },
  device: function device(state) {
    return state.device;
  },
  devices: function devices(state) {
    return state.devices;
  },
  totalDevices: function totalDevices(state) {
    return state.totalDevices;
  },
  deviceTypes: function deviceTypes(state) {
    return state.deviceTypes;
  },
  deviceFiles: function deviceFiles(state) {
    return state.deviceFiles;
  },
  deviceFile: function deviceFile(state) {
    return state.deviceFile;
  },
  totalDeviceFiles: function totalDeviceFiles(state) {
    return state.totalDeviceFiles;
  },
  currentDevice: function currentDevice(state) {
    return state.currentDevice;
  },
  tools: function tools(state) {
    return state.tools;
  },
  totalTools: function totalTools(state) {
    return state.totalTools;
  },
  toolMakes: function toolMakes(state) {
    return state.toolMakes;
  },
  totalFoundDevices: function totalFoundDevices(state) {
    return state.totalFoundDevices;
  },
  foundDevices: function foundDevices(state) {
    return state.foundDevices;
  },
  assignedDevices: function assignedDevices(state) {
    return state.assignedDevices;
  },
  totalAssignedDevices: function totalAssignedDevices(state) {
    return state.totalAssignedDevices;
  }
});

/***/ }),

/***/ 270:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__types__ = __webpack_require__(150);



var _types$INIT_DEVICE_DA;



/* harmony default export */ __webpack_exports__["default"] = (_types$INIT_DEVICE_DA = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$INIT_DEVICE_DA, __WEBPACK_IMPORTED_MODULE_2__types__["INIT_DEVICE_DATA"], function (state, data) {
  console.log('init device', data);
  state.device = data;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$INIT_DEVICE_DA, __WEBPACK_IMPORTED_MODULE_2__types__["SET_SEARCH_TERM"], function (state, text) {
  if (text !== undefined && text !== null) {
    state.searchTerm = text;
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$INIT_DEVICE_DA, __WEBPACK_IMPORTED_MODULE_2__types__["SET_PAGE_SIZE"], function (state, value) {
  if (value !== undefined && value !== null) {
    state.pageSize = parseInt(value);
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$INIT_DEVICE_DA, __WEBPACK_IMPORTED_MODULE_2__types__["SET_SORT_DIR"], function (state, text) {
  if (text !== undefined && text !== null) {
    state.sortDir = text;
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$INIT_DEVICE_DA, __WEBPACK_IMPORTED_MODULE_2__types__["SET_ORDER_BY"], function (state, text) {
  if (text !== undefined && text !== null) {
    state.orderBy = text;
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$INIT_DEVICE_DA, __WEBPACK_IMPORTED_MODULE_2__types__["SET_STATUS"], function (state, value) {
  if (value !== undefined && value !== null) {
    state.status = value;
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$INIT_DEVICE_DA, __WEBPACK_IMPORTED_MODULE_2__types__["SET_FILTER_BY"], function (state, value) {
  if (value !== undefined && value !== null) {
    state.filterBy = parseInt(value);
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$INIT_DEVICE_DA, __WEBPACK_IMPORTED_MODULE_2__types__["SET_DEVICE_TYPES"], function (state, data) {
  state.deviceTypes = data;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$INIT_DEVICE_DA, __WEBPACK_IMPORTED_MODULE_2__types__["SET_DEVICE"], function (state, data) {
  state.device = data;
  state.currentDevice = data;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$INIT_DEVICE_DA, __WEBPACK_IMPORTED_MODULE_2__types__["SET_DEVICEFILE"], function (state, data) {
  state.deviceFile = data;
  state.currentDeviceFile = data;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$INIT_DEVICE_DA, __WEBPACK_IMPORTED_MODULE_2__types__["SET_DEVICES"], function (state, data) {
  state.totalDevices = 0;
  state.devices = [];
  if (data !== undefined && data !== null) {
    if (data.length > 0) {
      state.totalDevices = data[0].TotalItems;
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(data), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var item = _step.value;

          item.isChecked = false;
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      state.devices = data;
    }
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$INIT_DEVICE_DA, __WEBPACK_IMPORTED_MODULE_2__types__["SET_DEVICEFILES"], function (state, data) {
  state.totalDeviceFiles = 0;
  state.deviceFiles = [];
  console.log('SET_DEVICE_FILES', data);
  if (data !== undefined && data !== null) {
    if (data.length > 0) {
      state.totalDeviceFiles = data[0].TotalItems;
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(data), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var item = _step2.value;

          item.isChecked = false;
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      state.deviceFiles = data;
      console.log('SET_DEVICE_FILES', state.deviceFiles);
    }
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$INIT_DEVICE_DA, __WEBPACK_IMPORTED_MODULE_2__types__["SET_FOUND_DEVICES"], function (state, data) {
  state.totalFoundDevices = 0;
  state.foundDevices = [];
  if (data !== undefined && data !== null) {
    if (data.length > 0) {
      state.totalFoundDevices = data[0].TotalItems;
      var _iteratorNormalCompletion3 = true;
      var _didIteratorError3 = false;
      var _iteratorError3 = undefined;

      try {
        for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(data), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
          var item = _step3.value;

          item.isChecked = false;
        }
      } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion3 && _iterator3.return) {
            _iterator3.return();
          }
        } finally {
          if (_didIteratorError3) {
            throw _iteratorError3;
          }
        }
      }

      state.foundDevices = data;
    }
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$INIT_DEVICE_DA, __WEBPACK_IMPORTED_MODULE_2__types__["SET_ASSOCIATED_DEVICES"], function (state, data) {
  state.totalAssociatedFoundDevices = 0;
  state.foundAssociatedDevices = [];
  if (data !== undefined && data !== null) {
    if (data.length > 0) {
      state.totalAssociatedFoundDevices = data[0].TotalItems;
      var _iteratorNormalCompletion4 = true;
      var _didIteratorError4 = false;
      var _iteratorError4 = undefined;

      try {
        for (var _iterator4 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(data), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
          var item = _step4.value;

          item.isChecked = false;
        }
      } catch (err) {
        _didIteratorError4 = true;
        _iteratorError4 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion4 && _iterator4.return) {
            _iterator4.return();
          }
        } finally {
          if (_didIteratorError4) {
            throw _iteratorError4;
          }
        }
      }

      state.foundAssociatedDevices = data;
    }
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$INIT_DEVICE_DA, __WEBPACK_IMPORTED_MODULE_2__types__["SET_ASSIGNED_DEVICES"], function (state, data) {
  state.totalAssignedDevices = 0;
  state.assignedDevices = [];
  if (data !== undefined && data !== null) {
    if (data.length > 0) {
      state.totalAssignedDevices = data[0].TotalItems;
      var _iteratorNormalCompletion5 = true;
      var _didIteratorError5 = false;
      var _iteratorError5 = undefined;

      try {
        for (var _iterator5 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(data), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
          var item = _step5.value;

          item.isChecked = false;
        }
      } catch (err) {
        _didIteratorError5 = true;
        _iteratorError5 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion5 && _iterator5.return) {
            _iterator5.return();
          }
        } finally {
          if (_didIteratorError5) {
            throw _iteratorError5;
          }
        }
      }

      state.assignedDevices = data;
    }
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$INIT_DEVICE_DA, __WEBPACK_IMPORTED_MODULE_2__types__["CLEAR_FOUND_DEVICES"], function (state) {
  state.totalFoundDevices = 0;
  state.foundDevices = [];
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$INIT_DEVICE_DA, __WEBPACK_IMPORTED_MODULE_2__types__["CLEAR_DEVICES"], function (state) {
  state.totalDevices = 0;
  state.devices = [];
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$INIT_DEVICE_DA, __WEBPACK_IMPORTED_MODULE_2__types__["SET_TOOLS"], function (state, data) {
  state.totalTools = 0;
  state.tools = [];
  if (data !== undefined && data !== null) {
    if (data.length > 0) {
      state.totalTools = data[0].TotalItems;
      var _iteratorNormalCompletion6 = true;
      var _didIteratorError6 = false;
      var _iteratorError6 = undefined;

      try {
        for (var _iterator6 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(data), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
          var item = _step6.value;

          item.isChecked = false;
        }
      } catch (err) {
        _didIteratorError6 = true;
        _iteratorError6 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion6 && _iterator6.return) {
            _iterator6.return();
          }
        } finally {
          if (_didIteratorError6) {
            throw _iteratorError6;
          }
        }
      }

      state.tools = data;
    }
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$INIT_DEVICE_DA, __WEBPACK_IMPORTED_MODULE_2__types__["SET_ACTIVE_TAB"], function (state, tab) {
  state.activeTab = tab;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$INIT_DEVICE_DA, __WEBPACK_IMPORTED_MODULE_2__types__["SET_TOOL_MAKES"], function (state, data) {
  state.toolMakes = [];
  if (data !== undefined && data !== null) {
    if (data !== '') {
      state.toolMakes = data;
    }
  }
}), _types$INIT_DEVICE_DA);

/***/ }),

/***/ 271:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = (function () {
  return {
    device: null,
    devices: [],
    totalDevices: 0,
    deviceFiles: [],
    deviceFile: null,
    totalDeviceFiles: 0,
    tools: [],
    totalTools: 0,
    toolMakes: [],
    connectedDevices: [],
    currentDevice: null,
    searchTerm: '',
    pageSize: 10,
    sortDir: 'asc',
    orderBy: 'Name',
    status: '',
    filterBy: 0,
    totalFoundDevices: 0,
    foundDevices: [],
    activeTab: 'Device',
    tabs: ['Device', 'Location', 'Shipment'],
    deviceTypes: [],
    assignedDevices: [],
    totalAssignedDevices: 0
  };
});

/***/ }),

/***/ 272:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api__ = __webpack_require__(11);





/* harmony default export */ __webpack_exports__["default"] = ({
  getFiles: function getFiles(_ref, path) {
    var _this = this;

    var commit = _ref.commit,
        state = _ref.state;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].getFiles(path).then(function (response) {
                  commit('SET_FILES', response.data);
                  resolve(response);
                });
              }));

            case 1:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  getBase64File: function getBase64File(_ref2, file) {
    var _this2 = this;

    var commit = _ref2.commit,
        state = _ref2.state;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              return _context2.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].getBase64File(file).then(function (response) {
                  commit('SET_FILE', response.data);
                  resolve(response);
                });
              }));

            case 1:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }))();
  },
  getThumbs: function getThumbs(_ref3, path) {
    var _this3 = this;

    var commit = _ref3.commit,
        state = _ref3.state;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              return _context3.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].getThumbs(path).then(function (response) {
                  commit('SET_THUMBS', response.data);
                  resolve(response);
                });
              }));

            case 1:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this3);
    }))();
  },
  uploadBase64File: function uploadBase64File(_ref4, data) {
    var _this4 = this;

    var commit = _ref4.commit;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              return _context4.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].uploadBase64File(data).then(function (response) {
                  resolve(response);
                });
              }));

            case 1:
            case 'end':
              return _context4.stop();
          }
        }
      }, _callee4, _this4);
    }))();
  }
});

/***/ }),

/***/ 273:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ({
  files: function files(state) {
    return state.files;
  },
  file: function file(state) {
    return state.file;
  },
  thumbs: function thumbs(state) {
    return state.thumbs;
  }
});

/***/ }),

/***/ 274:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__types__ = __webpack_require__(276);


var _types$SET_FILES$type;


/* harmony default export */ __webpack_exports__["default"] = (_types$SET_FILES$type = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$SET_FILES$type, __WEBPACK_IMPORTED_MODULE_1__types__["SET_FILES"], function (state, files) {
  state.files = files;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$SET_FILES$type, __WEBPACK_IMPORTED_MODULE_1__types__["SET_FILE"], function (state, file) {
  state.file = file;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$SET_FILES$type, __WEBPACK_IMPORTED_MODULE_1__types__["SET_THUMBS"], function (state, thumbs) {
  state.thumbs = thumbs;
}), _types$SET_FILES$type);

/***/ }),

/***/ 275:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = (function () {
  return {
    files: [],
    file: null,
    thumbs: []
  };
});

/***/ }),

/***/ 276:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_FILES", function() { return SET_FILES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_FILE", function() { return SET_FILE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_THUMBS", function() { return SET_THUMBS; });
var SET_FILES = 'SET_FILES';
var SET_FILE = 'SET_FILE';
var SET_THUMBS = 'SET_THUMBS';

/***/ }),

/***/ 277:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__types__ = __webpack_require__(151);






/* harmony default export */ __webpack_exports__["default"] = ({
  setSearchTerm: function setSearchTerm(_ref, text) {
    var commit = _ref.commit;

    commit(__WEBPACK_IMPORTED_MODULE_4__types__["SET_SEARCH_TERM"], text);
  },
  setPageSize: function setPageSize(_ref2, pageSize) {
    var commit = _ref2.commit;

    commit(__WEBPACK_IMPORTED_MODULE_4__types__["SET_PAGE_SIZE"], pageSize);
  },
  setSortDir: function setSortDir(_ref3, sortDir) {
    var commit = _ref3.commit;

    commit(__WEBPACK_IMPORTED_MODULE_4__types__["SET_SORT_DIR"], sortDir);
  },
  setOrderBy: function setOrderBy(_ref4, orderBy) {
    var commit = _ref4.commit;

    commit(__WEBPACK_IMPORTED_MODULE_4__types__["SET_ORDER_BY"], orderBy);
  },
  setStatus: function setStatus(_ref5, status) {
    var commit = _ref5.commit;

    commit(__WEBPACK_IMPORTED_MODULE_4__types__["SET_STATUS"], status);
  },
  setFilterBy: function setFilterBy(_ref6, filterBy) {
    var commit = _ref6.commit;

    commit(__WEBPACK_IMPORTED_MODULE_4__types__["SET_FILTER_BY"], filterBy);
  },
  getIntegrationById: function getIntegrationById(_ref7, id) {
    var _this = this;

    var commit = _ref7.commit,
        dispatch = _ref7.dispatch;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].getIntegrationById(id).then(function (response) {
                  commit(__WEBPACK_IMPORTED_MODULE_4__types__["SET_INTEGRATION"], response.data);
                  resolve(response);
                });
              }));

            case 1:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  getIntegrations: function getIntegrations(_ref8, searchOptions) {
    var _this2 = this;

    var commit = _ref8.commit,
        dispatch = _ref8.dispatch;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              console.log(searchOptions.state);
              return _context2.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].getIntegrations(searchOptions).then(function (response) {
                  commit(__WEBPACK_IMPORTED_MODULE_4__types__["SET_INTEGRATIONS"], response.data);
                  resolve(response);
                });
              }));

            case 2:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }))();
  },
  updateIntegration: function updateIntegration(_ref9, data) {
    var _this3 = this;

    var commit = _ref9.commit,
        dispatch = _ref9.dispatch;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              return _context3.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].updateIntegration(data).then(function (response) {
                  resolve(response);
                });
              }));

            case 1:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this3);
    }))();
  },
  RequeueIntegration: function RequeueIntegration(_ref10, data) {
    var _this4 = this;

    var commit = _ref10.commit,
        dispatch = _ref10.dispatch;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              return _context4.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].requeueIntegrationById(data).then(function (response) {
                  resolve(response);
                });
              }));

            case 1:
            case 'end':
              return _context4.stop();
          }
        }
      }, _callee4, _this4);
    }))();
  }
});

/***/ }),

/***/ 278:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ({
  searchTerm: function searchTerm(state) {
    return state.searchTerm;
  },
  pageSize: function pageSize(state) {
    return state.pageSize;
  },
  sortDir: function sortDir(state) {
    return state.sortDir;
  },
  orderBy: function orderBy(state) {
    return state.orderBy;
  },
  status: function status(state) {
    return state.status;
  },
  filterBy: function filterBy(state) {
    return state.filterBy;
  },
  integrations: function integrations(state) {
    return state.integrations;
  },
  integration: function integration(state) {
    return state.integration;
  },
  totalIntegrations: function totalIntegrations(state) {
    return state.totalIntegrations;
  }
});

/***/ }),

/***/ 279:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__types__ = __webpack_require__(151);



var _types$SET_SEARCH_TER;



/* harmony default export */ __webpack_exports__["default"] = (_types$SET_SEARCH_TER = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$SET_SEARCH_TER, __WEBPACK_IMPORTED_MODULE_2__types__["SET_SEARCH_TERM"], function (state, text) {
  if (text !== undefined && text !== null) {
    state.searchTerm = text;
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$SET_SEARCH_TER, __WEBPACK_IMPORTED_MODULE_2__types__["SET_PAGE_SIZE"], function (state, value) {
  if (value !== undefined && value !== null) {
    state.pageSize = parseInt(value);
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$SET_SEARCH_TER, __WEBPACK_IMPORTED_MODULE_2__types__["SET_SORT_DIR"], function (state, text) {
  if (text !== undefined && text !== null) {
    state.sortDir = text;
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$SET_SEARCH_TER, __WEBPACK_IMPORTED_MODULE_2__types__["SET_ORDER_BY"], function (state, text) {
  if (text !== undefined && text !== null) {
    state.orderBy = text;
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$SET_SEARCH_TER, __WEBPACK_IMPORTED_MODULE_2__types__["SET_STATUS"], function (state, value) {
  if (value !== undefined && value !== null) {
    state.status = value;
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$SET_SEARCH_TER, __WEBPACK_IMPORTED_MODULE_2__types__["SET_FILTER_BY"], function (state, value) {
  if (value !== undefined && value !== null) {
    state.filterBy = parseInt(value);
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$SET_SEARCH_TER, __WEBPACK_IMPORTED_MODULE_2__types__["SET_INTEGRATION"], function (state, data) {
  state.integration = data;
  state.currentIntegration = data;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$SET_SEARCH_TER, __WEBPACK_IMPORTED_MODULE_2__types__["SET_INTEGRATIONS"], function (state, data) {
  state.totalIntegrations = 0;
  state.integrations = [];
  if (data !== undefined && data !== null) {
    if (data.length > 0) {
      state.totalIntegrations = data[0].totalItems;
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(data), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var item = _step.value;

          item.isChecked = false;
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      state.integrations = data;
    }
  }
}), _types$SET_SEARCH_TER);

/***/ }),

/***/ 280:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = (function () {
  return {
    integrations: [],
    integration: null,
    totalIntegrations: 0,
    searchTerm: '',
    pageSize: 10,
    sortDir: 'asc',
    orderBy: 'Name',
    status: '',
    filterBy: 0
  };
});

/***/ }),

/***/ 281:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__types__ = __webpack_require__(152);







/* harmony default export */ __webpack_exports__["default"] = ({
  initWorkOrderMaintenance: function initWorkOrderMaintenance(_ref) {
    var commit = _ref.commit;

    commit(__WEBPACK_IMPORTED_MODULE_5__types__["INIT_WORKORDER"]);
  },
  addInsurance: function addInsurance(_ref2, data) {
    var _this = this;

    var commit = _ref2.commit,
        dispatch = _ref2.dispatch;
    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt('return', new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].addInsurance(data).then(function (response) {
                  resolve(response);
                });
              }));

            case 1:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  getWorkOrderMaintenance: function getWorkOrderMaintenance(_ref3, workOrder) {
    var _this2 = this;

    var commit = _ref3.commit,
        dispatch = _ref3.dispatch;
    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              return _context2.abrupt('return', new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].getWorkOrderMaintenance(workOrder).then(function (response) {
                  commit(__WEBPACK_IMPORTED_MODULE_5__types__["SET_WORKORDER"], response.data);
                  resolve(response);
                });
              }));

            case 1:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }))();
  },
  saveWorkOrderMaintenance: function saveWorkOrderMaintenance(_ref4, data) {
    var _this3 = this;

    var commit = _ref4.commit,
        dispatch = _ref4.dispatch;
    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              return _context3.abrupt('return', new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].saveWorkOrderMaintenance(data).then(function (response) {
                  resolve(response);
                });
              }));

            case 1:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this3);
    }))();
  },
  fixDispatchTimes: function fixDispatchTimes(_ref5) {
    var _this4 = this;

    var commit = _ref5.commit,
        dispatch = _ref5.dispatch;
    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee4() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              return _context4.abrupt('return', new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].fixDispatchTimes().then(function (response) {
                  resolve(response);
                });
              }));

            case 1:
            case 'end':
              return _context4.stop();
          }
        }
      }, _callee4, _this4);
    }))();
  },
  cancelPendingRequests: function cancelPendingRequests(_ref6, location) {
    var _this5 = this;

    var commit = _ref6.commit,
        dispatch = _ref6.dispatch;
    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee5() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              return _context5.abrupt('return', new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].cancelPendingRequests(location).then(function (response) {
                  resolve(response);
                });
              }));

            case 1:
            case 'end':
              return _context5.stop();
          }
        }
      }, _callee5, _this5);
    }))();
  },
  searchTechnicians: function searchTechnicians(_ref7, searchTerm) {
    var _this6 = this;

    var commit = _ref7.commit,
        state = _ref7.state,
        dispatch = _ref7.dispatch;
    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee6() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              return _context6.abrupt('return', new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].searchTechnicians(searchTerm).then(function (response) {
                  console.log('Search Techs', response);
                  var _technicians = [];
                  var _iteratorNormalCompletion = true;
                  var _didIteratorError = false;
                  var _iteratorError = undefined;

                  try {
                    for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(response.data), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                      var tech = _step.value;

                      var technician = {
                        name: tech.FamilyName + ', ' + tech.GivenName + ' (' + tech.Username + ')',
                        code: tech.Id,
                        lastName: tech.FamilyName
                      };
                      _technicians.push(technician);
                    }
                  } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                  } finally {
                    try {
                      if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                      }
                    } finally {
                      if (_didIteratorError) {
                        throw _iteratorError;
                      }
                    }
                  }

                  commit(__WEBPACK_IMPORTED_MODULE_5__types__["SET_TECHNICIANS"], _technicians);
                  resolve(_technicians);
                });
              }));

            case 1:
            case 'end':
              return _context6.stop();
          }
        }
      }, _callee6, _this6);
    }))();
  },
  resetTechnician: function resetTechnician(_ref8, data) {
    var _this7 = this;

    var commit = _ref8.commit,
        dispatch = _ref8.dispatch;
    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee7() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              return _context7.abrupt('return', new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].resetTechnician(data).then(function (response) {
                  resolve(response);
                });
              }));

            case 1:
            case 'end':
              return _context7.stop();
          }
        }
      }, _callee7, _this7);
    }))();
  }
});

/***/ }),

/***/ 282:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ({
  workOrder: function workOrder(state) {
    return state.workOrder;
  },
  technicians: function technicians(state) {
    return state.technicians;
  }
});

/***/ }),

/***/ 283:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__types__ = __webpack_require__(152);


var _types$SET_TECHNICIAN;



/* harmony default export */ __webpack_exports__["default"] = (_types$SET_TECHNICIAN = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$SET_TECHNICIAN, __WEBPACK_IMPORTED_MODULE_1__types__["SET_TECHNICIANS"], function (state, data) {
  state.technicians = data;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$SET_TECHNICIAN, __WEBPACK_IMPORTED_MODULE_1__types__["SET_WORKORDER"], function (state, workOrder) {
  state.workOrder = workOrder;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$SET_TECHNICIAN, __WEBPACK_IMPORTED_MODULE_1__types__["INIT_WORKORDER"], function (state) {
  state.workOrder = {
    Id: 0,
    Location: {
      Id: 0,
      Name: ''
    },
    WorkOrder: {
      CreatedBy: {
        Id: 0,
        LastName: '',
        FirstName: ''
      },
      UpdatedBy: {
        Id: 0,
        LastName: '',
        FirstName: ''
      }
    },
    ScanReport: {
      Status: '',
      CreatedBy: {
        Id: 0,
        LastName: '',
        FirstName: ''
      },
      UpdatedDate: new Date(),
      UpdatedBy: {
        Id: 0,
        LastName: '',
        FirstName: ''
      }
    },
    Invoice: {
      Number: '',
      Amount: ''
    }
  };
}), _types$SET_TECHNICIAN);

/***/ }),

/***/ 284:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = (function () {
  return {
    workOrder: null,
    technicians: []
  };
});

/***/ }),

/***/ 285:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api__ = __webpack_require__(11);





/* harmony default export */ __webpack_exports__["default"] = ({
  cancelNewMake: function cancelNewMake(_ref) {
    var commit = _ref.commit;

    commit('CANCEL_NEWMAKE');
  },
  setMakeActivation: function setMakeActivation(_ref2, data) {
    var commit = _ref2.commit;

    commit('SET_MAKEACTIVATION', data);
  },
  addMake: function addMake(_ref3, data) {
    var commit = _ref3.commit,
        state = _ref3.state;

    commit('ADD_MAKE', data);
  },
  setMake: function setMake(_ref4, data) {
    var commit = _ref4.commit,
        state = _ref4.state;

    commit('SET_MAKE', data);
  },
  getMakes: function getMakes(_ref5) {
    var _this = this;

    var commit = _ref5.commit,
        state = _ref5.state;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              state.makes = [];
              return _context.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].getMakes(true).then(function (response) {
                  commit('SET_MAKES', response.data);
                  resolve(response);
                });
              }));

            case 2:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  saveMakes: function saveMakes(_ref6, data) {
    var _this2 = this;

    var commit = _ref6.commit;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              return _context2.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].saveMakes(data, { headers: { 'content-type': 'application/json' } }).then(function (response) {
                  resolve(response);
                });
              }));

            case 1:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }))();
  }
});

/***/ }),

/***/ 286:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ({
  makes: function makes(state) {
    return state.makes;
  }
});

/***/ }),

/***/ 287:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__types__ = __webpack_require__(289);



var _types$CANCEL_NEWMAKE;


/* harmony default export */ __webpack_exports__["default"] = (_types$CANCEL_NEWMAKE = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$CANCEL_NEWMAKE, __WEBPACK_IMPORTED_MODULE_2__types__["CANCEL_NEWMAKE"], function (state) {
  state.makes = state.makes.filter(function (item) {
    return item.id !== 0;
  });
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$CANCEL_NEWMAKE, __WEBPACK_IMPORTED_MODULE_2__types__["SET_MAKEACTIVATION"], function (state, data) {
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(state.makes), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var item = _step.value;

      if (item.id === data.id) {
        item.isInactive = data.isInactive;
        item.isChanged = true;
        break;
      }
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$CANCEL_NEWMAKE, __WEBPACK_IMPORTED_MODULE_2__types__["ADD_MAKE"], function (state, make) {
  var cnt = 0;
  var _iteratorNormalCompletion2 = true;
  var _didIteratorError2 = false;
  var _iteratorError2 = undefined;

  try {
    for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(state.makes), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
      var item = _step2.value;

      if (item.id === 0) {
        cnt++;
      }
    }
  } catch (err) {
    _didIteratorError2 = true;
    _iteratorError2 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion2 && _iterator2.return) {
        _iterator2.return();
      }
    } finally {
      if (_didIteratorError2) {
        throw _iteratorError2;
      }
    }
  }

  if (cnt === 0) {
    state.makes.unshift(make);
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$CANCEL_NEWMAKE, __WEBPACK_IMPORTED_MODULE_2__types__["SET_MAKES"], function (state, data) {
  state.makes = [];
  if (data !== undefined && data !== null) {
    var _iteratorNormalCompletion3 = true;
    var _didIteratorError3 = false;
    var _iteratorError3 = undefined;

    try {
      for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(data), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
        var item = _step3.value;

        state.makes.push({
          id: item.id,
          make: item.make,
          isInactive: item.isInactive,
          isChanged: false
        });
      }
    } catch (err) {
      _didIteratorError3 = true;
      _iteratorError3 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion3 && _iterator3.return) {
          _iterator3.return();
        }
      } finally {
        if (_didIteratorError3) {
          throw _iteratorError3;
        }
      }
    }
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$CANCEL_NEWMAKE, __WEBPACK_IMPORTED_MODULE_2__types__["SET_MAKE"], function (state, data) {
  var _iteratorNormalCompletion4 = true;
  var _didIteratorError4 = false;
  var _iteratorError4 = undefined;

  try {
    for (var _iterator4 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(state.makes), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
      var item = _step4.value;

      if (item.id === data.id) {
        item.make = data.make;
        item.isChanged = true;
        break;
      }
    }
  } catch (err) {
    _didIteratorError4 = true;
    _iteratorError4 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion4 && _iterator4.return) {
        _iterator4.return();
      }
    } finally {
      if (_didIteratorError4) {
        throw _iteratorError4;
      }
    }
  }
}), _types$CANCEL_NEWMAKE);

/***/ }),

/***/ 288:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = (function () {
  return {
    makes: []
  };
});

/***/ }),

/***/ 289:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_MAKES", function() { return SET_MAKES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_MAKE", function() { return SET_MAKE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ADD_MAKE", function() { return ADD_MAKE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CANCEL_NEWMAKE", function() { return CANCEL_NEWMAKE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_MAKEACTIVATION", function() { return SET_MAKEACTIVATION; });
var SET_MAKES = 'SET_MAKES';
var SET_MAKE = 'SET_MAKE';
var ADD_MAKE = 'ADD_MAKE';
var CANCEL_NEWMAKE = 'CANCEL_NEWMAKE';
var SET_MAKEACTIVATION = 'SET_MAKEACTIVATION';

/***/ }),

/***/ 290:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api__ = __webpack_require__(11);





/* harmony default export */ __webpack_exports__["default"] = ({
  cancelNewMessage: function cancelNewMessage(_ref) {
    var commit = _ref.commit;

    commit('CANCEL_NEWMESSAGE');
  },
  setMessageActivation: function setMessageActivation(_ref2, data) {
    var commit = _ref2.commit;

    commit('SET_MESSAGEACTIVATION', data);
  },
  addMessage: function addMessage(_ref3, data) {
    var commit = _ref3.commit,
        state = _ref3.state;

    commit('ADD_MESSAGE', data);
  },
  setMessage: function setMessage(_ref4, data) {
    var commit = _ref4.commit,
        state = _ref4.state;

    commit('SET_MESSAGE', data);
  },
  getMessages: function getMessages(_ref5) {
    var _this = this;

    var commit = _ref5.commit,
        state = _ref5.state;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].lookup({ key: 'messages.precanned', showAll: true }, { headers: { 'content-type': 'application/json' } }).then(function (response) {
                  commit('SET_MESSAGES', response.data);
                  resolve(response);
                });
              }));

            case 1:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  saveMessages: function saveMessages(_ref6, data) {
    var _this2 = this;

    var commit = _ref6.commit;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              return _context2.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].savePreCannedMessages(data, { headers: { 'content-type': 'application/json' } }).then(function (response) {
                  resolve(response);
                });
              }));

            case 1:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }))();
  }
});

/***/ }),

/***/ 291:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ({
  messages: function messages(state) {
    return state.messages;
  }
});

/***/ }),

/***/ 292:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__types__ = __webpack_require__(294);



var _types$CANCEL_NEWMESS;


/* harmony default export */ __webpack_exports__["default"] = (_types$CANCEL_NEWMESS = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$CANCEL_NEWMESS, __WEBPACK_IMPORTED_MODULE_2__types__["CANCEL_NEWMESSAGE"], function (state) {
  state.messages = state.messages.filter(function (item) {
    return item.id !== 0;
  });
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$CANCEL_NEWMESS, __WEBPACK_IMPORTED_MODULE_2__types__["SET_MESSAGEACTIVATION"], function (state, data) {
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(state.messages), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var item = _step.value;

      if (item.id === data.id) {
        item.isActive = data.isActive;
        item.isChanged = true;
        break;
      }
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$CANCEL_NEWMESS, __WEBPACK_IMPORTED_MODULE_2__types__["ADD_MESSAGE"], function (state, message) {
  var cnt = 0;
  var _iteratorNormalCompletion2 = true;
  var _didIteratorError2 = false;
  var _iteratorError2 = undefined;

  try {
    for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(state.messages), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
      var item = _step2.value;

      if (item.id === 0) {
        cnt++;
      }
    }
  } catch (err) {
    _didIteratorError2 = true;
    _iteratorError2 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion2 && _iterator2.return) {
        _iterator2.return();
      }
    } finally {
      if (_didIteratorError2) {
        throw _iteratorError2;
      }
    }
  }

  if (cnt === 0) {
    state.messages.unshift(message);
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$CANCEL_NEWMESS, __WEBPACK_IMPORTED_MODULE_2__types__["SET_MESSAGES"], function (state, data) {
  state.messages = [];
  if (data !== undefined && data !== null) {
    var _iteratorNormalCompletion3 = true;
    var _didIteratorError3 = false;
    var _iteratorError3 = undefined;

    try {
      for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(data), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
        var item = _step3.value;

        state.messages.push({
          id: item.id,
          message: item.text,
          isActive: item.isActive,
          sortOrder: item.sortOrder,
          isChanged: false
        });
      }
    } catch (err) {
      _didIteratorError3 = true;
      _iteratorError3 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion3 && _iterator3.return) {
          _iterator3.return();
        }
      } finally {
        if (_didIteratorError3) {
          throw _iteratorError3;
        }
      }
    }
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$CANCEL_NEWMESS, __WEBPACK_IMPORTED_MODULE_2__types__["SET_MESSAGE"], function (state, data) {
  var _iteratorNormalCompletion4 = true;
  var _didIteratorError4 = false;
  var _iteratorError4 = undefined;

  try {
    for (var _iterator4 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(state.messages), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
      var item = _step4.value;

      if (item.id === data.id) {
        item.message = data.message;
        item.isChanged = true;
        break;
      }
    }
  } catch (err) {
    _didIteratorError4 = true;
    _iteratorError4 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion4 && _iterator4.return) {
        _iterator4.return();
      }
    } finally {
      if (_didIteratorError4) {
        throw _iteratorError4;
      }
    }
  }
}), _types$CANCEL_NEWMESS);

/***/ }),

/***/ 293:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = (function () {
  return {
    messages: []
  };
});

/***/ }),

/***/ 294:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_MESSAGES", function() { return SET_MESSAGES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_MESSAGE", function() { return SET_MESSAGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ADD_MESSAGE", function() { return ADD_MESSAGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CANCEL_NEWMESSAGE", function() { return CANCEL_NEWMESSAGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_MESSAGEACTIVATION", function() { return SET_MESSAGEACTIVATION; });
var SET_MESSAGES = 'SET_MESSAGES';
var SET_MESSAGE = 'SET_MESSAGE';
var ADD_MESSAGE = 'ADD_MESSAGE';
var CANCEL_NEWMESSAGE = 'CANCEL_NEWMESSAGE';
var SET_MESSAGEACTIVATION = 'SET_MESSAGEACTIVATION';

/***/ }),

/***/ 295:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__types__ = __webpack_require__(153);






/* harmony default export */ __webpack_exports__["default"] = ({
  getCalibrationHomepageMessage: function getCalibrationHomepageMessage(_ref) {
    var _this = this;

    var commit = _ref.commit,
        dispatch = _ref.dispatch;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].getCalibrationHomepageMessage().then(function (response) {
                  commit(__WEBPACK_IMPORTED_MODULE_4__types__["SET_CALIBRATION_HOMEPAGE_MESSAGE"], response.data);
                  resolve(response);
                });
              }));

            case 1:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  saveCalibrationHomepageMessage: function saveCalibrationHomepageMessage(_ref2, data) {
    var _this2 = this;

    var commit = _ref2.commit,
        state = _ref2.state;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              console.log('saveCalibrationHomepageMessage');

              return _context2.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                var request = {
                  Text: data.homepageMessage,
                  IsActive: data.isActive
                };

                __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].saveCalibrationHomepageMessage(request).then(function (response) {
                  resolve(response);
                });
              }));

            case 2:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }))();
  }
});

/***/ }),

/***/ 296:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ({
  calibrationHomepageMessage: function calibrationHomepageMessage(state) {
    return state.calibrationHomepageMessage;
  }

});

/***/ }),

/***/ 297:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__types__ = __webpack_require__(153);



/* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, __WEBPACK_IMPORTED_MODULE_1__types__["SET_CALIBRATION_HOMEPAGE_MESSAGE"], function (state, data) {
  state.calibrationHomepageMessage = data;
}));

/***/ }),

/***/ 298:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = (function () {
  return {
    calibrationHomepageMessage: null
  };
});

/***/ }),

/***/ 299:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__types__ = __webpack_require__(154);






/* harmony default export */ __webpack_exports__["default"] = ({
  setStandardOpeningHours: function setStandardOpeningHours(_ref, openingHours) {
    var commit = _ref.commit;

    commit(__WEBPACK_IMPORTED_MODULE_4__types__["SET_STANDARD_OPENING_HOURS"], openingHours);
  },
  setHolidayOpeningHours: function setHolidayOpeningHours(_ref2, openingHours) {
    var commit = _ref2.commit;

    commit(__WEBPACK_IMPORTED_MODULE_4__types__["SET_HOLIDAY_OPENING_HOURS"], openingHours);
  },
  getStandardOpeningHours: function getStandardOpeningHours(_ref3, tenantId) {
    var _this = this;

    var commit = _ref3.commit,
        dispatch = _ref3.dispatch;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].getStandardOpeningHours(tenantId).then(function (response) {
                  commit(__WEBPACK_IMPORTED_MODULE_4__types__["SET_STANDARD_OPENING_HOURS"], response.data);
                  resolve(response);
                });
              }));

            case 1:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  getHolidayOpeningHours: function getHolidayOpeningHours(_ref4, tenantId) {
    var _this2 = this;

    var commit = _ref4.commit,
        dispatch = _ref4.dispatch;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              return _context2.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].getHolidayOpeningHours(tenantId).then(function (response) {
                  commit(__WEBPACK_IMPORTED_MODULE_4__types__["SET_HOLIDAY_OPENING_HOURS"], response.data);
                  resolve(response);
                });
              }));

            case 1:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }))();
  },
  getStandardOpeningHoursForList: function getStandardOpeningHoursForList(_ref5) {
    var _this3 = this;

    var commit = _ref5.commit,
        dispatch = _ref5.dispatch;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              return _context3.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].getStandardOpeningHoursForList().then(function (response) {
                  commit(__WEBPACK_IMPORTED_MODULE_4__types__["SET_STANDARD_OPENING_HOURS"], response.data);
                  resolve(response);
                });
              }));

            case 1:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this3);
    }))();
  },
  getTenantDetails: function getTenantDetails(_ref6) {
    var _this4 = this;

    var commit = _ref6.commit,
        dispatch = _ref6.dispatch;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              return _context4.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].getTenantDetails().then(function (response) {
                  commit(__WEBPACK_IMPORTED_MODULE_4__types__["SET_TENANT_DETAILS"], response.data);
                  resolve(response);
                });
              }));

            case 1:
            case 'end':
              return _context4.stop();
          }
        }
      }, _callee4, _this4);
    }))();
  },
  setSelectedTenant: function setSelectedTenant(_ref7, tenantID) {
    var commit = _ref7.commit,
        state = _ref7.state;

    var tenantDetails = null;

    try {
      tenantDetails = typeof state.tenantDetails === 'string' ? JSON.parse(state.tenantDetails) : state.tenantDetails;
    } catch (error) {
      console.error('Invalid JSON structure:', error);
      return;
    }

    if (tenantDetails && Array.isArray(tenantDetails.Items)) {
      var tenant = tenantDetails.Items.find(function (t) {
        return t.ID === tenantID;
      });

      if (tenant) {
        commit(__WEBPACK_IMPORTED_MODULE_4__types__["SET_SELECTED_TENANT"], tenant);
      }
    }
  },
  updateTenantSupportEmail: function updateTenantSupportEmail(_ref8, data) {
    var _this5 = this;

    var commit = _ref8.commit;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              return _context5.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].updateTenantSupportEmail(data).then(function (response) {
                  commit(__WEBPACK_IMPORTED_MODULE_4__types__["SET_TENANT_DETAILS"], response.data);
                  resolve(response);
                });
              }));

            case 1:
            case 'end':
              return _context5.stop();
          }
        }
      }, _callee5, _this5);
    }))();
  },
  updateStandardOpeningHours: function updateStandardOpeningHours(_ref9, data) {
    var _this6 = this;

    var commit = _ref9.commit,
        dispatch = _ref9.dispatch;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              return _context6.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].updateStandardOpeningHours(data).then(function (response) {
                  commit(__WEBPACK_IMPORTED_MODULE_4__types__["SET_STANDARD_OPENING_HOURS"], response.data);
                  resolve(response);
                });
              }));

            case 1:
            case 'end':
              return _context6.stop();
          }
        }
      }, _callee6, _this6);
    }))();
  },
  updateHolidayOpeningHours: function updateHolidayOpeningHours(_ref10, data) {
    var _this7 = this;

    var commit = _ref10.commit,
        dispatch = _ref10.dispatch;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee7() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              return _context7.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].updateHolidayOpeningHours(data).then(function (response) {
                  commit(__WEBPACK_IMPORTED_MODULE_4__types__["SET_HOLIDAY_OPENING_HOURS"], response.data);
                  resolve(response);
                });
              }));

            case 1:
            case 'end':
              return _context7.stop();
          }
        }
      }, _callee7, _this7);
    }))();
  },
  insertHolidayOpeningHours: function insertHolidayOpeningHours(_ref11, data) {
    var _this8 = this;

    var commit = _ref11.commit,
        dispatch = _ref11.dispatch;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee8() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              return _context8.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].insertHolidayOpeningHours(data).then(function (response) {
                  commit(__WEBPACK_IMPORTED_MODULE_4__types__["SET_HOLIDAY_OPENING_HOURS"], response.data);
                  resolve(response);
                });
              }));

            case 1:
            case 'end':
              return _context8.stop();
          }
        }
      }, _callee8, _this8);
    }))();
  },
  deleteHolidaySchedule: function deleteHolidaySchedule(_ref12, data) {
    var _this9 = this;

    var commit = _ref12.commit,
        dispatch = _ref12.dispatch;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee9() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
        while (1) {
          switch (_context9.prev = _context9.next) {
            case 0:
              return _context9.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].deleteHolidaySchedule(data).then(function (response) {
                  commit(__WEBPACK_IMPORTED_MODULE_4__types__["SET_HOLIDAY_OPENING_HOURS"], response.data);
                  resolve(response);
                });
              }));

            case 1:
            case 'end':
              return _context9.stop();
          }
        }
      }, _callee9, _this9);
    }))();
  },
  getOutOfHoursAuditLog: function getOutOfHoursAuditLog(_ref13, searchOptions) {
    var _this10 = this;

    var commit = _ref13.commit,
        dispatch = _ref13.dispatch;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee10() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10) {
        while (1) {
          switch (_context10.prev = _context10.next) {
            case 0:
              return _context10.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].getOutOfHoursAuditLog(searchOptions).then(function (response) {
                  commit(__WEBPACK_IMPORTED_MODULE_4__types__["SET_OUT_OF_HOURS_AUDIT_LOG"], response.data);
                  resolve(response);
                });
              }));

            case 1:
            case 'end':
              return _context10.stop();
          }
        }
      }, _callee10, _this10);
    }))();
  },
  setPageSize: function setPageSize(_ref14, pageSize) {
    var commit = _ref14.commit;

    commit(__WEBPACK_IMPORTED_MODULE_4__types__["SET_PAGE_SIZE"], pageSize);
  },
  setSortDir: function setSortDir(_ref15, sortDir) {
    var commit = _ref15.commit;

    commit(__WEBPACK_IMPORTED_MODULE_4__types__["SET_SORT_DIR"], sortDir);
  },
  setOrderBy: function setOrderBy(_ref16, orderBy) {
    var commit = _ref16.commit;

    commit(__WEBPACK_IMPORTED_MODULE_4__types__["SET_ORDER_BY"], orderBy);
  }
});

/***/ }),

/***/ 300:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ({
  standardOpeningHours: function standardOpeningHours(state) {
    return state.standardOpeningHours;
  },
  holidayOpeningHours: function holidayOpeningHours(state) {
    return state.holidayOpeningHours;
  },
  tenantDetails: function tenantDetails(state) {
    return state.tenantDetails;
  },
  selectedTenant: function selectedTenant(state) {
    return state.selectedTenant;
  },
  totalLogEntries: function totalLogEntries(state) {
    return state.totalLogEntries;
  },
  outOfHoursAuditLog: function outOfHoursAuditLog(state) {
    return state.outOfHoursAuditLog;
  },
  sortDir: function sortDir(state) {
    return state.sortDir;
  },
  orderBy: function orderBy(state) {
    return state.orderBy;
  },
  pageSize: function pageSize(state) {
    return state.pageSize;
  }
});

/***/ }),

/***/ 301:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__types__ = __webpack_require__(154);


var _types$SET_STANDARD_O;



/* harmony default export */ __webpack_exports__["default"] = (_types$SET_STANDARD_O = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$SET_STANDARD_O, __WEBPACK_IMPORTED_MODULE_1__types__["SET_STANDARD_OPENING_HOURS"], function (state, value) {
  if (value !== undefined && value !== null) {
    state.standardOpeningHours = value;
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$SET_STANDARD_O, __WEBPACK_IMPORTED_MODULE_1__types__["SET_HOLIDAY_OPENING_HOURS"], function (state, value) {
  if (value !== undefined && value !== null) {
    state.holidayOpeningHours = value;
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$SET_STANDARD_O, __WEBPACK_IMPORTED_MODULE_1__types__["SET_TENANT_DETAILS"], function (state, value) {
  if (value !== undefined && value !== null) {
    state.tenantDetails = value;
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$SET_STANDARD_O, __WEBPACK_IMPORTED_MODULE_1__types__["SET_SELECTED_TENANT"], function (state, tenant) {
  state.selectedTenant = tenant;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$SET_STANDARD_O, __WEBPACK_IMPORTED_MODULE_1__types__["UPDATE_TENANT_SUPPORT_EMAIL"], function (state, _ref) {
  var tenantID = _ref.tenantID,
      email = _ref.email;

  var tenants = JSON.parse(state.tenantDetails);
  var tenant = tenants.find(function (t) {
    return t.ID === tenantID;
  });
  if (tenant) {
    tenant.SupportEmail = email;
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$SET_STANDARD_O, __WEBPACK_IMPORTED_MODULE_1__types__["SET_SORT_DIR"], function (state, text) {
  if (text !== undefined && text !== null) {
    state.sortDir = text;
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$SET_STANDARD_O, __WEBPACK_IMPORTED_MODULE_1__types__["SET_ORDER_BY"], function (state, text) {
  if (text !== undefined && text !== null) {
    state.orderBy = text;
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$SET_STANDARD_O, __WEBPACK_IMPORTED_MODULE_1__types__["SET_OUT_OF_HOURS_AUDIT_LOG"], function (state, data) {
  state.totalLogEntries = 0;
  state.outOfHoursAuditLog = [];
  if (data !== undefined && data !== null) {
    if (data.length > 0) {
      state.totalLogEntries = data[0].TotalItems;
      state.outOfHoursAuditLog = data;
    }
  }
}), _types$SET_STANDARD_O);

/***/ }),

/***/ 302:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = (function () {
  return {
    standardOpeningHours: '',
    holidayOpeningHours: '',
    tenantDetails: '',
    selectedTenant: null,
    totalLogEntries: 0,
    outOfHoursAuditLog: [],
    sortDir: '',
    orderBy: '',
    pageSize: 10
  };
});

/***/ }),

/***/ 303:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api__ = __webpack_require__(11);





/* harmony default export */ __webpack_exports__["default"] = ({
  addScanTool: function addScanTool(_ref, data) {
    var commit = _ref.commit,
        state = _ref.state;

    commit('ADD_SCANTOOL', data);
  },
  setScanTool: function setScanTool(_ref2, data) {
    var commit = _ref2.commit,
        state = _ref2.state;

    commit('SET_SCANTOOL', data);
  },
  cancelNewScanTool: function cancelNewScanTool(_ref3) {
    var commit = _ref3.commit;

    commit('CANCEL_NEWSCANTOOL');
  },
  addReportTemplate: function addReportTemplate(_ref4, data) {
    var commit = _ref4.commit,
        state = _ref4.state;

    commit('ADD_REPORT_TEMPLATE', data);
  },
  setReportTemplate: function setReportTemplate(_ref5, data) {
    var commit = _ref5.commit,
        state = _ref5.state;

    commit('SET_REPORT_TEMPLATE', data);
  },
  cancelNewReportTemplate: function cancelNewReportTemplate(_ref6) {
    var commit = _ref6.commit;

    commit('CANCEL_NEWREPORTTEMPLATE');
  },
  getScanTools: function getScanTools(_ref7) {
    var _this = this;

    var commit = _ref7.commit;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].getScanTools().then(function (response) {
                  commit('SET_SCANTOOLS', response.data);
                  resolve(response);
                });
              }));

            case 1:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  saveScanTool: function saveScanTool(_ref8) {
    var _this2 = this;

    var commit = _ref8.commit,
        state = _ref8.state;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              state.scantools.forEach(function (scantool) {
                if (scantool.isChanged) {
                  return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                    __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].saveScanTool(scantool, { headers: { 'content-type': 'application/json' } }).then(function (response) {
                      commit('SET_SCANTOOL', {
                        id: 0,
                        name: 'id',
                        value: response.data
                      });
                      scantool.isChanged = false;
                      resolve(response);
                    });
                  });
                }
              });

            case 1:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }))();
  },
  removeScanTool: function removeScanTool(_ref9, id) {
    var _this3 = this;

    var commit = _ref9.commit;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              return _context3.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].removeScanTool(id).then(function (response) {
                  resolve(response);
                });
              }));

            case 1:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this3);
    }))();
  },
  getReportTemplates: function getReportTemplates(_ref10, area) {
    var _this4 = this;

    var commit = _ref10.commit;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              return _context4.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].getReportTemplates(area).then(function (response) {
                  commit('SET_REPORT_TEMPLATES', response.data);
                  resolve(response);
                });
              }));

            case 1:
            case 'end':
              return _context4.stop();
          }
        }
      }, _callee4, _this4);
    }))();
  },
  saveReportTemplate: function saveReportTemplate(_ref11, data) {
    var _this5 = this;

    var commit = _ref11.commit,
        state = _ref11.state;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              state.reportTemplates.forEach(function (reportTemplate) {
                if (reportTemplate.isChanged) {
                  console.log('Saving Report Template', reportTemplate);
                  return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                    __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].saveReportTemplate(reportTemplate, { headers: { 'content-type': 'application/json' } }).then(function (response) {
                      console.log('Saved Report Template', response.data);
                      commit('SET_REPORT_TEMPLATE', {
                        id: 0,
                        name: 'id',
                        value: response.data
                      });
                      reportTemplate.isChanged = false;
                      resolve(response);
                    });
                  });
                }
              });

            case 1:
            case 'end':
              return _context5.stop();
          }
        }
      }, _callee5, _this5);
    }))();
  },
  removeReportTemplate: function removeReportTemplate(_ref12, id) {
    var _this6 = this;

    var commit = _ref12.commit;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              return _context6.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].removeReportTemplate(id).then(function (response) {
                  resolve(response);
                });
              }));

            case 1:
            case 'end':
              return _context6.stop();
          }
        }
      }, _callee6, _this6);
    }))();
  },
  saveTechInfo: function saveTechInfo(_ref13, tech) {
    var commit = _ref13.commit;

    commit('SAVE_TECH_INFO', tech);
  }
});

/***/ }),

/***/ 304:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ({
  scantools: function scantools(state) {
    return state.scantools;
  },
  reportTemplates: function reportTemplates(state) {
    return state.reportTemplates;
  },
  areas: function areas(state) {
    return state.areas;
  },
  apps: function apps(state) {
    return state.apps;
  },
  techInfo: function techInfo(state) {
    return state.techInfo;
  }
});

/***/ }),

/***/ 305:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__types__ = __webpack_require__(307);




var _types$CANCEL_NEWSCAN;


/* harmony default export */ __webpack_exports__["default"] = (_types$CANCEL_NEWSCAN = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$CANCEL_NEWSCAN, __WEBPACK_IMPORTED_MODULE_3__types__["CANCEL_NEWSCANTOOL"], function (state) {
  state.scantools = state.scantools.filter(function (item) {
    return item.id !== 0;
  });
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$CANCEL_NEWSCAN, __WEBPACK_IMPORTED_MODULE_3__types__["ADD_SCANTOOL"], function (state, scantool) {
  var cnt = 0;
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(state.scantools), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var item = _step.value;

      if (item.id === 0) {
        cnt++;
      }
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  if (cnt === 0) {
    state.scantools.unshift(scantool);
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$CANCEL_NEWSCAN, __WEBPACK_IMPORTED_MODULE_3__types__["SET_SCANTOOLS"], function (state, data) {
  state.scantools = [];
  if (data !== undefined && data !== null) {
    var _iteratorNormalCompletion2 = true;
    var _didIteratorError2 = false;
    var _iteratorError2 = undefined;

    try {
      for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(data), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
        var item = _step2.value;

        state.scantools.push({
          id: item.id,
          name: item.name,
          makeId: item.makeId,
          isSWS: item.isSWS,
          swsMakeId: item.swsMakeId,
          appId: item.appId,
          isInactive: item.isInactive,
          isChanged: false
        });
      }
    } catch (err) {
      _didIteratorError2 = true;
      _iteratorError2 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion2 && _iterator2.return) {
          _iterator2.return();
        }
      } finally {
        if (_didIteratorError2) {
          throw _iteratorError2;
        }
      }
    }
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$CANCEL_NEWSCAN, __WEBPACK_IMPORTED_MODULE_3__types__["SET_SCANTOOL"], function (state, data) {
  if (state.scantools !== null && data !== null) {
    var _iteratorNormalCompletion3 = true;
    var _didIteratorError3 = false;
    var _iteratorError3 = undefined;

    try {
      for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(state.scantools), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
        var item = _step3.value;

        if (item.id === data.id) {
          item[data.name] = data.value;
          if (item.name === 'id') {
            item.isChanged = false;
          } else {
            item.isChanged = true;
          }
          break;
        }
      }
    } catch (err) {
      _didIteratorError3 = true;
      _iteratorError3 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion3 && _iterator3.return) {
          _iterator3.return();
        }
      } finally {
        if (_didIteratorError3) {
          throw _iteratorError3;
        }
      }
    }
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$CANCEL_NEWSCAN, __WEBPACK_IMPORTED_MODULE_3__types__["CANCEL_NEWREPORTTEMPLATE"], function (state) {
  state.reportTemplates = state.reportTemplates.filter(function (item) {
    return item.id !== 0;
  });
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$CANCEL_NEWSCAN, __WEBPACK_IMPORTED_MODULE_3__types__["ADD_REPORT_TEMPLATE"], function (state, template) {
  var cnt = 0;
  var _iteratorNormalCompletion4 = true;
  var _didIteratorError4 = false;
  var _iteratorError4 = undefined;

  try {
    for (var _iterator4 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(state.reportTemplates), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
      var item = _step4.value;

      if (item.id === 0) {
        cnt++;
      }
    }
  } catch (err) {
    _didIteratorError4 = true;
    _iteratorError4 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion4 && _iterator4.return) {
        _iterator4.return();
      }
    } finally {
      if (_didIteratorError4) {
        throw _iteratorError4;
      }
    }
  }

  if (cnt === 0) {
    state.reportTemplates.unshift(template);
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$CANCEL_NEWSCAN, __WEBPACK_IMPORTED_MODULE_3__types__["SET_REPORT_TEMPLATES"], function (state, data) {
  state.reportTemplates = [];
  if (data !== undefined && data !== null) {
    var _iteratorNormalCompletion5 = true;
    var _didIteratorError5 = false;
    var _iteratorError5 = undefined;

    try {
      for (var _iterator5 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(data), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
        var item = _step5.value;

        state.reportTemplates.push({
          id: item.id,
          area: item.area,
          productId: item.productId,
          order: item.order,
          isSWS: item.isSWS,
          swsMakeId: item.swsMakeId,
          template: item.template,
          appId: item.appId,
          isInactive: item.isInactive,
          isAdd: item.isAdd,
          isChanged: false
        });
      }
    } catch (err) {
      _didIteratorError5 = true;
      _iteratorError5 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion5 && _iterator5.return) {
          _iterator5.return();
        }
      } finally {
        if (_didIteratorError5) {
          throw _iteratorError5;
        }
      }
    }
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$CANCEL_NEWSCAN, __WEBPACK_IMPORTED_MODULE_3__types__["SET_REPORT_TEMPLATE"], function (state, data) {
  if (state.reportTemplates !== null && data !== null) {
    var _iteratorNormalCompletion6 = true;
    var _didIteratorError6 = false;
    var _iteratorError6 = undefined;

    try {
      for (var _iterator6 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(state.reportTemplates), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
        var item = _step6.value;

        if (item.id === data.id) {
          item[data.name] = data.value;
          if (item.name === 'id') {
            item.isChanged = false;
          } else {
            item.isChanged = true;
          }
          break;
        }
      }
    } catch (err) {
      _didIteratorError6 = true;
      _iteratorError6 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion6 && _iterator6.return) {
          _iterator6.return();
        }
      } finally {
        if (_didIteratorError6) {
          throw _iteratorError6;
        }
      }
    }
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$CANCEL_NEWSCAN, __WEBPACK_IMPORTED_MODULE_3__types__["SAVE_TECH_INFO"], function (state, tech) {
  localStorage.setItem('techInfo', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(tech));
}), _types$CANCEL_NEWSCAN);

/***/ }),

/***/ 306:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = (function () {
  return {
    scantools: [],
    reportTemplates: [],
    apps: [{
      id: 0,
      name: 'All'
    }, {
      id: 1,
      name: 'UK/Europe'
    }, {
      id: 2,
      name: 'Glass US/Canada'
    }, {
      id: 4,
      name: 'Calibration US/Canada'
    }, {
      id: 5,
      name: 'ProTech'
    }],
    areas: [{
      id: 0,
      name: 'Service Details'
    }, {
      id: 1,
      name: 'Recommendations'
    }, {
      id: 2,
      name: 'Scan Readings'
    }, {
      id: 3,
      name: 'Snapshot Data'
    }],
    techInfo: JSON.parse(localStorage.getItem('techInfo'))
  };
});

/***/ }),

/***/ 307:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CANCEL_NEWSCANTOOL", function() { return CANCEL_NEWSCANTOOL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ADD_SCANTOOL", function() { return ADD_SCANTOOL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_SCANTOOLS", function() { return SET_SCANTOOLS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_SCANTOOL", function() { return SET_SCANTOOL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CANCEL_NEWREPORTTEMPLATE", function() { return CANCEL_NEWREPORTTEMPLATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ADD_REPORT_TEMPLATE", function() { return ADD_REPORT_TEMPLATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_REPORT_TEMPLATES", function() { return SET_REPORT_TEMPLATES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_REPORT_TEMPLATE", function() { return SET_REPORT_TEMPLATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SAVE_TECH_INFO", function() { return SAVE_TECH_INFO; });
var CANCEL_NEWSCANTOOL = 'CANCEL_NEWSCANTOOL';
var ADD_SCANTOOL = 'ADD_SCANTOOL';
var SET_SCANTOOLS = 'SET_SCANTOOLS';
var SET_SCANTOOL = 'SET_SCANTOOL';
var CANCEL_NEWREPORTTEMPLATE = 'CANCEL_NEWREPORTTEMPLATE';
var ADD_REPORT_TEMPLATE = 'ADD_REPORT_TEMPLATE';
var SET_REPORT_TEMPLATES = 'SET_REPORT_TEMPLATES';
var SET_REPORT_TEMPLATE = 'SET_REPORT_TEMPLATE';
var SAVE_TECH_INFO = 'SAVE_TECH_INFO';

/***/ }),

/***/ 308:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__types__ = __webpack_require__(155);






/* harmony default export */ __webpack_exports__["default"] = ({
  resetVisitedStep: function resetVisitedStep(_ref, value) {
    var commit = _ref.commit;

    commit(__WEBPACK_IMPORTED_MODULE_4__types__["RESET_VISITED_STEP"], value);
  },
  selectSubmodel: function selectSubmodel(_ref2, id) {
    var commit = _ref2.commit;

    commit(__WEBPACK_IMPORTED_MODULE_4__types__["SET_VEHICLE"], id);
  },
  resetSubmodels: function resetSubmodels(_ref3) {
    var commit = _ref3.commit;

    commit(__WEBPACK_IMPORTED_MODULE_4__types__["RESET_SUBMODELS"]);
  },
  setSelectedChecklistItems: function setSelectedChecklistItems(_ref4, data) {
    var commit = _ref4.commit;

    commit(__WEBPACK_IMPORTED_MODULE_4__types__["SET_SELECTED_CHECKLIST_ITEMS"], data);
  },
  setScanProChecklist: function setScanProChecklist(_ref5, data) {
    var commit = _ref5.commit;

    commit(__WEBPACK_IMPORTED_MODULE_4__types__["SET_SCANPRO_CHECKLIST"], data);
  },
  setScanProCriteria: function setScanProCriteria(_ref6, data) {
    var commit = _ref6.commit;

    commit(__WEBPACK_IMPORTED_MODULE_4__types__["SET_SCANPRO_CRITERIA"], data);
  },
  setCriteriaChanged: function setCriteriaChanged(_ref7, value) {
    var commit = _ref7.commit;

    commit(__WEBPACK_IMPORTED_MODULE_4__types__["SET_CRITERIA_CHANGED"], value);
  },
  setCorporateId: function setCorporateId(_ref8, id) {
    var commit = _ref8.commit;

    commit(__WEBPACK_IMPORTED_MODULE_4__types__["SET_CORPORATE_ID"], id);
  },
  setStep: function setStep(_ref9, value) {
    var _this = this;

    var commit = _ref9.commit,
        state = _ref9.state,
        dispatch = _ref9.dispatch;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var data;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              state.isLoading = true;
              if (value !== 99) {
                commit(__WEBPACK_IMPORTED_MODULE_4__types__["SET_STEP"], value);
                commit(__WEBPACK_IMPORTED_MODULE_4__types__["SET_VISITED_STEP"], value);
                state.isLoading = false;
              }

              if (!state.criteriaChanged) {
                _context.next = 5;
                break;
              }

              data = {
                businessId: state.corporateId,
                criteria: state.scanProCriteria,
                checklist: state.scanProChecklist
              };
              return _context.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].saveScanProConfiguration(data).then(function (response) {
                  resolve(response);
                  commit(__WEBPACK_IMPORTED_MODULE_4__types__["SET_CRITERIA_CHANGED"], false);
                  state.isLoading = false;
                });
              }));

            case 5:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  getScanProConfiguration: function getScanProConfiguration(_ref10) {
    var _this2 = this;

    var commit = _ref10.commit,
        state = _ref10.state;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              state.isLoading = true;
              return _context2.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].getScanProConfiguration(state.corporateId).then(function (response) {
                  state.isLoading = false;
                  commit(__WEBPACK_IMPORTED_MODULE_4__types__["SET_SCANPRO_CONFIGURATION"], response.data);
                  resolve(response);
                });
              }));

            case 2:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }))();
  },
  decodeVin: function decodeVin(_ref11, vin) {
    var _this3 = this;

    var commit = _ref11.commit,
        state = _ref11.state;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              state.isLoading = true;
              return _context3.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].decodeVin(vin).then(function (response) {
                  commit(__WEBPACK_IMPORTED_MODULE_4__types__["SET_DECODED_VIN"], { data: response.data, vin: vin });
                  resolve(response);
                  state.isLoading = false;
                });
              }));

            case 2:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this3);
    }))();
  },
  evaluateVehicle: function evaluateVehicle(_ref12, data) {
    var _this4 = this;

    var commit = _ref12.commit,
        state = _ref12.state;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              state.isLoading = true;
              return _context4.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].evaluateVehicle(data).then(function (response) {
                  resolve(response);
                  commit(__WEBPACK_IMPORTED_MODULE_4__types__["SET_RECOMMENDATION"], response.data);
                  state.isLoading = false;
                });
              }));

            case 2:
            case 'end':
              return _context4.stop();
          }
        }
      }, _callee4, _this4);
    }))();
  },
  saveScanProResults: function saveScanProResults(_ref13, data) {
    var _this5 = this;

    var commit = _ref13.commit,
        state = _ref13.state;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              state.isLoading = true;
              return _context5.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].saveScanProResults(data).then(function (response) {
                  resolve(response);
                  state.isLoading = false;
                });
              }));

            case 2:
            case 'end':
              return _context5.stop();
          }
        }
      }, _callee5, _this5);
    }))();
  }
});

/***/ }),

/***/ 309:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ({
  step: function step(state) {
    return state.step;
  },
  visitedStep: function visitedStep(state) {
    return state.visitedStep;
  },
  scanproConfiguration: function scanproConfiguration(state) {
    return state.scanproConfiguration;
  },
  scanProChecklist: function scanProChecklist(state) {
    return state.scanProChecklist;
  },
  scanProCriteria: function scanProCriteria(state) {
    return state.scanProCriteria;
  },
  criteriaChanged: function criteriaChanged(state) {
    return state.criteriaChanged;
  },
  vin: function vin(state) {
    return state.vin;
  },
  decodedVin: function decodedVin(state) {
    return state.decodedVin;
  },
  isDecoded: function isDecoded(state) {
    return state.isDecoded;
  },
  isSubmodelSelected: function isSubmodelSelected(state) {
    return state.isSubmodelSelected;
  },
  submodels: function submodels(state) {
    return state.submodels;
  },
  vehicle: function vehicle(state) {
    return state.vehicle;
  },
  recommendation: function recommendation(state) {
    return state.recommendation;
  },
  safety: function safety(state) {
    return state.safety;
  },
  selectedChecklistItems: function selectedChecklistItems(state) {
    return state.selectedChecklistItems;
  },
  isLoading: function isLoading(state) {
    return state.isLoading;
  },
  corporateId: function corporateId(state) {
    return state.corporateId;
  }
});

/***/ }),

/***/ 310:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__types__ = __webpack_require__(155);




var _types$SET_STEP$types;



/* harmony default export */ __webpack_exports__["default"] = (_types$SET_STEP$types = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$SET_STEP$types, __WEBPACK_IMPORTED_MODULE_3__types__["SET_STEP"], function (state, data) {
  state.step = data;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$SET_STEP$types, __WEBPACK_IMPORTED_MODULE_3__types__["RESET_VISITED_STEP"], function (state, data) {
  state.visitedStep = data;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$SET_STEP$types, __WEBPACK_IMPORTED_MODULE_3__types__["SET_VISITED_STEP"], function (state, currentStep) {
  state.visitedStep = currentStep > state.visitedStep ? currentStep : state.visitedStep;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$SET_STEP$types, __WEBPACK_IMPORTED_MODULE_3__types__["SET_CRITERIA_CHANGED"], function (state, value) {
  state.criteriaChanged = value;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$SET_STEP$types, __WEBPACK_IMPORTED_MODULE_3__types__["RESET_SUBMODELS"], function (state) {
  state.isSubmodelSelected = false;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$SET_STEP$types, __WEBPACK_IMPORTED_MODULE_3__types__["SET_CORPORATE_ID"], function (state, id) {
  state.corporateId = id;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$SET_STEP$types, __WEBPACK_IMPORTED_MODULE_3__types__["SET_SCANPRO_CONFIGURATION"], function (state, data) {
  state.isLoading = false;
  state.scanproConfiguration = data;
  state.scanProChecklist = [];
  state.scanProCriteria = [];
  console.log('ScanPro Configuration', data);

  if (data !== undefined && data !== null) {
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(data), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var item = _step.value;

        if (item.criteriaDetail !== null) {
          state.scanProCriteria.push({
            id: item.scanProId,
            value: item.criteriaDetail,
            selected: true,
            changed: false
          });
        } else {
          state.scanProChecklist.push({
            id: item.scanProId,
            value: item.scanProCriteria,
            selected: true,
            changed: false
          });
        }
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$SET_STEP$types, __WEBPACK_IMPORTED_MODULE_3__types__["SET_SCANPRO_CHECKLIST"], function (state, data) {
  state.scanProChecklist = JSON.parse(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(data));
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$SET_STEP$types, __WEBPACK_IMPORTED_MODULE_3__types__["SET_SCANPRO_CRITERIA"], function (state, data) {
  state.scanProCriteria = JSON.parse(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(data));
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$SET_STEP$types, __WEBPACK_IMPORTED_MODULE_3__types__["SET_DECODED_VIN"], function (state, _ref) {
  var data = _ref.data,
      vin = _ref.vin;

  state.safety = null;
  state.decodedVin = null;
  state.isDecoded = false;
  state.submodels = [];
  state.isSubmodelSelected = false;
  state.vehicle = null;
  state.vin = vin;
  try {
    state.submodels.push({
      value: 0,
      name: ''
    });
    if (data.decoder_messages.decoder_errors.length === 0) {
      state.decodedVin = data;
      state.isDecoded = true;
      var styles = data.query_responses.Request_Result.us_market_data.us_styles;
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(styles), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var style = _step2.value;

          state.submodels.push({
            value: style.vehicle_id,
            name: style.name
          });
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }
    }
  } catch (e) {}
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$SET_STEP$types, __WEBPACK_IMPORTED_MODULE_3__types__["SET_VEHICLE"], function (state, id) {
  state.vehicle = null;
  state.safety = null;
  var _iteratorNormalCompletion3 = true;
  var _didIteratorError3 = false;
  var _iteratorError3 = undefined;

  try {
    for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(state.decodedVin.query_responses.Request_Result.us_market_data.us_styles), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
      var style = _step3.value;

      if (style.vehicle_id === id) {
        state.vehicle = style;
        state.isSubmodelSelected = true;
        break;
      }
    }
  } catch (err) {
    _didIteratorError3 = true;
    _iteratorError3 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion3 && _iterator3.return) {
        _iterator3.return();
      }
    } finally {
      if (_didIteratorError3) {
        throw _iteratorError3;
      }
    }
  }

  if (state.vehicle !== null) {}
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$SET_STEP$types, __WEBPACK_IMPORTED_MODULE_3__types__["SET_RECOMMENDATION"], function (state, data) {
  state.recommendation = data;
  state.safety = [];
  var idx = 0;
  if (data !== undefined && data !== null) {
    if (data.scanRecommendation !== undefined && data.scanRecommendation !== null) {
      if (data.scanRecommendation.safetyFeatures !== undefined && data.scanRecommendation.safetyFeatures !== null) {
        var _iteratorNormalCompletion4 = true;
        var _didIteratorError4 = false;
        var _iteratorError4 = undefined;

        try {
          for (var _iterator4 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(data.scanRecommendation.safetyFeatures), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
            var item = _step4.value;

            idx++;
            state.safety.push({
              id: idx,
              name: item
            });
          }
        } catch (err) {
          _didIteratorError4 = true;
          _iteratorError4 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion4 && _iterator4.return) {
              _iterator4.return();
            }
          } finally {
            if (_didIteratorError4) {
              throw _iteratorError4;
            }
          }
        }
      }
    }
  }
  console.log('Eval Recommendation', { recommendation: state.recommendation, safety: state.safety });
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$SET_STEP$types, __WEBPACK_IMPORTED_MODULE_3__types__["SET_SELECTED_CHECKLIST_ITEMS"], function (state, data) {
  state.selectedChecklistItems = data;
}), _types$SET_STEP$types);

/***/ }),

/***/ 311:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = (function () {
  return {
    step: 1,
    visitedStep: 1,
    scanproConfiguration: null,
    scanProChecklist: [],
    scanProCriteria: [],
    criteriaChanged: false,
    isDecoded: false,
    vin: '',
    decodedVin: null,
    isSubmodelSelected: false,
    submodels: [],
    vehicle: null,
    recommendation: null,
    safety: null,
    selectedChecklistItems: [],
    isLoading: false,
    corporateId: 49
  };
});

/***/ }),

/***/ 312:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__types__ = __webpack_require__(156);






/* harmony default export */ __webpack_exports__["default"] = ({
  setSearchTerm: function setSearchTerm(_ref, text) {
    var commit = _ref.commit;

    commit(__WEBPACK_IMPORTED_MODULE_4__types__["SET_SEARCH_TERM"], text);
  },
  setPageSize: function setPageSize(_ref2, pageSize) {
    var commit = _ref2.commit;

    commit(__WEBPACK_IMPORTED_MODULE_4__types__["SET_PAGE_SIZE"], pageSize);
  },
  setSortDir: function setSortDir(_ref3, sortDir) {
    var commit = _ref3.commit;

    commit(__WEBPACK_IMPORTED_MODULE_4__types__["SET_SORT_DIR"], sortDir);
  },
  setOrderBy: function setOrderBy(_ref4, orderBy) {
    var commit = _ref4.commit;

    commit(__WEBPACK_IMPORTED_MODULE_4__types__["SET_ORDER_BY"], orderBy);
  },
  setStatus: function setStatus(_ref5, status) {
    var commit = _ref5.commit;

    commit(__WEBPACK_IMPORTED_MODULE_4__types__["SET_STATUS"], status);
  },
  setFilterBy: function setFilterBy(_ref6, filterBy) {
    var commit = _ref6.commit;

    commit(__WEBPACK_IMPORTED_MODULE_4__types__["SET_FILTER_BY"], filterBy);
  },
  getServiceRequests: function getServiceRequests(_ref7, searchOptions) {
    var _this = this;

    var commit = _ref7.commit,
        dispatch = _ref7.dispatch;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].getServiceRequests(searchOptions).then(function (response) {
                  commit(__WEBPACK_IMPORTED_MODULE_4__types__["SET_SERVICE_REQUESTS"], response.data);
                  resolve(response);
                });
              }));

            case 1:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  backDateServiceRequest: function backDateServiceRequest(_ref8, workOrder) {
    var _this2 = this;

    var commit = _ref8.commit,
        dispatch = _ref8.dispatch;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              return _context2.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].backDateServiceRequest(workOrder).then(function (response) {
                  resolve(response);
                });
              }));

            case 1:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }))();
  },
  getServiceRequestsForList: function getServiceRequestsForList(_ref9, searchOptions) {
    var _this3 = this;

    var commit = _ref9.commit,
        dispatch = _ref9.dispatch;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              return _context3.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].getServiceRequestsForList(searchOptions).then(function (response) {
                  commit(__WEBPACK_IMPORTED_MODULE_4__types__["SET_SERVICE_REQUESTS"], response.data);
                  resolve(response);
                });
              }));

            case 1:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this3);
    }))();
  },
  getServiceRequest: function getServiceRequest(_ref10, id) {
    var _this4 = this;

    var commit = _ref10.commit,
        dispatch = _ref10.dispatch;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              return _context4.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].getServiceRequest(id).then(function (response) {
                  commit(__WEBPACK_IMPORTED_MODULE_4__types__["SET_SERVICE_REQUEST"], response.data);
                  resolve(response);
                });
              }));

            case 1:
            case 'end':
              return _context4.stop();
          }
        }
      }, _callee4, _this4);
    }))();
  },
  getServiceRequestHistory: function getServiceRequestHistory(_ref11, id) {
    var _this5 = this;

    var commit = _ref11.commit,
        dispatch = _ref11.dispatch;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              return _context5.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].getServiceRequestHistory(id).then(function (response) {
                  commit(__WEBPACK_IMPORTED_MODULE_4__types__["SET_SERVICE_REQUEST_HISTORY"], response.data);
                  resolve(response);
                });
              }));

            case 1:
            case 'end':
              return _context5.stop();
          }
        }
      }, _callee5, _this5);
    }))();
  },
  getServiceRequestIssues: function getServiceRequestIssues(_ref12, id) {
    var _this6 = this;

    var commit = _ref12.commit,
        dispatch = _ref12.dispatch;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              return _context6.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].getServiceRequestIssues(id).then(function (response) {
                  commit(__WEBPACK_IMPORTED_MODULE_4__types__["SET_SERVICE_REQUEST_ISSUES"], response.data);
                  resolve(response);
                });
              }));

            case 1:
            case 'end':
              return _context6.stop();
          }
        }
      }, _callee6, _this6);
    }))();
  }
});

/***/ }),

/***/ 313:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ({
  searchTerm: function searchTerm(state) {
    return state.searchTerm;
  },
  pageSize: function pageSize(state) {
    return state.pageSize;
  },
  sortDir: function sortDir(state) {
    return state.sortDir;
  },
  orderBy: function orderBy(state) {
    return state.orderBy;
  },
  status: function status(state) {
    return state.status;
  },
  filterBy: function filterBy(state) {
    return state.filterBy;
  },
  serviceRequest: function serviceRequest(state) {
    return state.serviceRequest;
  },
  serviceRequests: function serviceRequests(state) {
    return state.serviceRequests;
  },
  requestHistory: function requestHistory(state) {
    return state.requestHistory;
  },
  issues: function issues(state) {
    return state.issues;
  }
});

/***/ }),

/***/ 314:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__types__ = __webpack_require__(156);


var _types$SET_SEARCH_TER;



/* harmony default export */ __webpack_exports__["default"] = (_types$SET_SEARCH_TER = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$SET_SEARCH_TER, __WEBPACK_IMPORTED_MODULE_1__types__["SET_SEARCH_TERM"], function (state, text) {
  if (text !== undefined && text !== null) {
    state.searchTerm = text;
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$SET_SEARCH_TER, __WEBPACK_IMPORTED_MODULE_1__types__["SET_PAGE_SIZE"], function (state, value) {
  if (value !== undefined && value !== null) {
    state.pageSize = parseInt(value);
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$SET_SEARCH_TER, __WEBPACK_IMPORTED_MODULE_1__types__["SET_SORT_DIR"], function (state, text) {
  if (text !== undefined && text !== null) {
    state.sortDir = text;
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$SET_SEARCH_TER, __WEBPACK_IMPORTED_MODULE_1__types__["SET_ORDER_BY"], function (state, text) {
  if (text !== undefined && text !== null) {
    state.orderBy = text;
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$SET_SEARCH_TER, __WEBPACK_IMPORTED_MODULE_1__types__["SET_STATUS"], function (state, value) {
  if (value !== undefined && value !== null) {
    state.status = value;
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$SET_SEARCH_TER, __WEBPACK_IMPORTED_MODULE_1__types__["SET_FILTER_BY"], function (state, value) {
  if (value !== undefined && value !== null) {
    state.filterBy = parseInt(value);
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$SET_SEARCH_TER, __WEBPACK_IMPORTED_MODULE_1__types__["SET_SERVICE_REQUEST"], function (state, data) {
  state.serviceRequest = null;
  if (data !== undefined && data !== null) {
    if (Array.isArray(data)) {
      state.serviceRequest = data[0];
    } else {
      state.serviceRequest = data;
    }
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$SET_SEARCH_TER, __WEBPACK_IMPORTED_MODULE_1__types__["SET_SERVICE_REQUESTS"], function (state, data) {
  state.serviceRequests = { count: 0, items: [] };
  if (data !== undefined && data !== null) {
    if (data.count === null) {
      data.count = 0;
    }
    if (data.items === null) {
      data.items = [];
    }
    state.serviceRequests = data;
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$SET_SEARCH_TER, __WEBPACK_IMPORTED_MODULE_1__types__["SET_SERVICE_REQUEST_HISTORY"], function (state, data) {
  state.requestHistory = data;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$SET_SEARCH_TER, __WEBPACK_IMPORTED_MODULE_1__types__["SET_SERVICE_REQUEST_ISSUES"], function (state, data) {
  state.issues = [];
  if (data !== undefined && data !== null) {
    if (data !== '') {
      state.issues = data;
    }
  }
}), _types$SET_SEARCH_TER);

/***/ }),

/***/ 315:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = (function () {
  return {
    serviceRequest: null,
    serviceRequests: [],
    requestHistory: [],
    searchTerm: '',
    pageSize: 10,
    sortDir: 'desc',
    orderBy: 'Id',
    status: '',
    filterBy: 0,
    issues: []
  };
});

/***/ }),

/***/ 316:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api__ = __webpack_require__(11);





/* harmony default export */ __webpack_exports__["default"] = ({
  setTranslation: function setTranslation(_ref, data) {
    var commit = _ref.commit,
        state = _ref.state;

    commit('SET_TRANSLATION', data);
  },
  setServiceElementTranslation: function setServiceElementTranslation(_ref2, data) {
    var commit = _ref2.commit,
        state = _ref2.state;

    commit('SET_SERVICE_ELEMENT_TRANSLATION', data);
  },
  setCustomMessageTranslation: function setCustomMessageTranslation(_ref3, data) {
    var commit = _ref3.commit,
        state = _ref3.state;

    commit('SET_CUSTOM_MESSAGE_TRANSLATION', data);
  },
  translateAllReportSections: function translateAllReportSections(_ref4, code) {
    var _this = this;

    var commit = _ref4.commit,
        state = _ref4.state;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              state.translations = [];
              return _context.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].translateAllReportSections(code).then(function (response) {
                  commit('SET_TRANSLATIONS', response.data);
                  resolve(response);
                });
              }));

            case 2:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  getReportTranslations: function getReportTranslations(_ref5, data) {
    var _this2 = this;

    var commit = _ref5.commit,
        state = _ref5.state;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              state.translations = [];
              return _context2.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].getReportTranslations(data).then(function (response) {
                  commit('SET_TRANSLATIONS', response.data);
                  resolve(response);
                });
              }));

            case 2:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }))();
  },
  saveTranslations: function saveTranslations(_ref6, data) {
    var _this3 = this;

    var commit = _ref6.commit;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              return _context3.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].saveTranslations(data).then(function (response) {
                  resolve(response);
                });
              }));

            case 1:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this3);
    }))();
  },
  translateAllServiceElements: function translateAllServiceElements(_ref7, cultureCode) {
    var _this4 = this;

    var commit = _ref7.commit,
        state = _ref7.state;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              state.serviceElementTranslations = [];
              return _context4.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].translateAllServiceElements(cultureCode).then(function (response) {
                  commit('SET_SERVICE_ELEMENT_TRANSLATIONS', response.data);
                  resolve(response);
                });
              }));

            case 2:
            case 'end':
              return _context4.stop();
          }
        }
      }, _callee4, _this4);
    }))();
  },
  getServiceElementTranslations: function getServiceElementTranslations(_ref8, data) {
    var _this5 = this;

    var commit = _ref8.commit,
        state = _ref8.state;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              state.serviceElementTranslations = [];
              return _context5.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].getServiceElementTranslations(data).then(function (response) {
                  commit('SET_SERVICE_ELEMENT_TRANSLATIONS', response.data);
                  resolve(response);
                });
              }));

            case 2:
            case 'end':
              return _context5.stop();
          }
        }
      }, _callee5, _this5);
    }))();
  },
  saveServiceElementTranslations: function saveServiceElementTranslations(_ref9, data) {
    var _this6 = this;

    var commit = _ref9.commit;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              return _context6.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].saveServiceElementTranslations(data).then(function (response) {
                  resolve(response);
                });
              }));

            case 1:
            case 'end':
              return _context6.stop();
          }
        }
      }, _callee6, _this6);
    }))();
  },
  localeTranslation: function localeTranslation(_ref10, data) {
    var _this7 = this;

    var commit = _ref10.commit;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee7() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              return _context7.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].localeTranslation(data).then(function (response) {
                  resolve(response);
                });
              }));

            case 1:
            case 'end':
              return _context7.stop();
          }
        }
      }, _callee7, _this7);
    }))();
  },
  getRagCustomMessageTranslations: function getRagCustomMessageTranslations(_ref11, cultureCode) {
    var _this8 = this;

    var commit = _ref11.commit,
        state = _ref11.state;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee8() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              state.customMessageTranslations = [];
              return _context8.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].getRagCustomMessageTranslations(cultureCode).then(function (response) {
                  var translations = typeof response.data === 'string' ? JSON.parse(response.data) : response.data;
                  commit('SET_CUSTOM_MESSAGE_TRANSLATIONS', translations);
                  resolve(response);
                }).catch(function (error) {
                  console.error('Vuex: API error:', error);
                  reject(error);
                });
              }));

            case 2:
            case 'end':
              return _context8.stop();
          }
        }
      }, _callee8, _this8);
    }))();
  },
  processCustomMessageTranslations: function processCustomMessageTranslations(_ref12, data) {
    var _this9 = this;

    var commit = _ref12.commit;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee9() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
        while (1) {
          switch (_context9.prev = _context9.next) {
            case 0:
              return _context9.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].processCustomMessageTranslations(data).then(function (response) {
                  resolve(response);
                }).catch(reject);
              }));

            case 1:
            case 'end':
              return _context9.stop();
          }
        }
      }, _callee9, _this9);
    }))();
  },
  deleteCustomMessageTranslations: function deleteCustomMessageTranslations(_ref13, translationIds) {
    var _this10 = this;

    var commit = _ref13.commit;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee10() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10) {
        while (1) {
          switch (_context10.prev = _context10.next) {
            case 0:
              return _context10.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].deleteCustomMessageTranslations(translationIds).then(function (response) {
                  resolve(response);
                }).catch(reject);
              }));

            case 1:
            case 'end':
              return _context10.stop();
          }
        }
      }, _callee10, _this10);
    }))();
  }
});

/***/ }),

/***/ 317:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ({
  translations: function translations(state) {
    return state.translations;
  },
  serviceElementTranslations: function serviceElementTranslations(state) {
    return state.serviceElementTranslations;
  },
  languages: function languages(state) {
    return state.languages;
  },
  customMessageTranslations: function customMessageTranslations(state) {
    return state.customMessageTranslations;
  }
});

/***/ }),

/***/ 318:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__types__ = __webpack_require__(320);




var _types$SET_TRANSLATIO;


/* harmony default export */ __webpack_exports__["default"] = (_types$SET_TRANSLATIO = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$SET_TRANSLATIO, __WEBPACK_IMPORTED_MODULE_3__types__["SET_TRANSLATIONS"], function (state, translations) {
  state.translations = translations;
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(state.translations), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var item = _step.value;

      item.isTranslated = false;
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$SET_TRANSLATIO, __WEBPACK_IMPORTED_MODULE_3__types__["SET_SERVICE_ELEMENT_TRANSLATIONS"], function (state, translations) {
  state.serviceElementTranslations = translations;
  var _iteratorNormalCompletion2 = true;
  var _didIteratorError2 = false;
  var _iteratorError2 = undefined;

  try {
    for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(state.serviceElementTranslations), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
      var item = _step2.value;

      item.isTranslated = false;
    }
  } catch (err) {
    _didIteratorError2 = true;
    _iteratorError2 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion2 && _iterator2.return) {
        _iterator2.return();
      }
    } finally {
      if (_didIteratorError2) {
        throw _iteratorError2;
      }
    }
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$SET_TRANSLATIO, __WEBPACK_IMPORTED_MODULE_3__types__["SET_TRANSLATION"], function (state, data) {
  var _iteratorNormalCompletion3 = true;
  var _didIteratorError3 = false;
  var _iteratorError3 = undefined;

  try {
    for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(state.translations), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
      var item = _step3.value;

      if (item.applyTo === data.applyTo && item.name === data.name) {
        item.translation = data.translation;
        item.isTranslated = true;
        break;
      }
    }
  } catch (err) {
    _didIteratorError3 = true;
    _iteratorError3 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion3 && _iterator3.return) {
        _iterator3.return();
      }
    } finally {
      if (_didIteratorError3) {
        throw _iteratorError3;
      }
    }
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$SET_TRANSLATIO, __WEBPACK_IMPORTED_MODULE_3__types__["SET_SERVICE_ELEMENT_TRANSLATION"], function (state, data) {
  var _iteratorNormalCompletion4 = true;
  var _didIteratorError4 = false;
  var _iteratorError4 = undefined;

  try {
    for (var _iterator4 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(state.serviceElementTranslations), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
      var item = _step4.value;

      if (item.serviceElementId === data.serviceElementId) {
        item.translation = data.translation;
        item.isTranslated = true;
        break;
      }
    }
  } catch (err) {
    _didIteratorError4 = true;
    _iteratorError4 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion4 && _iterator4.return) {
        _iterator4.return();
      }
    } finally {
      if (_didIteratorError4) {
        throw _iteratorError4;
      }
    }
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$SET_TRANSLATIO, __WEBPACK_IMPORTED_MODULE_3__types__["SET_CUSTOM_MESSAGE_TRANSLATIONS"], function (state, translations) {
  if (translations && translations.length > 0) {
    state.customMessageTranslations = translations.map(function (item) {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, item, {
        isModified: false,
        selectedForTranslation: false
      });
    });
  } else {
    state.customMessageTranslations = [];
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$SET_TRANSLATIO, __WEBPACK_IMPORTED_MODULE_3__types__["SET_CUSTOM_MESSAGE_TRANSLATION"], function (state, data) {
  var _iteratorNormalCompletion5 = true;
  var _didIteratorError5 = false;
  var _iteratorError5 = undefined;

  try {
    for (var _iterator5 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(state.customMessageTranslations), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
      var item = _step5.value;

      if (item.id === data.id || item.customMessage === data.customMessage && !item.id) {
        item.translatedCustomMessage = data.translatedCustomMessage;
        item.isModified = true;
        break;
      }
    }
  } catch (err) {
    _didIteratorError5 = true;
    _iteratorError5 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion5 && _iterator5.return) {
        _iterator5.return();
      }
    } finally {
      if (_didIteratorError5) {
        throw _iteratorError5;
      }
    }
  }
}), _types$SET_TRANSLATIO);

/***/ }),

/***/ 319:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = (function () {
  return {
    translations: [],
    serviceElementTranslations: [],
    languages: [],
    customMessageTranslations: []
  };
});

/***/ }),

/***/ 320:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_TRANSLATIONS", function() { return SET_TRANSLATIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_SERVICE_ELEMENT_TRANSLATIONS", function() { return SET_SERVICE_ELEMENT_TRANSLATIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_TRANSLATION", function() { return SET_TRANSLATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_SERVICE_ELEMENT_TRANSLATION", function() { return SET_SERVICE_ELEMENT_TRANSLATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_CUSTOM_MESSAGE_TRANSLATIONS", function() { return SET_CUSTOM_MESSAGE_TRANSLATIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_CUSTOM_MESSAGE_TRANSLATION", function() { return SET_CUSTOM_MESSAGE_TRANSLATION; });
var SET_TRANSLATIONS = 'SET_TRANSLATIONS';
var SET_SERVICE_ELEMENT_TRANSLATIONS = 'SET_SERVICE_ELEMENT_TRANSLATIONS';
var SET_TRANSLATION = 'SET_TRANSLATION';
var SET_SERVICE_ELEMENT_TRANSLATION = 'SET_SERVICE_ELEMENT_TRANSLATION';
var SET_CUSTOM_MESSAGE_TRANSLATIONS = 'SET_CUSTOM_MESSAGE_TRANSLATIONS';
var SET_CUSTOM_MESSAGE_TRANSLATION = 'SET_CUSTOM_MESSAGE_TRANSLATION';

/***/ }),

/***/ 321:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__types__ = __webpack_require__(157);






/* harmony default export */ __webpack_exports__["default"] = ({
  setSearchTerm: function setSearchTerm(_ref, text) {
    var commit = _ref.commit;

    commit(__WEBPACK_IMPORTED_MODULE_4__types__["SET_SEARCH_TERM"], text);
  },
  setPageSize: function setPageSize(_ref2, pageSize) {
    var commit = _ref2.commit;

    commit(__WEBPACK_IMPORTED_MODULE_4__types__["SET_PAGE_SIZE"], pageSize);
  },
  setSortDir: function setSortDir(_ref3, sortDir) {
    var commit = _ref3.commit;

    commit(__WEBPACK_IMPORTED_MODULE_4__types__["SET_SORT_DIR"], sortDir);
  },
  setOrderBy: function setOrderBy(_ref4, orderBy) {
    var commit = _ref4.commit;

    commit(__WEBPACK_IMPORTED_MODULE_4__types__["SET_ORDER_BY"], orderBy);
  },
  setStatus: function setStatus(_ref5, status) {
    var commit = _ref5.commit;

    commit(__WEBPACK_IMPORTED_MODULE_4__types__["SET_STATUS"], status);
  },
  setFilterBy: function setFilterBy(_ref6, filterBy) {
    var commit = _ref6.commit;

    commit(__WEBPACK_IMPORTED_MODULE_4__types__["SET_FILTER_BY"], filterBy);
  },
  initUser: function initUser(_ref7) {
    var commit = _ref7.commit;

    commit(__WEBPACK_IMPORTED_MODULE_4__types__["INIT_USER"]);
  },
  highlightSave: function highlightSave(_ref8, value) {
    var commit = _ref8.commit;

    commit(__WEBPACK_IMPORTED_MODULE_4__types__["SET_HIGHLIGHT"], value);
  },
  highlightPasswordSave: function highlightPasswordSave(_ref9, value) {
    var commit = _ref9.commit;

    commit(__WEBPACK_IMPORTED_MODULE_4__types__["SET_HIGHLIGHT_PASSWORD"], value);
  },
  setUserRole: function setUserRole(_ref10, value) {
    var commit = _ref10.commit;

    commit(__WEBPACK_IMPORTED_MODULE_4__types__["SET_USER_ROLE"], value);
  },
  setSource: function setSource(_ref11, source) {
    var commit = _ref11.commit;

    commit(__WEBPACK_IMPORTED_MODULE_4__types__["SET_SOURCE"], source);
  },
  getUser: function getUser(_ref12, username) {
    var _this = this;

    var commit = _ref12.commit,
        dispatch = _ref12.dispatch;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].getUser(username).then(function (response) {
                  console.log('getUser', response);
                  commit(__WEBPACK_IMPORTED_MODULE_4__types__["SET_USER"], response.data);
                  resolve(response);
                });
              }));

            case 1:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  getUsers: function getUsers(_ref13, searchOptions) {
    var _this2 = this;

    var commit = _ref13.commit,
        dispatch = _ref13.dispatch;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              return _context2.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].getUsers(searchOptions).then(function (response) {
                  commit(__WEBPACK_IMPORTED_MODULE_4__types__["SET_USERS"], response.data);
                  resolve(response);
                });
              }));

            case 1:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }))();
  },
  downloadAllUsers: function downloadAllUsers(_ref14) {
    var _this3 = this;

    var commit = _ref14.commit,
        dispatch = _ref14.dispatch;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              return _context3.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].downloadAllUsers().then(function (response) {
                  resolve(response);
                });
              }));

            case 1:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this3);
    }))();
  },
  updateUser: function updateUser(_ref15) {
    var _this4 = this;

    var commit = _ref15.commit,
        state = _ref15.state;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              return _context4.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                var data = {
                  Id: state.user.UserId,
                  Roles: state.user.Roles,
                  FamilyName: state.user.LastName,
                  GivenName: state.user.FirstName,
                  Username: state.user.Username,
                  Email: state.user.Email,
                  DispatchGroupEmail: state.user.DispatchGroupEmail,
                  IsActive: state.user.IsActive,
                  IsLockedOut: state.user.IsLockedOut,
                  RootLocationId: state.user.LocationId,
                  IsMahle: state.user.IsMahle,
                  ShowRAG: state.user.ShowRAG !== null && state.user.ShowRAG !== undefined ? state.user.ShowRAG : false,
                  IsTechpro: state.user.IsTechpro !== null && state.user.IsTechpro !== undefined ? state.user.IsTechpro : false,
                  IsTexa: state.user.IsTexa !== null && state.user.IsTexa !== undefined ? state.user.IsTexa : false
                };
                console.log('updateUser', data);
                __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].updateUser(data).then(function (response) {
                  resolve(response);
                });
              }));

            case 1:
            case 'end':
              return _context4.stop();
          }
        }
      }, _callee4, _this4);
    }))();
  },
  createUser: function createUser(_ref16, data) {
    var _this5 = this;

    var commit = _ref16.commit,
        state = _ref16.state;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              return _context5.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                var user = {
                  CreatedBy: data.CreatedBy,
                  Roles: state.user.Roles,
                  FamilyName: state.user.LastName,
                  GivenName: state.user.FirstName,
                  Username: state.user.Username,
                  Email: state.user.Email,
                  DispatchGroupEmail: state.user.DispatchGroupEmail,
                  Password: state.user.Password,
                  IsActive: state.user.IsActive,
                  IsLockedOut: state.user.IsLockedOut,
                  RootLocationId: data.LocationId,
                  IsMahle: data.IsMahle,
                  ShowRAG: state.user.ShowRAG !== null && state.user.ShowRAG !== undefined ? state.user.ShowRAG : false,
                  IsTechpro: state.user.IsTechpro !== null && state.user.IsTechpro !== undefined ? state.user.IsTechpro : false,
                  IsTexa: state.user.IsTexa !== null && state.user.IsTexa !== undefined ? state.user.IsTexa : false
                };
                console.log('createUser', user);
                __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].createUser(user).then(function (response) {
                  resolve(response);
                });
              }));

            case 1:
            case 'end':
              return _context5.stop();
          }
        }
      }, _callee5, _this5);
    }))();
  },
  resetUserPassword: function resetUserPassword(_ref17, user) {
    var commit = _ref17.commit,
        state = _ref17.state;

    if (user.password === null) {
      alert('Password must be provided.');
      return null;
    }
    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      console.log('User Password Reset', user);
      var data = {
        password: user.Password,
        resetLockout: !user.IsLockedOut,
        id: user.UserId
      };
      __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].resetUserPassword(data).then(function (response) {
        alert('Password has been reset successfully!');
        resolve(response);
        commit(__WEBPACK_IMPORTED_MODULE_4__types__["SET_HIGHLIGHT_PASSWORD"], false);
      }).catch(function (error) {
        alert(error.response.data);
        reject(error);
      });
    });
  },
  checkEmailExists: function checkEmailExists(_ref18) {
    var _this6 = this;

    var commit = _ref18.commit,
        state = _ref18.state;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6() {
      var result;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              result = false;

              console.log('test email', state.user.UserId, state.user.Email);
              return _context6.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].checkEmailExists(state.user.UserId, state.user.Email).then(function (response) {
                  console.log('checked email', response);
                  resolve(response);
                  result = response.data;
                  return result;
                });
              }));

            case 3:
            case 'end':
              return _context6.stop();
          }
        }
      }, _callee6, _this6);
    }))();
  },
  checkEmailExistsFor: function checkEmailExistsFor(_, _ref19) {
    var _this7 = this;

    var userId = _ref19.userId,
        email = _ref19.email;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee7() {
      var response;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              _context7.next = 2;
              return __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].checkEmailExists(userId || 0, email);

            case 2:
              response = _context7.sent;
              return _context7.abrupt('return', response.data);

            case 4:
            case 'end':
              return _context7.stop();
          }
        }
      }, _callee7, _this7);
    }))();
  }
});

/***/ }),

/***/ 322:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ({
  searchTerm: function searchTerm(state) {
    return state.searchTerm;
  },
  pageSize: function pageSize(state) {
    return state.pageSize;
  },
  sortDir: function sortDir(state) {
    return state.sortDir;
  },
  orderBy: function orderBy(state) {
    return state.orderBy;
  },
  status: function status(state) {
    return state.status;
  },
  filterBy: function filterBy(state) {
    return state.filterBy;
  },
  user: function user(state) {
    return state.user;
  },
  users: function users(state) {
    return state.users;
  },
  totalUsers: function totalUsers(state) {
    return state.totalUsers;
  },
  currentUser: function currentUser(state) {
    return state.currentUser;
  },
  highlight: function highlight(state) {
    return state.highlight;
  },
  highlightPassword: function highlightPassword(state) {
    return state.highlightPassword;
  },
  source: function source(state) {
    return state.source;
  }
});

/***/ }),

/***/ 323:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__types__ = __webpack_require__(157);




var _types$SET_SEARCH_TER;



/* harmony default export */ __webpack_exports__["default"] = (_types$SET_SEARCH_TER = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$SET_SEARCH_TER, __WEBPACK_IMPORTED_MODULE_3__types__["SET_SEARCH_TERM"], function (state, text) {
  if (text !== undefined && text !== null) {
    state.searchTerm = text;
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$SET_SEARCH_TER, __WEBPACK_IMPORTED_MODULE_3__types__["SET_PAGE_SIZE"], function (state, value) {
  if (value !== undefined && value !== null) {
    state.pageSize = parseInt(value);
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$SET_SEARCH_TER, __WEBPACK_IMPORTED_MODULE_3__types__["SET_SORT_DIR"], function (state, text) {
  if (text !== undefined && text !== null) {
    state.sortDir = text;
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$SET_SEARCH_TER, __WEBPACK_IMPORTED_MODULE_3__types__["SET_ORDER_BY"], function (state, text) {
  if (text !== undefined && text !== null) {
    state.orderBy = text;
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$SET_SEARCH_TER, __WEBPACK_IMPORTED_MODULE_3__types__["SET_STATUS"], function (state, value) {
  if (value !== undefined && value !== null) {
    state.status = value;
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$SET_SEARCH_TER, __WEBPACK_IMPORTED_MODULE_3__types__["SET_FILTER_BY"], function (state, value) {
  if (value !== undefined && value !== null) {
    state.filterBy = parseInt(value);
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$SET_SEARCH_TER, __WEBPACK_IMPORTED_MODULE_3__types__["INIT_USER"], function (state) {
  state.user = JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(state.default));
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$SET_SEARCH_TER, __WEBPACK_IMPORTED_MODULE_3__types__["SET_HIGHLIGHT"], function (state, value) {
  state.highlight = value;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$SET_SEARCH_TER, __WEBPACK_IMPORTED_MODULE_3__types__["SET_HIGHLIGHT_PASSWORD"], function (state, value) {
  state.highlightPassword = value;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$SET_SEARCH_TER, __WEBPACK_IMPORTED_MODULE_3__types__["SET_USER_ROLE"], function (state, role) {
  state.user.Role = role.name;
  state.user.Roles = [];
  state.user.Roles.push({
    Name: role.name,
    Id: role.id
  });
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$SET_SEARCH_TER, __WEBPACK_IMPORTED_MODULE_3__types__["SET_SOURCE"], function (state, source) {
  state.source = source;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$SET_SEARCH_TER, __WEBPACK_IMPORTED_MODULE_3__types__["SET_USER"], function (state, data) {
  state.user = JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(state.default));
  if (data.length > 0) {
    state.user = data[0];
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$SET_SEARCH_TER, __WEBPACK_IMPORTED_MODULE_3__types__["SET_USERS"], function (state, data) {
  state.totalUsers = 0;
  state.users = [];
  if (data !== undefined && data !== null) {
    if (data.length > 0) {
      state.totalUsers = data[0].TotalItems;
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(data), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var item = _step.value;

          item.isChecked = false;
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      state.users = data;
    }
  }
}), _types$SET_SEARCH_TER);

/***/ }),

/***/ 324:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = (function () {
  return {
    default: {
      BusinessName: '',
      Email: '',
      DispatchGroupEmail: '',
      FirstName: '',
      IsUK: 0,
      LastName: '',
      Location: {
        Id: 0,
        Name: ''
      },
      LocationId: 0,
      PartnerId: null,
      Role: '',
      Roles: [{
        Id: 0,
        Name: ''
      }],
      TimeZone: '',
      UserId: 0,
      Username: '',
      IsActive: true,
      IsLockedOut: false,
      Password: ''
    },
    user: null,
    users: [],
    totalUsers: 0,
    currentUser: null,
    searchTerm: '',
    pageSize: 10,
    sortDir: 'asc',
    orderBy: 'Name',
    status: '',
    filterBy: 0,
    highlight: false,
    highlightPassword: false,
    source: null
  };
});

/***/ }),

/***/ 329:
/***/ (function(module, exports) {

module.exports = {"aes-128-ecb":{"cipher":"AES","key":128,"iv":0,"mode":"ECB","type":"block"},"aes-192-ecb":{"cipher":"AES","key":192,"iv":0,"mode":"ECB","type":"block"},"aes-256-ecb":{"cipher":"AES","key":256,"iv":0,"mode":"ECB","type":"block"},"aes-128-cbc":{"cipher":"AES","key":128,"iv":16,"mode":"CBC","type":"block"},"aes-192-cbc":{"cipher":"AES","key":192,"iv":16,"mode":"CBC","type":"block"},"aes-256-cbc":{"cipher":"AES","key":256,"iv":16,"mode":"CBC","type":"block"},"aes128":{"cipher":"AES","key":128,"iv":16,"mode":"CBC","type":"block"},"aes192":{"cipher":"AES","key":192,"iv":16,"mode":"CBC","type":"block"},"aes256":{"cipher":"AES","key":256,"iv":16,"mode":"CBC","type":"block"},"aes-128-cfb":{"cipher":"AES","key":128,"iv":16,"mode":"CFB","type":"stream"},"aes-192-cfb":{"cipher":"AES","key":192,"iv":16,"mode":"CFB","type":"stream"},"aes-256-cfb":{"cipher":"AES","key":256,"iv":16,"mode":"CFB","type":"stream"},"aes-128-cfb8":{"cipher":"AES","key":128,"iv":16,"mode":"CFB8","type":"stream"},"aes-192-cfb8":{"cipher":"AES","key":192,"iv":16,"mode":"CFB8","type":"stream"},"aes-256-cfb8":{"cipher":"AES","key":256,"iv":16,"mode":"CFB8","type":"stream"},"aes-128-cfb1":{"cipher":"AES","key":128,"iv":16,"mode":"CFB1","type":"stream"},"aes-192-cfb1":{"cipher":"AES","key":192,"iv":16,"mode":"CFB1","type":"stream"},"aes-256-cfb1":{"cipher":"AES","key":256,"iv":16,"mode":"CFB1","type":"stream"},"aes-128-ofb":{"cipher":"AES","key":128,"iv":16,"mode":"OFB","type":"stream"},"aes-192-ofb":{"cipher":"AES","key":192,"iv":16,"mode":"OFB","type":"stream"},"aes-256-ofb":{"cipher":"AES","key":256,"iv":16,"mode":"OFB","type":"stream"},"aes-128-ctr":{"cipher":"AES","key":128,"iv":16,"mode":"CTR","type":"stream"},"aes-192-ctr":{"cipher":"AES","key":192,"iv":16,"mode":"CTR","type":"stream"},"aes-256-ctr":{"cipher":"AES","key":256,"iv":16,"mode":"CTR","type":"stream"},"aes-128-gcm":{"cipher":"AES","key":128,"iv":12,"mode":"GCM","type":"auth"},"aes-192-gcm":{"cipher":"AES","key":192,"iv":12,"mode":"GCM","type":"auth"},"aes-256-gcm":{"cipher":"AES","key":256,"iv":12,"mode":"GCM","type":"auth"}}

/***/ }),

/***/ 331:
/***/ (function(module, exports) {

module.exports = {"sha224WithRSAEncryption":{"sign":"rsa","hash":"sha224","id":"302d300d06096086480165030402040500041c"},"RSA-SHA224":{"sign":"ecdsa/rsa","hash":"sha224","id":"302d300d06096086480165030402040500041c"},"sha256WithRSAEncryption":{"sign":"rsa","hash":"sha256","id":"3031300d060960864801650304020105000420"},"RSA-SHA256":{"sign":"ecdsa/rsa","hash":"sha256","id":"3031300d060960864801650304020105000420"},"sha384WithRSAEncryption":{"sign":"rsa","hash":"sha384","id":"3041300d060960864801650304020205000430"},"RSA-SHA384":{"sign":"ecdsa/rsa","hash":"sha384","id":"3041300d060960864801650304020205000430"},"sha512WithRSAEncryption":{"sign":"rsa","hash":"sha512","id":"3051300d060960864801650304020305000440"},"RSA-SHA512":{"sign":"ecdsa/rsa","hash":"sha512","id":"3051300d060960864801650304020305000440"},"RSA-SHA1":{"sign":"rsa","hash":"sha1","id":"3021300906052b0e03021a05000414"},"ecdsa-with-SHA1":{"sign":"ecdsa","hash":"sha1","id":""},"sha256":{"sign":"ecdsa","hash":"sha256","id":""},"sha224":{"sign":"ecdsa","hash":"sha224","id":""},"sha384":{"sign":"ecdsa","hash":"sha384","id":""},"sha512":{"sign":"ecdsa","hash":"sha512","id":""},"DSA-SHA":{"sign":"dsa","hash":"sha1","id":""},"DSA-SHA1":{"sign":"dsa","hash":"sha1","id":""},"DSA":{"sign":"dsa","hash":"sha1","id":""},"DSA-WITH-SHA224":{"sign":"dsa","hash":"sha224","id":""},"DSA-SHA224":{"sign":"dsa","hash":"sha224","id":""},"DSA-WITH-SHA256":{"sign":"dsa","hash":"sha256","id":""},"DSA-SHA256":{"sign":"dsa","hash":"sha256","id":""},"DSA-WITH-SHA384":{"sign":"dsa","hash":"sha384","id":""},"DSA-SHA384":{"sign":"dsa","hash":"sha384","id":""},"DSA-WITH-SHA512":{"sign":"dsa","hash":"sha512","id":""},"DSA-SHA512":{"sign":"dsa","hash":"sha512","id":""},"DSA-RIPEMD160":{"sign":"dsa","hash":"rmd160","id":""},"ripemd160WithRSA":{"sign":"rsa","hash":"rmd160","id":"3021300906052b2403020105000414"},"RSA-RIPEMD160":{"sign":"rsa","hash":"rmd160","id":"3021300906052b2403020105000414"},"md5WithRSAEncryption":{"sign":"rsa","hash":"md5","id":"3020300c06082a864886f70d020505000410"},"RSA-MD5":{"sign":"rsa","hash":"md5","id":"3020300c06082a864886f70d020505000410"}}

/***/ }),

/***/ 332:
/***/ (function(module, exports) {

module.exports = {"1.3.132.0.10":"secp256k1","1.3.132.0.33":"p224","1.2.840.10045.3.1.1":"p192","1.2.840.10045.3.1.7":"p256","1.3.132.0.34":"p384","1.3.132.0.35":"p521"}

/***/ }),

/***/ 571:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__currency__ = __webpack_require__(631);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__dates__ = __webpack_require__(632);



/* harmony default export */ __webpack_exports__["a"] = ({
  currency: __WEBPACK_IMPORTED_MODULE_0__currency__,
  dates: __WEBPACK_IMPORTED_MODULE_1__dates__
});

/***/ }),

/***/ 572:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_i18n__ = __webpack_require__(1031);



var language = 'en';

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_i18n__["a" /* default */]);

function loadLocales() {
  var locales = __webpack_require__(1038);
  var messages = {};
  locales.keys().forEach(function (key) {
    var matched = key.match(/([A-Za-z0-9-_]+)\./i);
    if (matched && matched.length > 1) {
      var locale = matched[1];
      messages[locale] = locales(key);
    }
  });
  return messages;
}

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_i18n__["a" /* default */]({
  locale: language,
  fallbackLocale: 'en',
  messages: loadLocales()
}));

/***/ }),

/***/ 573:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

var errorHandler = function errorHandler(err, vm, info) {
  console.error(err);
  console.error(vm);
  console.error(info);
};

/* harmony default export */ __webpack_exports__["a"] = (errorHandler);

/***/ }),

/***/ 577:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(966)
}
var Component = __webpack_require__(578)(
  /* script */
  __webpack_require__(662),
  /* template */
  __webpack_require__(1032),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 580:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_crypto__ = __webpack_require__(948);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_crypto___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_crypto__);


var appName = 'athena';
var environment = window.config ? window.config.environment : 'local';

var hash = function hash(key) {
  return __WEBPACK_IMPORTED_MODULE_0_crypto___default.a.createHash('md5').update(appName + '/' + environment + '/' + key).digest('hex');
};

/* harmony default export */ __webpack_exports__["a"] = ({
  session: {
    setItem: function setItem(key, value) {
      sessionStorage.setItem(hash(key), value);
    },
    getItem: function getItem(key) {
      return sessionStorage.getItem(hash(key));
    },
    clear: function clear() {
      sessionStorage.clear();
    }
  },
  local: {
    setItem: function setItem(key, value) {
      localStorage.setItem(hash(key), value);
    },
    getItem: function getItem(key) {
      return localStorage.getItem(hash(key));
    },
    clear: function clear() {
      localStorage.clear();
    }
  }
});

/***/ }),

/***/ 582:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_common__ = __webpack_require__(8);


/* harmony default export */ __webpack_exports__["default"] = ({
  getJatoVehicleYears: function getJatoVehicleYears() {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].get('ragrating/JatoVehicleYears');
  }
});

/***/ }),

/***/ 584:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_common__ = __webpack_require__(8);


/* harmony default export */ __webpack_exports__["default"] = ({
  getBusinessProfiles: function getBusinessProfiles(id) {
    if (id) {
      return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].get('BusinessProfile/GetBusinessProfile?id=' + id);
    }
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].get('BusinessProfile/GetBusinessProfile');
  },
  upsertBusinessProfile: function upsertBusinessProfile(data) {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].post('BusinessProfile/UpsertBusinessProfile', data);
  },
  deleteBusinessProfile: function deleteBusinessProfile(id) {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].delete('BusinessProfile/DeleteBusinessProfile?id=' + id);
  },
  cloneBusinessProfile: function cloneBusinessProfile(data) {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].post('BusinessProfile/CloneBusinessProfile', data);
  },
  upsertBusinessProfileProduct: function upsertBusinessProfileProduct(data) {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].post('BusinessProfile/UpsertBusinessProfileProduct', data);
  },
  upsertBusinessProfileProductAdd: function upsertBusinessProfileProductAdd(data) {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].post('BusinessProfile/UpsertBusinessProfileProductAdd', data);
  },
  deleteBusinessProfileProduct: function deleteBusinessProfileProduct(businessProfileId, productId) {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].delete('BusinessProfile/DeleteBusinessProfileProduct?businessProfileId=' + businessProfileId + '&productId=' + productId);
  },
  deleteBusinessProfileProductAdd: function deleteBusinessProfileProductAdd(businessProfileId, productAddId) {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].delete('BusinessProfile/DeleteBusinessProfileProductAdd?businessProfileId=' + businessProfileId + '&productAddId=' + productAddId);
  },
  applyBusinessProfile: function applyBusinessProfile(data) {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].post('BusinessProfile/ApplyBusinessProfile', data);
  }
});

/***/ }),

/***/ 585:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_common__ = __webpack_require__(8);


/* harmony default export */ __webpack_exports__["default"] = ({
  upsertBusiness: function upsertBusiness(data) {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].post('Business/Upsert', data);
  },
  upsertBusinessUser: function upsertBusinessUser(data) {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].post('Business/ModifyUsers', data);
  },
  upsertBusinessNote: function upsertBusinessNote(data) {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].post('Business/UpsertNote', data);
  },
  upsertBusinessDocument: function upsertBusinessDocument(data, config) {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].post('Business/AddDocument', data, config);
  },
  upsertBusinessInfo: function upsertBusinessInfo(data) {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].post('Business/UpsertInfo', data);
  },
  upsertBusinessPromotion: function upsertBusinessPromotion(data) {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].post('Business/UpsertPromotion', data);
  },
  upsertBusinessBilling: function upsertBusinessBilling(data) {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].post('Business/UpsertBilling', data);
  },
  upsertBusinessDiscount: function upsertBusinessDiscount(data) {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].post('Business/UpsertDiscount', data);
  },
  upsertDiscountProductAdd: function upsertDiscountProductAdd(data) {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].post('Business/UpsertDiscountProductAdd', data);
  },
  swapShop: function swapShop(data) {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].post('saintgobain/swapshopid', data);
  },
  setBusinessStatus: function setBusinessStatus(data) {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].post('Business/SetBusinessStatus', data);
  },
  resetUserPassword: function resetUserPassword(data) {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].post('User/ResetPassword', data);
  },
  getDownloadToken: function getDownloadToken(data) {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].post('User/GetDownloadToken', data);
  },
  getBusinesses: function getBusinesses(data) {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].get('BusinessQuery/Registered', data);
  },
  getBusinessLocation: function getBusinessLocation(sid) {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].get('BusinessQuery/Location?key=' + sid);
  },
  getBusinessInfo: function getBusinessInfo(sid) {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].get('BusinessQuery/Info?key=' + sid);
  },
  getBusinessPromotion: function getBusinessPromotion(sid) {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].get('BusinessQuery/Promotion?key=' + sid);
  },
  getBusinessUsers: function getBusinessUsers(sid) {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].get('BusinessQuery/Users?key=' + sid);
  },
  getBusinessNotes: function getBusinessNotes(sid) {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].get('BusinessQuery/Notes?key=' + sid);
  },
  getBusinessBilling: function getBusinessBilling(sid) {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].get('BusinessQuery/Billing?key=' + sid);
  },
  getBusinessDiscounts: function getBusinessDiscounts(_ref) {
    var sid = _ref.sid,
        type = _ref.type,
        other = _ref.other;

    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].get('BusinessQuery/Discounts?key=' + sid + '&type=' + type + '&other=' + other);
  },
  getBusinessDiscountsProductAdds: function getBusinessDiscountsProductAdds(_ref2) {
    var sid = _ref2.sid;

    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].get('BusinessQuery/DiscountsProductAdds?key=' + sid);
  },
  lookupBusiness: function lookupBusiness(search) {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].get('business/LookupBusiness?search=' + search);
  },
  getRoles: function getRoles(type) {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].get('BusinessQuery/Roles?type=' + type);
  },
  searchBusinesses: function searchBusinesses(search) {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].get('BusinessQuery/Search', {
      params: search
    });
  }
});

/***/ }),

/***/ 586:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_common__ = __webpack_require__(8);

/* harmony default export */ __webpack_exports__["default"] = ({
  getIntegrations: function getIntegrations(searchOptions) {
    console.log('Get Integration Queue Data');
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].postWithJson('admin/integrationQueue', searchOptions);
  },
  getIntegrationById: function getIntegrationById(id) {
    console.log('Get Integration Queue By Id');
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].get('admin/integrationQueueById?id=' + id);
  },
  requeueIntegrationById: function requeueIntegrationById(id) {
    console.log('Requeue Integration Queue Data');
    console.log(id);
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].put('admin/integrationQueue/requeue/' + id);
  }
});

/***/ }),

/***/ 610:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_common__ = __webpack_require__(8);


/* harmony default export */ __webpack_exports__["default"] = ({
  authUser: function authUser(credentials, callback, error) {
    __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].auth(credentials, callback, error);
  },
  getUserInfo: function getUserInfo(username) {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].get('user/getUserByName?username=' + username);
  }
});

/***/ }),

/***/ 611:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_common__ = __webpack_require__(8);


/* harmony default export */ __webpack_exports__["default"] = ({
  getCalibrationRecommendations: function getCalibrationRecommendations(make) {
    if (make !== undefined && make !== null) {
      return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].get('calibrate/getCalibrationRecommendations?vehicleMake=' + make);
    } else {
      return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].get('calibrate/getCalibrationRecommendations');
    }
  },
  getCalibrationRecommendation: function getCalibrationRecommendation(id) {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].get('calibrate/getCalibrationRecommendation?id=' + id);
  },
  saveCalibrationRecommendations: function saveCalibrationRecommendations(data) {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].post('calibrate/saveCalibrationRecommendations', data);
  },
  deleteCalibrationRecommendation: function deleteCalibrationRecommendation(id) {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].get('calibrate/deleteCalibrationRecommendation?id=' + id);
  }
});

/***/ }),

/***/ 612:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_common__ = __webpack_require__(8);


/* harmony default export */ __webpack_exports__["default"] = ({
  getCalibrationHomepageMessage: function getCalibrationHomepageMessage() {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].get('NotificationMessage/GetWelcomeNotificationMessage');
  },
  getTranslatedCalibrationHomepageMessage: function getTranslatedCalibrationHomepageMessage(languageCode) {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].get('NotificationMessage/GetTranslatedCalibrationWelcomeMessage?languageCode=' + languageCode);
  },
  saveCalibrationHomepageMessage: function saveCalibrationHomepageMessage(message) {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].post('NotificationMessage/SaveCalibrationWelcomeMessage', message);
  },
  enableCalibrationHomepageMessage: function enableCalibrationHomepageMessage() {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].post('NotificationMessage/EnableCalibrationWelcomeMessage');
  },
  disableCalibrationHomepageMessage: function disableCalibrationHomepageMessage() {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].post('NotificationMessage/DisableCalibrationWelcomeMessage');
  }
});

/***/ }),

/***/ 613:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_common__ = __webpack_require__(8);


/* harmony default export */ __webpack_exports__["default"] = ({
  getChannels: function getChannels(options) {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].get('chat/SendBirdGroupChannels?token=' + options.token + '&pagesize=' + options.pagesize + '&search=' + encodeURIComponent(options.search) + '&includeMembers=1&chatChannelType=' + options.channelType);
  },
  getChatUsers: function getChatUsers(options) {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].get('chat/SendBirdUsers?token=' + options.token + '&pagesize=' + options.pagesize + '&search=' + encodeURIComponent(options.search));
  },
  getChatUserChannels: function getChatUserChannels(options) {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].get('chat/SendBirdUserChannels?userid=' + options.userid + '&token=' + options.token + '&pagesize=' + options.pagesize + '&search=' + encodeURIComponent(options.search));
  },
  removeChannels: function removeChannels(data) {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].post('chat/RemoveGroupChannel', data);
  },
  removeUsers: function removeUsers(data) {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].post('chat/RemoveUser', data);
  },
  saveMessage: function saveMessage(data) {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].post('message/InsertUserMessage', data);
  },
  saveTranslatedMessage: function saveTranslatedMessage(data) {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].post('message/AddMessageTranslated', data);
  },
  getChatHistory: function getChatHistory(id) {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].get('Message/ServiceRequestMessages?id=' + id + '&language=en');
  },
  saveChatMessages: function saveChatMessages(data) {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].post('chat/SaveChatHistoryWait', data);
  }
});

/***/ }),

/***/ 614:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_common__ = __webpack_require__(8);


/* harmony default export */ __webpack_exports__["default"] = ({
  getContext: function getContext() {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].get('ConnectedDevices/GetContext');
  },
  saveConnectedDevices: function saveConnectedDevices(manufacturerDeviceId, deviceIds) {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].post('ConnectedDevices/SetConnectedDevices', {
      DeviceIds: deviceIds
    }, {
      params: {
        manufacturerDeviceId: manufacturerDeviceId
      }
    });
  },
  upsertManufacturerDevice: function upsertManufacturerDevice(manufacturerDevice) {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].post('ConnectedDevices/UpsertManufacturerDevice', manufacturerDevice);
  },
  removeManufacturerDevice: function removeManufacturerDevice(manufacturerDeviceId) {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].post('ConnectedDevices/RemoveManufacturerDevice', null, {
      params: {
        manufacturerDeviceId: manufacturerDeviceId
      }
    });
  }
});

/***/ }),

/***/ 615:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_common__ = __webpack_require__(8);


/* harmony default export */ __webpack_exports__["default"] = ({
  getDocumentUploads: function getDocumentUploads(workOrderId) {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].get('ConnectSync/DocumentUploads', { params: { workOrderId: workOrderId } });
  },
  getConnectDocumentTypes: function getConnectDocumentTypes() {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].get('ConnectSync/DocumentTypes');
  },
  resendDocumentUpload: function resendDocumentUpload(id) {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].post('ConnectSync/ResendDocumentUpload?id=' + id);
  },
  getDocumentPreview: function getDocumentPreview(workOrderId, documentTypeId) {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].get('ConnectSync/DocumentPreview', {
      params: { workOrderId: workOrderId, documentTypeId: documentTypeId },
      responseType: 'blob'
    });
  },
  getStatusSyncs: function getStatusSyncs(workOrderId) {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].get('ConnectSync/StatusSyncs', { params: { workOrderId: workOrderId } });
  },
  resendStatusSync: function resendStatusSync(id) {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].post('ConnectSync/ResendStatusSync?id=' + id);
  }
});

/***/ }),

/***/ 616:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_common__ = __webpack_require__(8);


/* harmony default export */ __webpack_exports__["default"] = ({
  getAllCountries: function getAllCountries() {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].get('countrystate/GetCountryList');
  },
  getStateProvinces: function getStateProvinces(id) {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].get('countrystate/GetStateProvinceList?id=' + id);
  },
  upsertCountry: function upsertCountry(data) {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].post('countrystate/UpsertCountry', data);
  },
  upsertStateProvince: function upsertStateProvince(data) {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].post('countrystate/UpsertStateProvince', data);
  },
  deleteStateProvince: function deleteStateProvince(data) {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].post('countrystate/DeleteStateProvince', data);
  }
});

/***/ }),

/***/ 617:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_common__ = __webpack_require__(8);


/* harmony default export */ __webpack_exports__["default"] = ({
  getDataSchema: function getDataSchema(name) {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].get('dashboard/DashboardDataSchema?name=' + name);
  },
  getChoices: function getChoices(data) {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].get('dashboard/DashboardSummaryChoices?startDate=' + data.startDate + '&endDate=' + data.endDate + '&category=' + data.category);
  },
  downloadRequestStatistics: function downloadRequestStatistics(data) {
    console.log('Download Request Statistics', data);
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].post('dashboard/ExportServiceRequestStatistics', data);
  },
  downloadDeviceStatistics: function downloadDeviceStatistics(data) {
    console.log('Download Device Statistics', data);
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].post('dashboard/ExportDeviceStatistics', data);
  },
  downloadActivationCardStatistics: function downloadActivationCardStatistics(data) {
    console.log('Download Activation Card Statistics', data);
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].post('dashboard/ExportActivationCardStatistics', data);
  },
  downloadBusinessAccountInfo: function downloadBusinessAccountInfo(data) {
    console.log('Download Business Accounts Informations', data);
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].post('dashboard/ExportBusinessAccountSetup', data);
  },
  downloadDeviceShipments: function downloadDeviceShipments(data) {
    console.log('Download Device Shipments', data);
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].post('dashboard/ExportDeviceShipment', data);
  },
  downloadRequests: function downloadRequests(data) {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].get('dashboard/ExportServiceRequests?startDate=' + data.startDate + '&endDate=' + data.endDate);
  },
  downloadRequestsAdhoc: function downloadRequestsAdhoc(data) {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].post('dashboard/ExportServiceRequestsAdhoc', data);
  },
  getQueryTemplates: function getQueryTemplates() {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].get('dashboard/DashboardDataTemplates');
  },
  saveQueryTemplate: function saveQueryTemplate(data) {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].post('dashboard/DashboardDataTemplateSave', data);
  },
  removeQueryTemplate: function removeQueryTemplate(data) {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].post('dashboard/DashboardDataTemplateRemove', data);
  }
});

/***/ }),

/***/ 618:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_common__ = __webpack_require__(8);



/* harmony default export */ __webpack_exports__["default"] = ({
  getDevice: function getDevice(serialNumber) {
    return __WEBPACK_IMPORTED_MODULE_1__api_common__["a" /* default */].get('device/GetDevice?serialNumber=' + serialNumber);
  },
  getDeviceById: function getDeviceById(id) {
    return __WEBPACK_IMPORTED_MODULE_1__api_common__["a" /* default */].get('device/GetDeviceById?id=' + id);
  },
  getDevices: function getDevices(searchOptions) {
    return __WEBPACK_IMPORTED_MODULE_1__api_common__["a" /* default */].get('device/GetDevicesForListing', {
      params: searchOptions
    });
  },
  downloadAllTools: function downloadAllTools(id) {
    var filter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

    return __WEBPACK_IMPORTED_MODULE_1__api_common__["a" /* default */].get('device/GetAllTools?id=' + id + '&filter=' + filter);
  },
  getTools: function getTools(searchOptions) {
    return __WEBPACK_IMPORTED_MODULE_1__api_common__["a" /* default */].get('device/GetToolsForListing', {
      params: searchOptions
    });
  },
  getdevicefiles: function getdevicefiles(searchOptions) {
    return __WEBPACK_IMPORTED_MODULE_1__api_common__["a" /* default */].get('device/GetAllDeviceFiles', {
      params: searchOptions
    });
  },
  getDeviceFileById: function getDeviceFileById(id) {
    return __WEBPACK_IMPORTED_MODULE_1__api_common__["a" /* default */].get('device/GetDeviceFileById?id=' + id);
  },
  requeueDeviceFileById: function requeueDeviceFileById(id) {
    return __WEBPACK_IMPORTED_MODULE_1__api_common__["a" /* default */].post('device/RequeueDeviceFile?id=' + id);
  },
  getToolMakes: function getToolMakes(id) {
    return __WEBPACK_IMPORTED_MODULE_1__api_common__["a" /* default */].get('device/GetToolMakes?id=' + id);
  },
  createDevice: function createDevice(data) {
    return __WEBPACK_IMPORTED_MODULE_1__api_common__["a" /* default */].post('device/CreateDevice', data);
  },
  activateDevice: function activateDevice(data) {
    return __WEBPACK_IMPORTED_MODULE_1__api_common__["a" /* default */].post('smartlink/activateDevice', data);
  },
  getDeviceActivation: function getDeviceActivation(data) {
    return __WEBPACK_IMPORTED_MODULE_1__api_common__["a" /* default */].post('smartlink/DeviceActivatationInfo', data);
  },
  updateDevice: function updateDevice(data) {
    return __WEBPACK_IMPORTED_MODULE_1__api_common__["a" /* default */].post('device/UpdateDevice', data);
  },
  updateDeviceFile: function updateDeviceFile(data) {
    return __WEBPACK_IMPORTED_MODULE_1__api_common__["a" /* default */].post('device/UpdateDeviceFile', data);
  },
  upsertDeviceShipment: function upsertDeviceShipment(data) {
    return __WEBPACK_IMPORTED_MODULE_1__api_common__["a" /* default */].post('device/UpsertDeviceShipment', data);
  },
  addToolMake: function addToolMake(data) {
    return __WEBPACK_IMPORTED_MODULE_1__api_common__["a" /* default */].post('device/AddToolMake', data);
  },
  deleteToolMake: function deleteToolMake(id) {
    return __WEBPACK_IMPORTED_MODULE_1__api_common__["a" /* default */].get('device/DeleteToolMake?id=' + id);
  },
  assignDevice: function assignDevice(data) {
    return __WEBPACK_IMPORTED_MODULE_1__api_common__["a" /* default */].post('device/AssignDevice', data);
  },
  getDevicesForBusiness: function getDevicesForBusiness(businessId, searchOptions) {
    return __WEBPACK_IMPORTED_MODULE_1__api_common__["a" /* default */].get('device/GetDevicesForBusiness', {
      params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({ businessId: businessId }, searchOptions)
    });
  }
});

/***/ }),

/***/ 619:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_common__ = __webpack_require__(8);


/* harmony default export */ __webpack_exports__["default"] = ({
  getAllDeviceTypes: function getAllDeviceTypes() {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].get('devicetype/GetAllDeviceTypes');
  },
  getDeviceTypeImage: function getDeviceTypeImage(id) {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].get('devicetype/GetDeviceTypeImage/' + id, {
      responseType: 'blob'
    });
  },
  upsertDeviceType: function upsertDeviceType(deviceType) {
    var formData = new FormData();

    if (deviceType.id) {
      formData.append('Id', deviceType.id);
    }

    formData.append('Description', deviceType.description);
    formData.append('ExternalName', deviceType.externalName || '');
    formData.append('RemoteProAlias', deviceType.remoteProAlias || '');
    formData.append('LaunchAlias', deviceType.launchAlias || '');
    formData.append('RepairifyAlias', deviceType.repairifyAlias || '');
    formData.append('RedAlias', deviceType.redAlias || '');
    formData.append('RAGEnabled', deviceType.ragEnabled !== undefined ? deviceType.ragEnabled : false);
    formData.append('IsAlphanumericSerial', deviceType.isAlphanumericSerial !== undefined ? deviceType.isAlphanumericSerial : false);

    if (deviceType.imageFile) {
      formData.append('ImageFile', deviceType.imageFile);
    }

    if (deviceType.deletedDate) {
      formData.append('DeletedDate', deviceType.deletedDate);
    }

    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].post('devicetype/UpsertDeviceType', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
  }
});

/***/ }),

/***/ 620:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_common__ = __webpack_require__(8);


/* harmony default export */ __webpack_exports__["default"] = ({
  getFiles: function getFiles(path) {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].get('file/list?folder=' + path);
  },
  getBase64File: function getBase64File(file) {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].get('file/fileBase64?file=' + file);
  },
  getThumbs: function getThumbs(path) {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].get('file/thumbsBase64?path=' + path);
  },
  uploadBase64File: function uploadBase64File(data) {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].post('file/uploadBase64', data);
  }
});

/***/ }),

/***/ 621:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_common__ = __webpack_require__(8);




/* harmony default export */ __webpack_exports__["default"] = ({
  getIssues: function getIssues(key) {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var response;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2__api_common__["a" /* default */].get('admin/issue/' + key + '/2');

            case 2:
              response = _context.sent;
              return _context.abrupt('return', response);

            case 4:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  getStatuses: function getStatuses() {
    var _this2 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
      var response;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2__api_common__["a" /* default */].get('lookup/GetLookupValues?key=workorder.status');

            case 2:
              response = _context2.sent;

              if (response.data && Array.isArray(response.data)) {
                response.data.sort(function (a, b) {
                  return a.text.localeCompare(b.text);
                });
              }
              return _context2.abrupt('return', response);

            case 5:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }))();
  },
  upsertIssue: function upsertIssue(data) {
    return __WEBPACK_IMPORTED_MODULE_2__api_common__["a" /* default */].post('admin/issue/upsert', data);
  }
});

/***/ }),

/***/ 622:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_common__ = __webpack_require__(8);


/* harmony default export */ __webpack_exports__["default"] = ({
  lookup: function lookup(data, config) {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].post('lookup/ByKey', data, config);
  },
  lookups: function lookups(keys, config) {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].post('lookup/ByKeys', keys, config);
  },
  lookupsZeus: function lookupsZeus(key) {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].get('app/GetLookupValues?key=' + key);
  },
  lookupsByGroup: function lookupsByGroup(_ref) {
    var className = _ref.className,
        group = _ref.group;

    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].get('lookup/ByGroup?className=' + className + '&group=' + group);
  },
  serverProfiles: function serverProfiles() {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].get('device/GetServerProfiles');
  },
  scanTypes: function scanTypes() {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].get('lookup/GetScanTypes');
  },
  upsertScanType: function upsertScanType(data) {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].post('lookup/UpsertScanType', data);
  },
  activationCards: function activationCards() {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].get('lookup/GetActivationCards');
  },
  releaseTracks: function releaseTracks() {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].get('lookup/GetReleaseTracks');
  },
  hardwares: function hardwares() {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].get('lookup/GetHardwares');
  },
  upsertActivationCard: function upsertActivationCard(data) {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].post('lookup/UpsertActivationCard', data);
  },
  upsertLookup: function upsertLookup(data) {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].post('lookup/Upsert', data);
  },
  upsertLookupZeus: function upsertLookupZeus(data) {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].post('app/SaveZeusLookup', data);
  },
  upsertProduct: function upsertProduct(data) {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].post('Business/UpsertProduct', data);
  },
  getTimeZones: function getTimeZones() {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].get('lookup/TimeZones');
  },
  getDistributors: function getDistributors() {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].get('lookup/Distributors');
  },
  getSalesReps: function getSalesReps() {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].get('lookup/SalesReps');
  },
  getVehicleManufacturers: function getVehicleManufacturers() {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].get('lookup/VehicleManufacturers');
  },
  getInsuranceCompanies: function getInsuranceCompanies() {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].get('lookup/InsuranceCompanies');
  },
  getProducts: function getProducts() {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].get('lookup/Products');
  },
  getStates: function getStates(id) {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].get('lookup/StateProvince?id=' + id);
  },
  getCountries: function getCountries() {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].get('lookup/Countries');
  },
  getLanguages: function getLanguages() {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].get('lookup/Languages');
  },
  savePreCannedMessages: function savePreCannedMessages(data, config) {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].post('lookup/SavePrecannedMessages', data, config);
  },
  getVehicleMakes: function getVehicleMakes(year) {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].get('lookup/VehicleMakes/?year=' + year);
  },
  getProductAdds: function getProductAdds() {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].get('lookup/ProductAdds');
  },
  upsertProductAdd: function upsertProductAdd(data) {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].post('Business/UpsertProductAdd', data);
  },
  getMakes: function getMakes(showAll) {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].get('lookup/GetMakes?showAll=' + showAll);
  },
  saveMakes: function saveMakes(data, config) {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].post('lookup/SaveMakes', data, config);
  },
  getProductMakes: function getProductMakes() {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].get('lookup/ProductMakes');
  },
  getLaunchAccountList: function getLaunchAccountList() {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].get('smartlink/GetLaunchAccountList');
  },
  upsertProductMake: function upsertProductMake(data) {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].post('Business/UpsertProductMake', data);
  },
  getRagRatingList: function getRagRatingList() {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].get('lookup/RagRatingList');
  },
  getDeviceManufactureModels: function getDeviceManufactureModels() {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].get('app/GetDeviceManufactureAndModels');
  }
});

/***/ }),

/***/ 623:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_common__ = __webpack_require__(8);


/* harmony default export */ __webpack_exports__["default"] = ({
  addInsurance: function addInsurance(data) {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].get('maintenance/SaveInsurance?name=' + data);
  },
  getWorkOrderMaintenance: function getWorkOrderMaintenance(workOrder) {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].get('maintenance/GetWorkOrder', {
      params: { workOrder: workOrder }
    });
  },
  saveWorkOrderMaintenance: function saveWorkOrderMaintenance(data) {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].post('maintenance/SaveWorkOrder', data);
  },
  fixDispatchTimes: function fixDispatchTimes() {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].get('maintenance/FixDispatchTimes');
  },
  cancelPendingRequests: function cancelPendingRequests(location) {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].get('maintenance/CancelPendingRequests', {
      params: { location: location }
    });
  },
  searchTechnicians: function searchTechnicians(searchTerm) {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].get('maintenance/SearchTechnicians/?search=' + searchTerm);
  },
  resetTechnician: function resetTechnician(data) {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].post('maintenance/ResetTechnician', data);
  }
});

/***/ }),

/***/ 624:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_common__ = __webpack_require__(8);


/* harmony default export */ __webpack_exports__["default"] = ({
  getStandardOpeningHours: function getStandardOpeningHours(tenantId) {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].get('openingHours/GetStandardOpeningHours?tenantId=' + tenantId);
  },
  getHolidayOpeningHours: function getHolidayOpeningHours(tenantId) {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].get('openingHours/GetHolidayOpeningHours?tenantId=' + tenantId);
  },
  getStandardOpeningHoursForList: function getStandardOpeningHoursForList() {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].get('openingHours/StandardOpeningHoursForList');
  },
  getStandardOpeningHoursForId: function getStandardOpeningHoursForId(id) {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].get('openingHours/StandardOpeningHoursForId?id=' + id);
  },
  getHolidayOpeningHoursForId: function getHolidayOpeningHoursForId(id) {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].get('openingHours/HolidayOpeningHoursForId?id=' + id);
  },
  getTenantDetails: function getTenantDetails() {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].get('openingHours/TenantDetails');
  },
  updateStandardOpeningHours: function updateStandardOpeningHours(data) {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].post('openingHours/UpdateStandardOpeningHours', data);
  },
  updateHolidayOpeningHours: function updateHolidayOpeningHours(data) {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].post('openingHours/UpdateHolidayOpeningHours', data);
  },
  insertHolidayOpeningHours: function insertHolidayOpeningHours(data) {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].post('openingHours/InsertHolidayOpeningHours', data);
  },
  deleteHolidaySchedule: function deleteHolidaySchedule(data) {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].post('openingHours/DeleteHolidayOpeningHours', data);
  },
  updateTenantSupportEmail: function updateTenantSupportEmail(data) {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].post('openingHours/UpdateTenantSupportEmail', data);
  },
  getOutOfHoursAuditLog: function getOutOfHoursAuditLog(searchOptions) {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].post('openingHours/GetAuditLog', searchOptions);
  }
});

/***/ }),

/***/ 625:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_common__ = __webpack_require__(8);


/* harmony default export */ __webpack_exports__["default"] = ({
  getScanTools: function getScanTools() {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].get('lookup/GetScanTools');
  },
  saveScanTool: function saveScanTool(data) {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].post('lookup/SaveScanTool', data);
  },
  removeScanTool: function removeScanTool(id) {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].get('lookup/RemoveScanTool?id=' + id);
  },
  getReportTemplates: function getReportTemplates(area) {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].get('lookup/GetReportTemplates?area=' + area);
  },
  saveReportTemplate: function saveReportTemplate(data) {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].post('lookup/SaveReportTemplate', data);
  },
  removeReportTemplate: function removeReportTemplate(id) {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].get('lookup/RemoveReportTemplate?id=' + id);
  }
});

/***/ }),

/***/ 626:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_common__ = __webpack_require__(8);


/* harmony default export */ __webpack_exports__["default"] = ({
  saveScanProConfiguration: function saveScanProConfiguration(data) {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].post('scanpro/SaveScanProConfiguration', data);
  },
  getScanProConfiguration: function getScanProConfiguration(id) {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].get('scanpro/ScanProConfiguration?id=' + id);
  },
  decodeVin: function decodeVin(vin) {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].get('decoder/DecodeVin?vin=' + vin);
  },
  evaluateVehicle: function evaluateVehicle(data) {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].post('scanpro/EvaluateVehicle', data);
  },
  saveScanProResults: function saveScanProResults(data) {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].post('scanpro/SaveScanProResults', data);
  }
});

/***/ }),

/***/ 627:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_common__ = __webpack_require__(8);


/* harmony default export */ __webpack_exports__["default"] = ({
  serviceElements: function serviceElements() {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].get('ragrating/GetServiceElementList');
  },
  upsertServiceElement: function upsertServiceElement(data) {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].post('ragrating/UpsertServiceElement', data);
  },
  getServiceElementGroups: function getServiceElementGroups() {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].get('ragrating/GetServiceElementGroups');
  },
  getDistinctVehicleMakes: function getDistinctVehicleMakes() {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].get('ragrating/GetVehicleMakes');
  },
  getDistinctVehicleModels: function getDistinctVehicleModels(_ref) {
    var make = _ref.make,
        year = _ref.year;

    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].get('ragrating/GetVehicleModels?make=' + make + '&year=' + year);
  },
  getServiceElementsRagRating: function getServiceElementsRagRating(_ref2) {
    var make = _ref2.make,
        model = _ref2.model,
        year = _ref2.year,
        deviceId = _ref2.deviceId,
        orderBy = _ref2.orderBy,
        sortBy = _ref2.sortBy;

    var encodedMake = encodeURIComponent(make || '');
    var encodedModel = encodeURIComponent(model || '');

    var url = 'ragrating/GetServiceElementsRagRating?make=' + encodedMake + '&model=' + encodedModel + '&year=' + year + '&orderBy=' + orderBy + '&sortBy=' + sortBy + '&deviceTypeId=' + deviceId;

    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].get(url);
  },
  getVehicleRagRatingId: function getVehicleRagRatingId(_ref3) {
    var make = _ref3.make,
        model = _ref3.model,
        year = _ref3.year;

    var encodedMake = encodeURIComponent(make || '');
    var encodedModel = encodeURIComponent(model || '');
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].get('ragrating/GetRAGRatingVehicleId?make=' + encodedMake + '&model=' + encodedModel + '&year=' + year);
  },
  updateRagRating: function updateRagRating(data) {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].post('ragrating/UpdateRagRatingForServiceElement', data);
  },
  bulkCopyRagRating: function bulkCopyRagRating(_ref4) {
    var bulkCopyParams = _ref4.bulkCopyParams;

    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].post('ragrating/BulkCopyRagRatings', bulkCopyParams);
  },
  copyRagRating: function copyRagRating(_ref5) {
    var sourceVehicleId = _ref5.sourceVehicleId,
        targetVehicleId = _ref5.targetVehicleId;

    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].post('ragrating/CopyRagRatings?sourceVehicleId=' + sourceVehicleId + '&targetVehicleId=' + targetVehicleId);
  },
  audit: function audit(_ref6) {
    var auditDetails = _ref6.auditDetails;

    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].post('ragrating/Audit', auditDetails);
  },
  getRagAuditTypeList: function getRagAuditTypeList() {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].get('ragrating/GetAuditTypeList');
  },
  getAuditLog: function getAuditLog(searchOptions) {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].post('ragrating/GetAuditLog', searchOptions);
  },
  getDeviceTypes: function getDeviceTypes() {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].get('ragrating/GetRagDeviceTypes');
  }
});

/***/ }),

/***/ 628:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_common__ = __webpack_require__(8);


/* harmony default export */ __webpack_exports__["default"] = ({
  getServiceRequests: function getServiceRequests(searchOptions) {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].get('serviceRequest/GetServiceRequests', {
      params: searchOptions
    });
  },
  backDateServiceRequest: function backDateServiceRequest(workOrder) {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].get('serviceRequest/AdjustWorkOrderCreatedDate?workOrderId=' + workOrder);
  },
  getServiceRequestsWithMessages: function getServiceRequestsWithMessages(searchOptions) {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].get('serviceRequest/ServiceRequestsForList', {
      params: searchOptions
    });
  },
  getServiceRequestsForList: function getServiceRequestsForList(searchOptions) {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].get('serviceRequest/ServiceRequestsForList', {
      params: searchOptions
    });
  },
  getServiceRequest: function getServiceRequest(id) {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].get('serviceRequest/ServiceRequest?id=' + id);
  },
  getServiceRequestHistory: function getServiceRequestHistory(id) {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].get('serviceRequest/GetServiceRequestHistory?id=' + id);
  },
  getServiceRequestIssues: function getServiceRequestIssues(id) {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].get('issue/GetIssues?&status=ByRequest&searchTerm=' + id);
  }
});

/***/ }),

/***/ 629:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_common__ = __webpack_require__(8);


/* harmony default export */ __webpack_exports__["default"] = ({
  getReportTranslations: function getReportTranslations(code) {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].get('app/GetReportTranslations?code=' + code);
  },
  saveTranslations: function saveTranslations(data) {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].post('app/SaveReportTranslations', data);
  },
  translateAllReportSections: function translateAllReportSections(code) {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].get('app/TranslateAllReportSections?code=' + code);
  },
  getServiceElementTranslations: function getServiceElementTranslations(cultureCode) {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].get('app/GetServiceElementTranslations?cultureCode=' + cultureCode);
  },
  saveServiceElementTranslations: function saveServiceElementTranslations(data) {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].post('app/SaveServiceElementTranslations', data);
  },
  translateAllServiceElements: function translateAllServiceElements(cultureCode) {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].get('app/TranslateAllServiceElements?cultureCode=' + cultureCode);
  },
  localeTranslation: function localeTranslation(data) {
    console.log('API Locale Translation', data);
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].post('app/AppLabelTranslations', data);
  },
  getRagCustomMessageTranslations: function getRagCustomMessageTranslations(cultureCode) {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].get('ragRating/GetRagCustomMessageTranslations?cultureCode=' + cultureCode);
  },
  processCustomMessageTranslations: function processCustomMessageTranslations(data) {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].post('ragRating/ProcessCustomMessageTranslations', data);
  },
  deleteCustomMessageTranslations: function deleteCustomMessageTranslations(translationIds) {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].post('ragRating/DeleteCustomMessageTranslations', { translationIds: translationIds });
  }
});

/***/ }),

/***/ 630:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_common__ = __webpack_require__(8);


/* harmony default export */ __webpack_exports__["default"] = ({
  getUser: function getUser(username) {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].get('user/GetUserByName?username=' + username);
  },
  getUsers: function getUsers(searchOptions) {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].get('user/GetUsers', {
      params: searchOptions
    });
  },
  downloadAllUsers: function downloadAllUsers() {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].get('user/GetAllUsers');
  },
  createUser: function createUser(data) {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].post('user/CreateUser', data);
  },
  updateUser: function updateUser(data) {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].post('user/UpdateUser', data);
  },
  checkEmailExists: function checkEmailExists(id, email) {
    return __WEBPACK_IMPORTED_MODULE_0__api_common__["a" /* default */].post('user/EmailExists?userID=' + id + '&email=' + encodeURIComponent(email));
  }
});

/***/ }),

/***/ 631:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["currencyUSD"] = currencyUSD;
var digitsRE = /(\d{3})(?=\d)/g;

function currencyUSD(value, currency, decimals) {
  var originalValue = value;
  value = parseFloat(value);
  if (!isFinite(value) || !value && value !== 0) return originalValue;
  currency = currency != null ? currency : '$';
  decimals = decimals != null ? decimals : 2;
  var stringified = Math.abs(value).toFixed(decimals);
  var _int = decimals ? stringified.slice(0, -1 - decimals) : stringified;
  var i = _int.length % 3;
  var head = i > 0 ? _int.slice(0, i) + (_int.length > 3 ? ',' : '') : '';
  var _float = decimals ? stringified.slice(-1 - decimals) : '';
  var sign = value < 0 ? '-' : '';
  return sign + currency + head + _int.slice(i).replace(digitsRE, '$1,') + _float;
}

/***/ }),

/***/ 632:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["shortDate"] = shortDate;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);


function shortDate(value) {
  return __WEBPACK_IMPORTED_MODULE_0_moment___default()(value).format('MM/DD/YYYY hh:mm:ssa');
}

/***/ }),

/***/ 633:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_polyfill__ = __webpack_require__(574);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_polyfill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__app__ = __webpack_require__(577);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__app___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__app__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__locales__ = __webpack_require__(572);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__router__ = __webpack_require__(225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__store__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__logger__ = __webpack_require__(573);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__filters__ = __webpack_require__(571);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vee_validate__ = __webpack_require__(576);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vuejs_paginate__ = __webpack_require__(227);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vuejs_paginate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_vuejs_paginate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_v_mask__ = __webpack_require__(575);














__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].config.errorHandler = __WEBPACK_IMPORTED_MODULE_7__logger__["a" /* default */];

__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(__WEBPACK_IMPORTED_MODULE_8__filters__["a" /* default */]).forEach(function (filter) {
  __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(__WEBPACK_IMPORTED_MODULE_8__filters__["a" /* default */][filter]).forEach(function (f) {
    __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].filter(f, __WEBPACK_IMPORTED_MODULE_8__filters__["a" /* default */][filter][f]);
  });
});

__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_9_vee_validate__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].component('paginate', __WEBPACK_IMPORTED_MODULE_10_vuejs_paginate___default.a);

__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_11_v_mask__["a" /* default */]);

window.app = new __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_5__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */],
  i18n: __WEBPACK_IMPORTED_MODULE_4__locales__["a" /* default */],
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_3__app___default.a);
  }
});

__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].directive('ctk-tooltip', {
  bind: function bind(el, binding) {
    el.addEventListener('mouseenter', function () {
      var $tooltip = document.createElement('div');
      var $tooltipDimension = el.getBoundingClientRect();
      var top = (window.pageYOffset || document.documentElement.scrollTop) - (document.documentElement.clientTop || 0);
      $tooltip.setAttribute('class', 'ctk-tooltip');
      $tooltip.setAttribute('id', 'CtkTooltip');
      $tooltip.innerHTML = binding.value;
      $tooltip.style.left = $tooltipDimension.left + $tooltipDimension.width / 2 + 'px';
      $tooltip.style.top = top - 30 + 'px';
      document.body.appendChild($tooltip);
    });
    el.addEventListener('mouseleave', function () {
      var elemToRemove = document.getElementById('CtkTooltip');
      elemToRemove.parentNode.removeChild(elemToRemove);
    });
  }
});

/***/ }),

/***/ 634:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store__ = __webpack_require__(94);


/* harmony default export */ __webpack_exports__["a"] = (function (to, from, next) {
  console.log('Guard routing to ', to);
  if (to.path === '/login') {
    next();
    return;
  }
  console.log('checking anonymous...');

  if (to.matched.some(function (record) {
    return record.meta.allowAnonymous;
  })) {
    next();
    return;
  }
  console.log('checking login...');

  if (!__WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].getters['authorize/token']) {
    __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].dispatch('authorize/setPassthrough', to.path);
    console.log('going to login');
    next('/login');
    return;
  }
  console.log('authorized');

  if (!__WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].getters['authorize/isAllowed'](to.path)) {
    console.log('not allowed...');
    next('/notauthorized');
    return;
  }
  console.log('allowed, continuing...');

  next();
});

/***/ }),

/***/ 635:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store__ = __webpack_require__(94);


/* harmony default export */ __webpack_exports__["a"] = ([{
  path: '/',
  redirect: function redirect(to) {
    var role = __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].getters['authorize/primaryRole'];
    console.log('Redirect Role', role);
    return 'business';
  },
  component: function component(resolve) {
    __webpack_require__.e/* require */(38).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1095)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  },

  children: [{
    path: 'notauthorized',
    component: function component(resolve) {
      __webpack_require__.e/* require */(40).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1093)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },

    meta: { allowAnonymous: true }
  }, {
    path: 'login',
    component: function component(resolve) {
      __webpack_require__.e/* require */(39).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1094)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },

    meta: { allowAnonymous: true }
  }, {
    path: 'business',
    component: function component(resolve) {
      __webpack_require__.e/* require */(21).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1085)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: 'business/:action/:id?',
    component: function component(resolve) {
      __webpack_require__.e/* require */(1).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1084)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: 'dashboard/requests',
    component: function component(resolve) {
      __webpack_require__.e/* require */(9).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1090)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: 'dashboard/statistics',
    component: function component(resolve) {
      __webpack_require__.e/* require */(23).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1091)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: 'dashboard/devicestatistics',
    component: function component(resolve) {
      __webpack_require__.e/* require */(24).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1089)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: 'dashboard/activationcardstatistics',
    component: function component(resolve) {
      __webpack_require__.e/* require */(27).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1086)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: 'dashboard/businessaccountsinfo',
    component: function component(resolve) {
      __webpack_require__.e/* require */(26).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1087)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: 'dashboard/deviceshipments',
    component: function component(resolve) {
      __webpack_require__.e/* require */(25).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1088)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: 'users',
    component: function component(resolve) {
      __webpack_require__.e/* require */(11).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1096)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: 'users/:action/:id?',
    component: function component(resolve) {
      __webpack_require__.e/* require */(12).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1097)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: 'admin/defaults',
    component: function component(resolve) {
      __webpack_require__.e/* require */(3).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1062)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: 'admin/salesreps',
    component: function component(resolve) {
      __webpack_require__.e/* require */(20).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1081)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: 'admin/translation',
    component: function component(resolve) {
      __webpack_require__.e/* require */(14).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1083)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: 'admin/message',
    component: function component(resolve) {
      __webpack_require__.e/* require */(18).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1073)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: 'admin/devices',
    component: function component(resolve) {
      __webpack_require__.e/* require */(4).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1066)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: 'admin/device-detail/:id?',
    component: function component(resolve) {
      __webpack_require__.e/* require */(8).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1063)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: 'admin/device-file-detail/:id?',
    component: function component(resolve) {
      __webpack_require__.e/* require */(32).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1064)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: 'admin/device-files',
    component: function component(resolve) {
      __webpack_require__.e/* require */(29).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1065)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: 'admin/integrations',
    component: function component(resolve) {
      __webpack_require__.e/* require */(28).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1069)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: 'admin/integration-detail/:id?',
    component: function component(resolve) {
      __webpack_require__.e/* require */(31).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1068)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: 'admin/maintenance',
    component: function component(resolve) {
      __webpack_require__.e/* require */(5).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1071)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: 'admin/report',
    component: function component(resolve) {
      __webpack_require__.e/* require */(6).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1080)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: 'admin/chat',
    component: function component(resolve) {
      __webpack_require__.e/* require */(2).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1060)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: 'admin/calibrate',
    component: function component(resolve) {
      __webpack_require__.e/* require */(22).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1058)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: 'admin/mobile',
    component: function component(resolve) {
      __webpack_require__.e/* require */(19).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1074)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: 'admin/files',
    component: function component(resolve) {
      __webpack_require__.e/* require */(37).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1067)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: 'admin/scanpro',
    component: function component(resolve) {
      __webpack_require__.e/* require */(10).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1082)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: 'admin/makes',
    component: function component(resolve) {
      __webpack_require__.e/* require */(17).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1072)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: 'admin/calibration-homepage-message',
    component: function component(resolve) {
      __webpack_require__.e/* require */(34).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1059)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: 'admin/openinghours/opening-hours',
    component: function component(resolve) {
      __webpack_require__.e/* require */(7).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1076)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: 'admin/openinghours/auditLog',
    component: function component(resolve) {
      __webpack_require__.e/* require */(30).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1075)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: 'admin/rag/maintain-rag-ratings',
    component: function component(resolve) {
      __webpack_require__.e/* require */(0).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(587)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: 'admin/rag/auditLog',
    component: function component(resolve) {
      __webpack_require__.e/* require */(33).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1077)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: 'admin/rag/maintenance',
    component: function component(resolve) {
      __webpack_require__.e/* require */(0/* duplicate */).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(587)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: 'admin/rag/service-element-translation',
    component: function component(resolve) {
      __webpack_require__.e/* require */(15).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1079)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: 'admin/rag/custom-message-translation',
    component: function component(resolve) {
      __webpack_require__.e/* require */(13).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1078)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: 'admin/issues',
    component: function component(resolve) {
      __webpack_require__.e/* require */(36).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1070)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: 'admin/business-profiles',
    component: function component(resolve) {
      __webpack_require__.e/* require */(16).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1057)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: 'admin/connected-devices',
    component: function component(resolve) {
      __webpack_require__.e/* require */(35).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1061)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }]
}, {
  path: '*',
  component: function component(resolve) {
    __webpack_require__.e/* require */(41).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1092)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  },

  meta: { allowAnonymous: true }
}]);

/***/ }),

/***/ 636:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "admin", function() { return admin; });
var admin = {
  namespaced: true,
  state: {
    salesRepresentatives: []
  },
  getters: {
    salesRepresentatives: function salesRepresentatives(state) {
      return state.salesRepresentatives;
    }
  },
  actions: {},
  mutations: {
    ADD_SALES_REPRESENTATIVE: function ADD_SALES_REPRESENTATIVE(state, defaultTitleId) {
      state.salesRepresentatives.push({
        id: 0,
        firstName: null,
        lastName: null,
        hasLogin: false,
        username: null,
        email: null,
        password: null,
        requiresPasswordOnSubmit: false,
        isEnabled: false,
        isLockout: false,
        receivesInvoices: false,
        receivesReports: false,
        receivesReportsOnly: false,
        receivesChatReports: false,
        isAstechUser: false,
        titleId: defaultTitleId,
        phone: null
      });
    }
  }
};

/***/ }),

/***/ 637:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "authorize", function() { return authorize; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__state__ = __webpack_require__(244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getters__ = __webpack_require__(242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mutations__ = __webpack_require__(243);





var authorize = {
  namespaced: true,
  state: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__state__["default"])(),
  getters: __WEBPACK_IMPORTED_MODULE_1__getters__["default"],
  actions: __WEBPACK_IMPORTED_MODULE_2__actions__["default"],
  mutations: __WEBPACK_IMPORTED_MODULE_3__mutations__["default"]
};

/***/ }),

/***/ 638:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "business", function() { return business; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__state__ = __webpack_require__(248);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getters__ = __webpack_require__(246);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mutations__ = __webpack_require__(247);





var business = {
  namespaced: true,
  state: __WEBPACK_IMPORTED_MODULE_0__state__["default"],
  getters: __WEBPACK_IMPORTED_MODULE_1__getters__["default"],
  actions: __WEBPACK_IMPORTED_MODULE_2__actions__["default"],
  mutations: __WEBPACK_IMPORTED_MODULE_3__mutations__["default"]
};

/***/ }),

/***/ 639:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "calibrate", function() { return calibrate; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__state__ = __webpack_require__(252);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getters__ = __webpack_require__(250);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mutations__ = __webpack_require__(251);





var calibrate = {
  namespaced: true,
  state: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__state__["default"])(),
  getters: __WEBPACK_IMPORTED_MODULE_1__getters__["default"],
  actions: __WEBPACK_IMPORTED_MODULE_2__actions__["default"],
  mutations: __WEBPACK_IMPORTED_MODULE_3__mutations__["default"]
};

/***/ }),

/***/ 640:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "chat", function() { return chat; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__state__ = __webpack_require__(257);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getters__ = __webpack_require__(255);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(254);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mutations__ = __webpack_require__(256);





var chat = {
  namespaced: true,
  state: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__state__["default"])(),
  getters: __WEBPACK_IMPORTED_MODULE_1__getters__["default"],
  actions: __WEBPACK_IMPORTED_MODULE_2__actions__["default"],
  mutations: __WEBPACK_IMPORTED_MODULE_3__mutations__["default"]
};

/***/ }),

/***/ 641:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "configuration", function() { return configuration; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__plugins_storage__ = __webpack_require__(580);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__types__ = __webpack_require__(258);






var configuration = {
  namespaced: true,
  state: {
    configuration: JSON.parse(__WEBPACK_IMPORTED_MODULE_3__plugins_storage__["a" /* default */].local.getItem(__WEBPACK_IMPORTED_MODULE_4__types__["CONFIGURATION"])) || []
  },
  getters: {
    configuration: function configuration(state) {
      return state.configuration;
    }
  },
  actions: {
    getConfigurationValues: function getConfigurationValues(_ref) {
      var commit = _ref.commit;

      var key = 'configuration';
      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].lookupsZeus(key, { headers: { 'content-type': 'application/json' } }).then(function (response) {
          commit(__WEBPACK_IMPORTED_MODULE_4__types__["SET_CONFIGURATION"], response.data);
          resolve(response);
        }).catch(function (error) {
          return reject(error);
        });
      });
    }
  },
  mutations: {
    SET_CONFIGURATION: function SET_CONFIGURATION(state, data) {
      state.configuration = data;
      __WEBPACK_IMPORTED_MODULE_3__plugins_storage__["a" /* default */].local.setItem(__WEBPACK_IMPORTED_MODULE_4__types__["CONFIGURATION"], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data));
    }
  }
};

/***/ }),

/***/ 642:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "connectedDevices", function() { return connectedDevices; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__state__ = __webpack_require__(262);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getters__ = __webpack_require__(260);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(259);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mutations__ = __webpack_require__(261);





var connectedDevices = {
  namespaced: true,
  state: __WEBPACK_IMPORTED_MODULE_0__state__["default"],
  getters: __WEBPACK_IMPORTED_MODULE_1__getters__["default"],
  actions: __WEBPACK_IMPORTED_MODULE_2__actions__["default"],
  mutations: __WEBPACK_IMPORTED_MODULE_3__mutations__["default"]
};

/***/ }),

/***/ 643:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "connectSync", function() { return connectSync; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api__ = __webpack_require__(11);




var connectSync = {
  namespaced: true,
  state: {
    documentUploads: [],
    documentTypes: [],
    statusSyncs: []
  },
  getters: {
    documentUploads: function documentUploads(state) {
      return state.documentUploads;
    },
    documentTypes: function documentTypes(state) {
      return state.documentTypes;
    },
    statusSyncs: function statusSyncs(state) {
      return state.statusSyncs;
    }
  },
  mutations: {
    SET_DOCUMENT_UPLOADS: function SET_DOCUMENT_UPLOADS(state, data) {
      state.documentUploads = data || [];
    },
    SET_DOCUMENT_TYPES: function SET_DOCUMENT_TYPES(state, data) {
      state.documentTypes = data || [];
    },
    SET_STATUS_SYNCS: function SET_STATUS_SYNCS(state, data) {
      state.statusSyncs = data || [];
    }
  },
  actions: {
    getDocumentUploads: function getDocumentUploads(_ref, workOrderId) {
      var _this = this;

      var commit = _ref.commit;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].getDocumentUploads(workOrderId);

              case 2:
                response = _context.sent;

                commit('SET_DOCUMENT_UPLOADS', response.data);

              case 4:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    getDocumentTypes: function getDocumentTypes(_ref2) {
      var _this2 = this;

      var commit = _ref2.commit;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].getConnectDocumentTypes();

              case 2:
                response = _context2.sent;

                commit('SET_DOCUMENT_TYPES', response.data);

              case 4:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    resendDocumentUpload: function resendDocumentUpload(context, id) {
      return __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].resendDocumentUpload(id);
    },
    getDocumentPreview: function getDocumentPreview(context, _ref3) {
      var workOrderId = _ref3.workOrderId,
          documentTypeId = _ref3.documentTypeId;

      return __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].getDocumentPreview(workOrderId, documentTypeId);
    },
    getStatusSyncs: function getStatusSyncs(_ref4, workOrderId) {
      var _this3 = this;

      var commit = _ref4.commit;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].getStatusSyncs(workOrderId);

              case 2:
                response = _context3.sent;

                commit('SET_STATUS_SYNCS', response.data);

              case 4:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    },
    resendStatusSync: function resendStatusSync(context, id) {
      return __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].resendStatusSync(id);
    }
  }
};

/***/ }),

/***/ 644:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "countries", function() { return countries; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api__ = __webpack_require__(11);




var countries = {
  namespaced: true,
  state: {
    countries: [],
    stateProvinces: []
  },
  getters: {
    countries: function countries(state) {
      return state.countries;
    },
    stateProvinces: function stateProvinces(state) {
      return state.stateProvinces;
    }
  },
  actions: {
    getAllCountries: function getAllCountries(_ref) {
      var commit = _ref.commit;

      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].getAllCountries({ headers: { 'content-type': 'application/json' } }).then(function (response) {
          commit('SET_COUNTRIES', JSON.parse(response.data));
          resolve(response);
        });
      });
    },
    getStateProvinces: function getStateProvinces(_ref2, id) {
      var commit = _ref2.commit;

      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].getStateProvinces(id).then(function (response) {
          commit('SET_STATE_PROVINCES', response.data);
          resolve(response);
        });
      });
    },
    resetStateProvinces: function resetStateProvinces(_ref3) {
      var commit = _ref3.commit;

      commit('SET_STATE_PROVINCES', null);
    },
    upsertCountry: function upsertCountry(_ref4, country) {
      var commit = _ref4.commit;

      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].upsertCountry(country).then(function (response) {
          country.id = response.data;
          if (response.status === 200) {
            commit('SET_COUNTRY', country);
          }
          resolve(response);
        });
      });
    },
    upsertStateProvince: function upsertStateProvince(_ref5, stateProvince) {
      var commit = _ref5.commit;

      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].upsertStateProvince(stateProvince).then(function (response) {
          stateProvince.id = response.data;
          if (response.status === 200) {
            commit('SET_STATE_PROVINCE', stateProvince);
          }
          resolve(response);
        });
      });
    },
    deleteStateProvince: function deleteStateProvince(_ref6, stateProvince) {
      var commit = _ref6.commit;

      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].deleteStateProvince(stateProvince).then(function (response) {
          resolve(response);
        });
      });
    }
  },
  mutations: {
    SET_COUNTRIES: function SET_COUNTRIES(state, data) {
      state.countries = data;
    },
    SET_COUNTRY: function SET_COUNTRY(state, data) {
      if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(data.id) === 'object' && data.id.error) {
        return;
      }

      var idx = state.countries.findIndex(function (i) {
        return i.id === data.id;
      });

      if (parseInt(idx) !== -1) {
        state.countries[idx].name = data.name;
        state.countries[idx].abbreviation = data.abbreviation;
      } else {
        var lookup = {
          id: data.id,
          name: data.name,
          abbreviation: data.abbreviation
        };
        state.countries.push(lookup);
      }
    },
    SET_STATE_PROVINCES: function SET_STATE_PROVINCES(state, stateProvinces) {
      state.stateProvinces = stateProvinces || [];
    },
    SET_STATE_PROVINCE: function SET_STATE_PROVINCE(state, data) {
      if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(data.id) === 'object' && data.id.error) {
        return;
      }

      var idx = state.stateProvinces.findIndex(function (i) {
        return i.id === data.id;
      });

      if (parseInt(idx) !== -1) {
        state.stateProvinces[idx].name = data.name;
        state.stateProvinces[idx].abbreviation = data.abbreviation;
      } else {
        var lookup = {
          id: data.id,
          name: data.name,
          abbreviation: data.abbreviation,
          countryId: data.countryId
        };
        state.stateProvinces.push(lookup);
      }
    }
  }
};

/***/ }),

/***/ 645:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "dashboard", function() { return dashboard; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__state__ = __webpack_require__(267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getters__ = __webpack_require__(265);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(264);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mutations__ = __webpack_require__(266);





var dashboard = {
  namespaced: true,
  state: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__state__["default"])(),
  getters: __WEBPACK_IMPORTED_MODULE_1__getters__["default"],
  actions: __WEBPACK_IMPORTED_MODULE_2__actions__["default"],
  mutations: __WEBPACK_IMPORTED_MODULE_3__mutations__["default"]
};

/***/ }),

/***/ 646:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "devices", function() { return devices; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__state__ = __webpack_require__(271);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getters__ = __webpack_require__(269);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mutations__ = __webpack_require__(270);





var devices = {
  namespaced: true,
  state: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__state__["default"])(),
  getters: __WEBPACK_IMPORTED_MODULE_1__getters__["default"],
  actions: __WEBPACK_IMPORTED_MODULE_2__actions__["default"],
  mutations: __WEBPACK_IMPORTED_MODULE_3__mutations__["default"]
};

/***/ }),

/***/ 647:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "files", function() { return files; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__state__ = __webpack_require__(275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getters__ = __webpack_require__(273);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(272);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mutations__ = __webpack_require__(274);





var files = {
  namespaced: true,
  state: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__state__["default"])(),
  getters: __WEBPACK_IMPORTED_MODULE_1__getters__["default"],
  actions: __WEBPACK_IMPORTED_MODULE_2__actions__["default"],
  mutations: __WEBPACK_IMPORTED_MODULE_3__mutations__["default"]
};

/***/ }),

/***/ 648:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "integrations", function() { return integrations; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__state__ = __webpack_require__(280);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getters__ = __webpack_require__(278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mutations__ = __webpack_require__(279);





var integrations = {
  namespaced: true,
  state: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__state__["default"])(),
  getters: __WEBPACK_IMPORTED_MODULE_1__getters__["default"],
  actions: __WEBPACK_IMPORTED_MODULE_2__actions__["default"],
  mutations: __WEBPACK_IMPORTED_MODULE_3__mutations__["default"]
};

/***/ }),

/***/ 649:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "locales", function() { return locales; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set__ = __webpack_require__(583);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(579);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);


var defaultLang = __webpack_require__.i({"NODE_ENV":"production"}).defaultLang || window.localStorage.getItem('_lang') || window.app.defaultLang;

var locales = {
  state: {
    i18n_loaded: false,
    i18n_lang: defaultLang,
    i18n_allowedLang: [defaultLang] },
  getters: {
    i18n_lang: function i18n_lang(state) {
      return state.i18n_lang;
    },
    i18n_isValidLang: function i18n_isValidLang(state) {
      return function (lang) {
        return state.i18n_allowedLang.includes(lang);
      };
    },
    i18n_allowedLang: function i18n_allowedLang(state) {
      return [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set___default.a(state.i18n_allowedLang)));
    }
  },
  actions: {
    i18n_addAllowedLang: function i18n_addAllowedLang(_ref, lang) {
      var commit = _ref.commit;

      commit('SET_I18N_ALLOWED_LANG', lang);
    },
    i18n_setLang: function i18n_setLang(_ref2, lang) {
      var commit = _ref2.commit,
          state = _ref2.state;

      if (!state.i18n_allowedLang.includes(lang)) {
        lang = state.i18n_lang || defaultLang;
      }
      if (lang === state.i18n_lang && state.i18n_loaded) {
        return;
      }
      commit('SET_I18N_LANG', lang);
      commit('SET_I18N_LOADED', true);
    },
    i18n_changeLang: function i18n_changeLang(_ref3, lang) {
      var commit = _ref3.commit,
          state = _ref3.state;

      var path = window.location.pathname.replace(state.i18n_lang, lang);
      console.log(window.location.replace(path));
    }
  },
  mutations: {
    SET_I18N_LANG: function SET_I18N_LANG(state, lang) {},
    SET_I18N_LOADED: function SET_I18N_LOADED(state, loaded) {
      state.i18n_loaded = loaded;
    },
    SET_I18N_ALLOWED_LANG: function SET_I18N_ALLOWED_LANG(state, lang) {
      state.i18n_allowedLang.push(lang);
    }
  }
};

/***/ }),

/***/ 650:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "lookup", function() { return lookup; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api__ = __webpack_require__(11);





var LOOKUP_CACHE_TTL_MS = 30 * 60 * 1000;

function isFresh(state, cacheKey) {
  var fetchedAt = state.fetchedAt[cacheKey];
  return !!fetchedAt && Date.now() - fetchedAt < LOOKUP_CACHE_TTL_MS;
}

var lookup = {
  namespaced: true,
  state: {
    lookups: {},
    lookupsZeus: {},
    serverProfiles: [],
    timezones: [],
    states: [],
    countries: [],
    languages: [],
    products: [],
    insuranceCompanies: [],
    vehicleManufacturers: [],
    vehicleMakes: [],
    productAdds: [],
    productMakes: [],
    groups: [],
    invoiceMethods: [],
    taxRates: [],
    scanTypes: [],
    launchAccounts: [],
    serviceElementGroups: [],
    deviceManufactureModels: [],
    brands: [],
    activationTypes: [],
    activationCards: [],
    hardwares: [],
    releaseTracks: [],
    suppliers: [],
    fetchedAt: {}
  },
  getters: {
    lookups: function lookups(state) {
      return state.lookups;
    },
    lookupsZeus: function lookupsZeus(state) {
      return state.lookupsZeus;
    },
    serverProfiles: function serverProfiles(state) {
      return state.serverProfiles;
    },
    timezones: function timezones(state) {
      return state.timezones;
    },
    states: function states(state) {
      return state.states;
    },
    countries: function countries(state) {
      return state.countries;
    },
    languages: function languages(state) {
      return state.languages;
    },
    insuranceCompanies: function insuranceCompanies(state) {
      return state.insuranceCompanies;
    },
    vehicleManufacturers: function vehicleManufacturers(state) {
      return state.vehicleManufacturers;
    },
    products: function products(state) {
      return state.products;
    },
    vehicleMakes: function vehicleMakes(state) {
      return state.vehicleMakes;
    },
    productAdds: function productAdds(state) {
      return state.productAdds;
    },
    productMakes: function productMakes(state) {
      return state.productMakes;
    },
    groups: function groups(state) {
      return state.groups;
    },
    invoiceMethods: function invoiceMethods(state) {
      return state.invoiceMethods;
    },
    taxRates: function taxRates(state) {
      return state.taxRates;
    },
    scanTypes: function scanTypes(state) {
      return state.scanTypes;
    },
    launchAccounts: function launchAccounts(state) {
      return state.launchAccounts;
    },
    deviceManufactureModels: function deviceManufactureModels(state) {
      return state.deviceManufactureModels;
    },
    serviceElementGroups: function serviceElementGroups(state) {
      return state.serviceElementGroups;
    },
    brands: function brands(state) {
      return state.brands;
    },
    activationTypes: function activationTypes(state) {
      return state.activationTypes;
    },
    activationCards: function activationCards(state) {
      return state.activationCards;
    },
    releaseTracks: function releaseTracks(state) {
      return state.releaseTracks;
    },
    hardwares: function hardwares(state) {
      return state.hardwares;
    },
    suppliers: function suppliers(state) {
      return state.suppliers;
    }
  },
  actions: {
    getLookups: function getLookups(_ref, keys) {
      var commit = _ref.commit;

      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].lookups(keys, { headers: { 'content-type': 'application/json' } }).then(function (response) {
          commit('SET_LOOKUPS', { keys: keys, data: response.data });
          resolve(response);
        });
      });
    },
    getActivationTypes: function getActivationTypes(_ref2) {
      var commit = _ref2.commit,
          state = _ref2.state;

      if (isFresh(state, 'activationTypes')) return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve();
      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].lookups(['device.activationtypeid'], { headers: { 'content-type': 'application/json' } }).then(function (response) {
          commit('SET_ACTIVATIONTYPES', { data: response.data });
          commit('SET_FETCHED_AT', 'activationTypes');
          resolve(response);
        }).catch(function (error) {
          return reject(error);
        });
      });
    },
    getSuppliers: function getSuppliers(_ref3) {
      var commit = _ref3.commit,
          state = _ref3.state;

      if (isFresh(state, 'suppliers')) return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve();
      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].lookups(['device.supplierid'], { headers: { 'content-type': 'application/json' } }).then(function (response) {
          commit('SET_SUPPLIERS', { data: response.data });
          commit('SET_FETCHED_AT', 'suppliers');
          resolve(response);
        }).catch(function (error) {
          return reject(error);
        });
      });
    },
    getLookupsZeus: function getLookupsZeus(_ref4, key) {
      var commit = _ref4.commit,
          state = _ref4.state;

      if (isFresh(state, key)) return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve();
      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].lookupsZeus(key, { headers: { 'content-type': 'application/json' } }).then(function (response) {
          commit('SET_LOOKUPS_ZEUS', { key: key, data: response.data });
          commit('SET_FETCHED_AT', key);
          resolve(response);
        }).catch(function (error) {
          return reject(error);
        });
      });
    },
    getLookupsByGroup: function getLookupsByGroup(_ref5, _ref6) {
      var commit = _ref5.commit;
      var className = _ref6.className,
          group = _ref6.group;

      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].lookupsByGroup({ className: className, group: group }, { headers: { 'content-type': 'application/json' } }).then(function (response) {
          commit('SET_GROUPS', response.data);
          resolve(response);
        });
      });
    },
    getServerProfiles: function getServerProfiles(_ref7) {
      var commit = _ref7.commit,
          state = _ref7.state;

      if (isFresh(state, 'serverProfiles')) return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve();
      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].serverProfiles().then(function (response) {
          commit('SET_SERVER_PROFILES', response.data);
          commit('SET_FETCHED_AT', 'serverProfiles');
          resolve(response);
        }).catch(function (error) {
          return reject(error);
        });
      });
    },
    getScanTypes: function getScanTypes(_ref8) {
      var commit = _ref8.commit;

      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].scanTypes({ headers: { 'content-type': 'application/json' } }).then(function (response) {
          commit('SET_SCAN_TYPES', response.data);
          resolve(response);
        });
      });
    },
    getActivationCards: function getActivationCards(_ref9) {
      var commit = _ref9.commit,
          state = _ref9.state;

      if (isFresh(state, 'activationCards')) return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve();
      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].activationCards({ headers: { 'content-type': 'application/json' } }).then(function (response) {
          commit('SET_ACTIVATION_CARDS', response.data);
          commit('SET_FETCHED_AT', 'activationCards');
          resolve(response);
        }).catch(function (error) {
          return reject(error);
        });
      });
    },
    getReleaseTracks: function getReleaseTracks(_ref10) {
      var commit = _ref10.commit,
          state = _ref10.state;

      if (isFresh(state, 'releaseTracks')) return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve();
      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].releaseTracks({ headers: { 'content-type': 'application/json' } }).then(function (response) {
          commit('SET_RELEASETRACKS', response.data);
          commit('SET_FETCHED_AT', 'releaseTracks');
          resolve(response);
        }).catch(function (error) {
          return reject(error);
        });
      });
    },
    getHardwares: function getHardwares(_ref11) {
      var commit = _ref11.commit,
          state = _ref11.state;

      if (isFresh(state, 'hardwares')) return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve();
      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].hardwares({ headers: { 'content-type': 'application/json' } }).then(function (response) {
          commit('SET_HARDWARES', response.data);
          commit('SET_FETCHED_AT', 'hardwares');
          resolve(response);
        }).catch(function (error) {
          return reject(error);
        });
      });
    },
    getDeviceManufactureModels: function getDeviceManufactureModels(_ref12) {
      var commit = _ref12.commit,
          state = _ref12.state;

      if (isFresh(state, 'deviceManufactureModels')) return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve();
      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].getDeviceManufactureModels({ headers: { 'content-type': 'application/json' } }).then(function (response) {
          commit('SET_DEVICE_MANUFACTURE_MODELS', response.data);
          commit('SET_FETCHED_AT', 'deviceManufactureModels');
          resolve(response);
        }).catch(function (error) {
          return reject(error);
        });
      });
    },
    upsertLookup: function upsertLookup(_ref13, lookup) {
      var commit = _ref13.commit;

      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].upsertLookup(lookup).then(function (response) {
          lookup.id = response.data;
          if (response.status === 200) {
            commit('SET_LOOKUP', lookup);
          }
          resolve(response);
        });
      });
    },
    upsertScanType: function upsertScanType(_ref14, scanType) {
      var commit = _ref14.commit;

      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].upsertScanType(scanType).then(function (response) {
          scanType.id = response.data;
          if (response.status === 200) {
            commit('SET_SCAN_TYPE', scanType);
          }
          resolve(response);
        });
      });
    },
    upsertActivationCard: function upsertActivationCard(_ref15, activationCard) {
      var commit = _ref15.commit;

      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].upsertActivationCard(activationCard).then(function (response) {
          activationCard.id = response.data;
          if (response.status === 200) {
            commit('SET_ACTIVATION_CARD', activationCard);
          }
          resolve(response);
        });
      });
    },
    upsertProduct: function upsertProduct(_ref16, product) {
      var commit = _ref16.commit;

      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].upsertProduct(product).then(function (response) {
          product.id = response.data;
          product.hasDisclaimer = true;
          if (!product.disclaimer || product.disclaimer.length === 0) {
            product.hasDisclaimer = false;
          }
          if (response.status === 200) {
            commit('SET_PRODUCT', product);
          }
          resolve(response);
        });
      });
    },
    getTimeZones: function getTimeZones(_ref17) {
      var commit = _ref17.commit;

      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].getTimeZones().then(function (response) {
          commit('SET_TIMEZONES', response.data);
          resolve(response);
        });
      });
    },
    getStates: function getStates(_ref18, id) {
      var commit = _ref18.commit;

      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].getStates(id).then(function (response) {
          commit('SET_STATES', response.data);
          resolve(response);
        });
      });
    },
    getCountries: function getCountries(_ref19) {
      var commit = _ref19.commit;

      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].getCountries().then(function (response) {
          commit('SET_COUNTRIES', response.data);
          resolve(response);
        });
      });
    },
    getLanguages: function getLanguages(_ref20) {
      var commit = _ref20.commit;

      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].getLanguages().then(function (response) {
          commit('SET_LANGUAGES', response.data);
          resolve(response);
        });
      });
    },
    getInsuranceCompanies: function getInsuranceCompanies(_ref21) {
      var commit = _ref21.commit;

      __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].getInsuranceCompanies().then(function (response) {
        if (response.status === 200) {
          commit('SET_INSURANCE_COMPANIES', response.data);
        }
      });
    },
    getVehicleManufacturers: function getVehicleManufacturers(_ref22) {
      var commit = _ref22.commit;

      __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].getVehicleManufacturers().then(function (response) {
        if (response.status === 200) {
          commit('SET_VEHICLE_MANUFATURERS', response.data);
        }
      });
    },
    getProducts: function getProducts(_ref23) {
      var commit = _ref23.commit;

      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].getProducts().then(function (response) {
          commit('SET_PRODUCTS', response.data);
          resolve(response);
        }).catch(function (error) {
          return reject(error);
        });
      });
    },
    getLaunchAccountList: function getLaunchAccountList(_ref24) {
      var commit = _ref24.commit,
          state = _ref24.state;

      if (isFresh(state, 'launchAccounts')) return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve();
      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].getLaunchAccountList().then(function (response) {
          commit('SET_LAUNCH_ACCOUNTS', response.data);
          commit('SET_FETCHED_AT', 'launchAccounts');
          resolve(response);
        }).catch(function (error) {
          return reject(error);
        });
      });
    },
    getVehicleMakes: function getVehicleMakes(_ref25, year) {
      var commit = _ref25.commit;

      __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].getVehicleMakes(year).then(function (response) {
        if (response.status === 200) {
          commit('SET_VEHICLE_MAKES', response.data);
        }
      });
    },
    getProductAdds: function getProductAdds(_ref26) {
      var commit = _ref26.commit;

      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].getProductAdds().then(function (response) {
          commit('SET_PRODUCTADDS', response.data);
          resolve(response);
        }).catch(function (error) {
          return reject(error);
        });
      });
    },
    upsertProductAdd: function upsertProductAdd(_ref27, productAdd) {
      var commit = _ref27.commit;

      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].upsertProductAdd(productAdd).then(function (response) {
          productAdd.id = response.data;
          if (response.status === 200) {
            commit('SET_PRODUCTADD', productAdd);
          }
          resolve(response);
        });
      });
    },
    getProductMakes: function getProductMakes(_ref28) {
      var commit = _ref28.commit;

      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].getProductMakes().then(function (response) {
          commit('SET_PRODUCTMAKES', response.data);
          resolve(response);
        }).catch(function (error) {
          return reject(error);
        });
      });
    },
    upsertProductMake: function upsertProductMake(_ref29, productMake) {
      var commit = _ref29.commit;

      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].upsertProductMake(productMake).then(function (response) {
          productMake.id = response.data;
          if (response.status === 200) {
            commit('SET_PRODUCTMAKE', productMake);
          }
          resolve(response);
        });
      });
    }
  },
  mutations: {
    SET_FETCHED_AT: function SET_FETCHED_AT(state, cacheKey) {
      __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].set(state.fetchedAt, cacheKey, Date.now());
    },
    SET_LOOKUPS: function SET_LOOKUPS(state, _ref30) {
      var keys = _ref30.keys,
          data = _ref30.data;

      if (data !== undefined && data !== null) {
        if ((typeof keys === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(keys)) === 'object') {
          if (data !== '') {
            keys.forEach(function (x) {
              __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].set(state.lookups, x, data.filter(function (l) {
                return l.key === x;
              }));
            });
          }
        } else {
          __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].set(state.lookups, keys, data);
        }
      }
    },
    SET_LOOKUPS_ZEUS: function SET_LOOKUPS_ZEUS(state, _ref31) {
      var key = _ref31.key,
          data = _ref31.data;

      __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].set(state.lookupsZeus, key, data);
    },
    SET_SERVER_PROFILES: function SET_SERVER_PROFILES(state, data) {
      state.serverProfiles = data;
    },
    SET_DEVICE_MANUFACTURE_MODELS: function SET_DEVICE_MANUFACTURE_MODELS(state, data) {
      state.deviceManufactureModels = data;
      var output = [];
      var keys = [];

      state.deviceManufactureModels.forEach(function (manufacture) {
        var key = manufacture.Brand;

        if (keys.indexOf(key) === -1) {
          keys.push(key);
          output.push(manufacture);
        }
      });
      console.log(output);
      state.brands = output;
      console.log(state.brands);
    },
    SET_SCAN_TYPES: function SET_SCAN_TYPES(state, data) {
      state.scanTypes = data;
      console.log(state.scanTypes);
    },
    SET_ACTIVATION_CARDS: function SET_ACTIVATION_CARDS(state, data) {
      console.log(data);
      state.activationCards = data;
      console.log('activationCards', state.activationCards);
    },
    SET_RELEASETRACKS: function SET_RELEASETRACKS(state, data) {
      console.log(data);
      state.releaseTracks = data;
      console.log('releaseTracks', state.releaseTracks);
    },
    SET_HARDWARES: function SET_HARDWARES(state, data) {
      console.log(data);
      state.hardwares = data;
      console.log('hardwares', state.hardwares);
    },
    SET_ACTIVATIONTYPES: function SET_ACTIVATIONTYPES(state, data) {
      state.activationTypes = data.data;
      console.log(state.activationTypes);
    },
    SET_SUPPLIERS: function SET_SUPPLIERS(state, data) {
      console.log(data);
      state.suppliers = data.data;
    },
    SET_SERVICE_ELEMENT_GROUPS: function SET_SERVICE_ELEMENT_GROUPS(state, data) {
      state.serviceElementGroups = data;
    },
    SET_SCAN_TYPE: function SET_SCAN_TYPE(state, data) {
      var idx = state.scanTypes.findIndex(function (i) {
        return i.id === data.id;
      });
      console.log(idx);
      if (idx !== -1) {
        if (data.isInActive) {
          state.scanTypes.splice(idx, 1);
        } else {
          state.scanTypes[idx].text = data.text;
          state.scanTypes[idx].serviceElementGroupId = data.serviceElementGroupId;
          state.scanTypes[idx].serviceElementGroupName = data.serviceElementGroupName;
          state.scanTypes[idx].connectProductId = data.connectProductId;
          state.scanTypes[idx].connectProductText = data.connectProductText;
        }
      } else {
        var _lookup = {
          id: data.id,
          key: 'workorder.servicetype',
          text: data.text,
          isActive: data.isInActive === false,
          value: data.value,
          dateValue: null,
          decimalValue: null,
          intValue: null,
          label: null,
          parentId: null,
          stringValue: null,
          serviceElementGroupId: data.serviceElementGroupId,
          serviceElementGroupName: data.serviceElementGroupName,
          connectProductId: data.connectProductId,
          connectProductText: data.connectProductText
        };
        state.scanTypes.push(_lookup);
      }
    },
    SET_ACTIVATION_CARD: function SET_ACTIVATION_CARD(state, data) {
      var idx = state.activationCards.findIndex(function (i) {
        return i.id === data.id;
      });
      console.log(idx);
      if (idx !== -1) {
        state.activationCards[idx].activationCardId = data.activationCardId;
        state.activationCards[idx].activationPassword = data.activationPassword;
        state.activationCards[idx].assignedDate = data.assignedDate;
        state.activationCards[idx].assignedDeviceId = data.assignedDeviceId;
        state.activationCards[idx].activationAccountType = data.activationAccountType;
        state.activationCards[idx].activationAccountReference = data.activationAccountReference;
      } else {
        var activationCard = {
          id: data.id,
          activationCardId: data.activationCardId,
          activationPassword: data.activationPassword,
          activationAccountReference: data.activationAccountReference,
          activationAccountType: data.activationAccountType,
          assignedDate: null,
          assignedDeviceId: null,
          isActive: true
        };
        state.activationCards.push(activationCard);
      }
    },
    SET_LOOKUP: function SET_LOOKUP(state, lookup) {
      if (lookup.isActive) {
        state.lookups[lookup.key].push(lookup);
      } else {
        var index = state.lookups[lookup.key].findIndex(function (i) {
          return i.id === lookup.id;
        });
        state.lookups[lookup.key].splice(index, 1);
      }
    },
    SET_GROUPS: function SET_GROUPS(state, groups) {
      state.groups = [];
      if (groups !== undefined && groups !== null) {
        if (groups !== '') {
          state.groups = groups;
        }
      }
    },
    SET_TIMEZONES: function SET_TIMEZONES(state, timezones) {
      state.timezones = timezones || [];
    },
    SET_STATES: function SET_STATES(state, states) {
      state.states = states || [];
    },
    SET_COUNTRIES: function SET_COUNTRIES(state, countries) {
      state.countries = countries || [];
    },
    SET_LANGUAGES: function SET_LANGUAGES(state, languages) {
      state.languages = languages || [];
    },
    SET_LAUNCH_ACCOUNTS: function SET_LAUNCH_ACCOUNTS(state, launchAccounts) {
      console.log(launchAccounts.data);
      state.launchAccounts = launchAccounts.data || [];
    },
    SET_INSURANCE_COMPANIES: function SET_INSURANCE_COMPANIES(state, insuranceCompanies) {
      state.insuranceCompanies = insuranceCompanies || [];
    },
    SET_VEHICLE_MANUFATURERS: function SET_VEHICLE_MANUFATURERS(state, vehicleManufacturers) {
      state.vehicleManufacturers = vehicleManufacturers || [];
    },
    SET_PRODUCTS: function SET_PRODUCTS(state, products) {
      state.products = products || [];
      state.products.forEach(function (element) {
        element.isAdd = false;
      });
    },
    SET_PRODUCT: function SET_PRODUCT(state, product) {
      if (product.isActive) {
        if (product.id !== null && product.isAdd === false) {
          var idx = state.products.findIndex(function (i) {
            return i.id === product.id;
          });
          state.products[idx] = product;
        } else {
          state.products.push(product);
        }
      } else {
        var index = state.products.findIndex(function (i) {
          return i.id === product.id;
        });
        state.products.splice(index, 1);
      }
    },
    SET_VEHICLE_MAKES: function SET_VEHICLE_MAKES(state, vehicleMakes) {
      state.vehicleMakes = vehicleMakes || [];
    },
    SET_PRODUCTADDS: function SET_PRODUCTADDS(state, productAdds) {
      state.productAdds = productAdds || [];
      state.productAdds.forEach(function (element) {
        element.isAdd = false;
      });
    },
    SET_PRODUCTADD: function SET_PRODUCTADD(state, productAdd) {
      if (productAdd.isActive) {
        if (productAdd.id !== null && productAdd.isAdd === false) {
          var idx = state.productAdds.findIndex(function (i) {
            return i.id === productAdd.id;
          });
          state.productAdds[idx] = productAdd;
        } else {
          state.productAdds.push(productAdd);
        }
      } else {
        var index = state.productAdds.findIndex(function (i) {
          return i.id === productAdd.id;
        });
        state.productAdds.splice(index, 1);
      }
    },
    SET_PRODUCTMAKES: function SET_PRODUCTMAKES(state, productMakes) {
      state.productMakes = productMakes || [];
      state.productMakes.forEach(function (element) {
        element.isAdd = false;
      });
    },
    SET_PRODUCTMAKE: function SET_PRODUCTMAKE(state, productMake) {
      if (productMake.isActive) {
        if (productMake.id !== null && productMake.isAdd === false) {
          var idx = state.productMakes.findIndex(function (i) {
            return i.id === productMake.id;
          });
          state.productMakes[idx] = productMake;
        } else {
          state.productMakes.push(productMake);
        }
      } else {
        var index = state.productMakes.findIndex(function (i) {
          return i.id === productMake.id;
        });
        state.productMakes.splice(index, 1);
      }
    }
  }
};

/***/ }),

/***/ 651:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "maintenance", function() { return maintenance; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__state__ = __webpack_require__(284);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getters__ = __webpack_require__(282);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(281);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mutations__ = __webpack_require__(283);





var maintenance = {
  namespaced: true,
  state: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__state__["default"])(),
  getters: __WEBPACK_IMPORTED_MODULE_1__getters__["default"],
  actions: __WEBPACK_IMPORTED_MODULE_2__actions__["default"],
  mutations: __WEBPACK_IMPORTED_MODULE_3__mutations__["default"]
};

/***/ }),

/***/ 652:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "make", function() { return make; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__state__ = __webpack_require__(288);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getters__ = __webpack_require__(286);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(285);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mutations__ = __webpack_require__(287);





var make = {
  namespaced: true,
  state: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__state__["default"])(),
  getters: __WEBPACK_IMPORTED_MODULE_1__getters__["default"],
  actions: __WEBPACK_IMPORTED_MODULE_2__actions__["default"],
  mutations: __WEBPACK_IMPORTED_MODULE_3__mutations__["default"]
};

/***/ }),

/***/ 653:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "message", function() { return message; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__state__ = __webpack_require__(293);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getters__ = __webpack_require__(291);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(290);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mutations__ = __webpack_require__(292);





var message = {
  namespaced: true,
  state: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__state__["default"])(),
  getters: __WEBPACK_IMPORTED_MODULE_1__getters__["default"],
  actions: __WEBPACK_IMPORTED_MODULE_2__actions__["default"],
  mutations: __WEBPACK_IMPORTED_MODULE_3__mutations__["default"]
};

/***/ }),

/***/ 654:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "calibrationHomepageMessage", function() { return calibrationHomepageMessage; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__state__ = __webpack_require__(298);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getters__ = __webpack_require__(296);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mutations__ = __webpack_require__(297);





var calibrationHomepageMessage = {
  namespaced: true,
  state: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__state__["default"])(),
  getters: __WEBPACK_IMPORTED_MODULE_1__getters__["default"],
  actions: __WEBPACK_IMPORTED_MODULE_2__actions__["default"],
  mutations: __WEBPACK_IMPORTED_MODULE_3__mutations__["default"]
};

/***/ }),

/***/ 655:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "openinghours", function() { return openinghours; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__state__ = __webpack_require__(302);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getters__ = __webpack_require__(300);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(299);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mutations__ = __webpack_require__(301);





var openinghours = {
  namespaced: true,
  state: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__state__["default"])(),
  getters: __WEBPACK_IMPORTED_MODULE_1__getters__["default"],
  actions: __WEBPACK_IMPORTED_MODULE_2__actions__["default"],
  mutations: __WEBPACK_IMPORTED_MODULE_3__mutations__["default"]
};

/***/ }),

/***/ 656:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "report", function() { return report; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__state__ = __webpack_require__(306);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getters__ = __webpack_require__(304);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(303);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mutations__ = __webpack_require__(305);





var report = {
  namespaced: true,
  state: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__state__["default"])(),
  getters: __WEBPACK_IMPORTED_MODULE_1__getters__["default"],
  actions: __WEBPACK_IMPORTED_MODULE_2__actions__["default"],
  mutations: __WEBPACK_IMPORTED_MODULE_3__mutations__["default"]
};

/***/ }),

/***/ 657:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "scanpro", function() { return scanpro; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__state__ = __webpack_require__(311);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getters__ = __webpack_require__(309);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(308);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mutations__ = __webpack_require__(310);





var scanpro = {
  namespaced: true,
  state: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__state__["default"])(),
  getters: __WEBPACK_IMPORTED_MODULE_1__getters__["default"],
  actions: __WEBPACK_IMPORTED_MODULE_2__actions__["default"],
  mutations: __WEBPACK_IMPORTED_MODULE_3__mutations__["default"]
};

/***/ }),

/***/ 658:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "serviceelements", function() { return serviceelements; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__api__ = __webpack_require__(11);







var LOOKUP_CACHE_TTL_MS = 30 * 60 * 1000;

function isFresh(state, cacheKey) {
  var fetchedAt = state.fetchedAt[cacheKey];
  return !!fetchedAt && Date.now() - fetchedAt < LOOKUP_CACHE_TTL_MS;
}

var serviceelements = {
  namespaced: true,
  state: {
    lookups: {},
    pageSize: 10,
    totalLogEntries: 0,
    lookupsZeus: {},
    serviceElements: [],
    serviceElementGroups: [],
    makes: [],
    models: [],
    copyModels: [],
    serviceElementsRagRating: [],
    sortDir: '',
    orderBy: '',
    vehicleRagRatingId: '',
    ragAuditTypeList: [],
    ragAuditLog: [],
    deviceTypes: [],
    fetchedAt: {}
  },
  getters: {
    pageSize: function pageSize(state) {
      return state.pageSize;
    },
    totalLogEntries: function totalLogEntries(state) {
      return state.totalLogEntries;
    },
    lookups: function lookups(state) {
      return state.lookups;
    },
    lookupsZeus: function lookupsZeus(state) {
      return state.lookupsZeus;
    },
    scanTypes: function scanTypes(state) {
      return state.scanTypes;
    },
    serviceElements: function serviceElements(state) {
      return state.serviceElements;
    },
    serviceElementGroups: function serviceElementGroups(state) {
      return state.serviceElementGroups;
    },
    makes: function makes(state) {
      return state.makes;
    },
    models: function models(state) {
      return state.models;
    },
    copyModels: function copyModels(state) {
      return state.copyModels;
    },
    serviceElementsRagRating: function serviceElementsRagRating(state) {
      return state.serviceElementsRagRating;
    },
    sortDir: function sortDir(state) {
      return state.sortDir;
    },
    orderBy: function orderBy(state) {
      return state.orderBy;
    },
    vehicleRagRatingId: function vehicleRagRatingId(state) {
      return state.vehicleRagRatingId;
    },
    ragAuditTypeList: function ragAuditTypeList(state) {
      return state.ragAuditTypeList;
    },
    ragAuditLog: function ragAuditLog(state) {
      return state.ragAuditLog;
    },
    deviceTypes: function deviceTypes(state) {
      return state.deviceTypes || [];
    }
  },
  actions: {
    setPageSize: function setPageSize(_ref, pageSize) {
      var commit = _ref.commit;

      commit('SET_PAGE_SIZE', pageSize);
    },
    getLookups: function getLookups(_ref2, keys) {
      var commit = _ref2.commit;

      return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_5__api__["a" /* default */].lookups(keys, { headers: { 'content-type': 'application/json' } }).then(function (response) {
          commit('SET_LOOKUPS', { keys: keys, data: response.data });
          resolve(response);
        });
      });
    },
    getLookupsZeus: function getLookupsZeus(_ref3, key) {
      var commit = _ref3.commit;

      return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_5__api__["a" /* default */].lookupsZeus(key, { headers: { 'content-type': 'application/json' } }).then(function (response) {
          commit('SET_LOOKUPS_ZEUS', { key: key, data: response.data });
          resolve(response);
        });
      });
    },
    getServiceElements: function getServiceElements(_ref4) {
      var commit = _ref4.commit;

      return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_5__api__["a" /* default */].serviceElements({ headers: { 'content-type': 'application/json' } }).then(function (response) {
          commit('SET_SERVICE_ELEMENTS', response.data);
          resolve(response);
        });
      });
    },
    getServiceElementGroups: function getServiceElementGroups(_ref5) {
      var commit = _ref5.commit;

      return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_5__api__["a" /* default */].getServiceElementGroups({ headers: { 'content-type': 'application/json' } }).then(function (response) {
          commit('SET_SERVICE_ELEMENT_GROUPS', response.data);
          resolve(response);
        });
      });
    },
    getVehicleRagRatingId: function getVehicleRagRatingId(_ref6, _ref7) {
      var commit = _ref6.commit;
      var make = _ref7.make,
          model = _ref7.model,
          year = _ref7.year;

      return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_5__api__["a" /* default */].getVehicleRagRatingId({ make: make, model: model, year: year }, { headers: { 'content-type': 'application/json' } }).then(function (response) {
          commit('SET_VEHICLE_RAG_RATING_ID', response.data);
          resolve(response);
        });
      });
    },
    upsertServiceElement: function upsertServiceElement(_ref8, serviceElement) {
      var commit = _ref8.commit;

      return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_5__api__["a" /* default */].upsertServiceElement(serviceElement).then(function (response) {
          serviceElement.id = response.data;
          if (response.status === 200) {
            commit('SET_SERVICE_ELEMENT', serviceElement);
          }
          resolve(response);
        });
      });
    },
    getVehicleMakes: function getVehicleMakes(_ref9) {
      var commit = _ref9.commit;

      return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_5__api__["a" /* default */].getDistinctVehicleMakes({ headers: { 'content-type': 'application/json' } }).then(function (response) {
          commit('SET_MAKES', response.data);
          resolve(response);
        });
      });
    },
    getVehicleModels: function getVehicleModels(_ref10, _ref11) {
      var commit = _ref10.commit;
      var make = _ref11.make,
          year = _ref11.year,
          isCopy = _ref11.isCopy;

      return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_5__api__["a" /* default */].getDistinctVehicleModels({ make: make, year: year }, { headers: { 'content-type': 'application/json' } }).then(function (response) {
          if (isCopy) {
            commit('SET_COPY_MODELS', response.data);
          } else {
            commit('SET_MODELS', response.data);
          }
          resolve(response);
        });
      });
    },
    getServiceElementsRagRating: function getServiceElementsRagRating(_ref12, _ref13) {
      var commit = _ref12.commit;
      var make = _ref13.make,
          model = _ref13.model,
          year = _ref13.year,
          deviceId = _ref13.deviceId,
          orderBy = _ref13.orderBy,
          sortBy = _ref13.sortBy;

      return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_5__api__["a" /* default */].getServiceElementsRagRating({ make: make, model: model, year: year, deviceId: deviceId, orderBy: orderBy, sortBy: sortBy }, { headers: { 'content-type': 'application/json' } }).then(function (response) {
          console.log('getServiceElementsRagRating: API response:', response.data);
          commit('SET_SERVICE_ELEMENTS_RAG_RATING', response.data);
          resolve(response);
        }).catch(function (error) {
          console.error('API error:', error);
          reject(error);
        });
      });
    },
    getAuditLog: function getAuditLog(_ref14, searchOptions) {
      var _this = this;

      var commit = _ref14.commit,
          dispatch = _ref14.dispatch;
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt('return', new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                  __WEBPACK_IMPORTED_MODULE_5__api__["a" /* default */].getAuditLog(searchOptions).then(function (response) {
                    commit('SET_RAG_AUDIT_LOG', response.data);
                    resolve(response);
                  });
                }));

              case 1:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    getRagAuditTypeList: function getRagAuditTypeList(_ref15) {
      var _this2 = this;

      var commit = _ref15.commit;
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                return _context2.abrupt('return', new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                  __WEBPACK_IMPORTED_MODULE_5__api__["a" /* default */].getRagAuditTypeList().then(function (response) {
                    var newItem = { AuditTypeId: 0, AuditTypeName: 'All entries' };
                    response.data.unshift(newItem);
                    commit('SET_RAG_AUDIT_TYPE_LIST', response.data);
                    resolve(response);
                  });
                }));

              case 1:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    updateRagRating: function updateRagRating(_ref16, data) {
      var _this3 = this;

      var commit = _ref16.commit,
          dispatch = _ref16.dispatch;
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                return _context3.abrupt('return', new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                  __WEBPACK_IMPORTED_MODULE_5__api__["a" /* default */].updateRagRating(data).then(function (response) {
                    resolve(response);
                  });
                }));

              case 1:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    },
    bulkCopyRagRating: function bulkCopyRagRating(_ref17, _ref18) {
      var _this4 = this;

      var commit = _ref17.commit,
          dispatch = _ref17.dispatch;
      var bulkCopyParams = _ref18.bulkCopyParams;
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee4() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                return _context4.abrupt('return', new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                  __WEBPACK_IMPORTED_MODULE_5__api__["a" /* default */].bulkCopyRagRating({ bulkCopyParams: bulkCopyParams }).then(function (response) {
                    resolve(response);
                  });
                }));

              case 1:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this4);
      }))();
    },
    copyRagRating: function copyRagRating(_ref19, _ref20) {
      var _this5 = this;

      var commit = _ref19.commit,
          dispatch = _ref19.dispatch;
      var sourceVehicleId = _ref20.sourceVehicleId,
          targetVehicleId = _ref20.targetVehicleId;
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee5() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                return _context5.abrupt('return', new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                  __WEBPACK_IMPORTED_MODULE_5__api__["a" /* default */].copyRagRating({ sourceVehicleId: sourceVehicleId, targetVehicleId: targetVehicleId }).then(function (response) {
                    resolve(response);
                  });
                }));

              case 1:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this5);
      }))();
    },
    audit: function audit(_ref21, data) {
      var _this6 = this;

      var commit = _ref21.commit,
          dispatch = _ref21.dispatch;
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee6() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                return _context6.abrupt('return', new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                  __WEBPACK_IMPORTED_MODULE_5__api__["a" /* default */].audit(data).then(function (response) {
                    resolve(response);
                  });
                }));

              case 1:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, _this6);
      }))();
    },
    setSortDir: function setSortDir(_ref22, sortDir) {
      var commit = _ref22.commit;

      commit('SET_SORT_DIR', sortDir);
    },
    setOrderBy: function setOrderBy(_ref23, orderBy) {
      var commit = _ref23.commit;

      commit('SET_ORDER_BY', orderBy);
    },
    getDeviceTypes: function getDeviceTypes(_ref24) {
      var commit = _ref24.commit,
          state = _ref24.state;

      if (isFresh(state, 'deviceTypes')) return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a.resolve();
      return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_5__api__["a" /* default */].getAllDeviceTypes({ headers: { 'content-type': 'application/json' } }).then(function (response) {
          console.log('GetDeviceTypes: API response:', response.data);
          commit('SET_DEVICE_TYPES', response.data);
          commit('SET_FETCHED_AT', 'deviceTypes');
          resolve(response);
        }).catch(function (error) {
          console.error('GetDeviceTypes API error:', error);
          reject(error);
        });
      });
    }
  },
  mutations: {
    SET_FETCHED_AT: function SET_FETCHED_AT(state, cacheKey) {
      __WEBPACK_IMPORTED_MODULE_4_vue__["a" /* default */].set(state.fetchedAt, cacheKey, Date.now());
    },
    SET_PAGE_SIZE: function SET_PAGE_SIZE(state, value) {
      if (value !== undefined && value !== null) {
        state.pageSize = parseInt(value);
      }
    },
    SET_LOOKUPS: function SET_LOOKUPS(state, _ref25) {
      var keys = _ref25.keys,
          data = _ref25.data;

      if (data !== undefined && data !== null) {
        if ((typeof keys === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(keys)) === 'object') {
          if (data !== '') {
            keys.forEach(function (x) {
              __WEBPACK_IMPORTED_MODULE_4_vue__["a" /* default */].set(state.lookups, x, data.filter(function (l) {
                return l.key === x;
              }));
            });
          }
        } else {
          __WEBPACK_IMPORTED_MODULE_4_vue__["a" /* default */].set(state.lookups, keys, data);
        }
      }
    },
    SET_LOOKUPS_ZEUS: function SET_LOOKUPS_ZEUS(state, _ref26) {
      var key = _ref26.key,
          data = _ref26.data;

      __WEBPACK_IMPORTED_MODULE_4_vue__["a" /* default */].set(state.lookupsZeus, key, data);
    },
    SET_SERVICE_ELEMENTS: function SET_SERVICE_ELEMENTS(state, data) {
      state.serviceElements = data;
    },
    SET_SERVICE_ELEMENT_GROUPS: function SET_SERVICE_ELEMENT_GROUPS(state, data) {
      state.serviceElementGroups = data;
    },
    SET_SERVICE_ELEMENT: function SET_SERVICE_ELEMENT(state, data) {
      var idx = state.serviceElements.findIndex(function (i) {
        return i.id === data.id;
      });
      if (idx !== -1) {
        if (!data.isActive) {
          state.serviceElements.splice(idx, 1);
        } else {
          state.serviceElements[idx].name = data.name;
          state.serviceElements[idx].serviceElementGroupId = data.serviceElementGroupId;
          state.serviceElements[idx].serviceElementGroupName = data.serviceElementGroupName;
          state.serviceElements[idx].isActive = data.isActive;
        }
      } else {
        var lookup = {
          id: data.id,
          name: data.name,
          serviceElementGroupId: data.serviceElementGroupId,
          serviceElementGroupName: data.serviceElementGroupName
        };
        state.serviceElements.push(lookup);
      }
    },
    SET_LOOKUP: function SET_LOOKUP(state, lookup) {
      if (lookup.isActive) {
        state.lookups[lookup.key].push(lookup);
      } else {
        var index = state.lookups[lookup.key].findIndex(function (i) {
          return i.id === lookup.id;
        });
        state.lookups[lookup.key].splice(index, 1);
      }
    },
    SET_MAKES: function SET_MAKES(state, data) {
      state.makes = data;
    },
    SET_MODELS: function SET_MODELS(state, data) {
      state.models = data;
    },
    SET_COPY_MODELS: function SET_COPY_MODELS(state, data) {
      state.copyModels = data;
    },
    SET_SERVICE_ELEMENTS_RAG_RATING: function SET_SERVICE_ELEMENTS_RAG_RATING(state, data) {
      state.serviceElementsRagRating = data;
    },
    SET_SORT_DIR: function SET_SORT_DIR(state, text) {
      if (text !== undefined && text !== null) {
        state.sortDir = text;
      }
    },
    SET_ORDER_BY: function SET_ORDER_BY(state, text) {
      if (text !== undefined && text !== null) {
        state.orderBy = text;
      }
    },
    SET_VEHICLE_RAG_RATING_ID: function SET_VEHICLE_RAG_RATING_ID(state, data) {
      state.vehicleRagRatingId = data;
    },
    SET_RAG_AUDIT_TYPE_LIST: function SET_RAG_AUDIT_TYPE_LIST(state, data) {
      state.ragAuditTypeList = data;
    },
    SET_RAG_AUDIT_LOG: function SET_RAG_AUDIT_LOG(state, data) {
      state.totalLogEntries = 0;
      state.ragAuditLog = [];
      if (data !== undefined && data !== null) {
        if (data.length > 0) {
          state.totalLogEntries = data[0].TotalItems;
          state.ragAuditLog = data;
        }
      }
    },
    SET_DEVICE_TYPES: function SET_DEVICE_TYPES(state, data) {
      state.deviceTypes = (data || []).filter(function (dt) {
        return !dt.DeletedDate;
      });
    }
  }
};

/***/ }),

/***/ 659:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "servicerequests", function() { return servicerequests; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__state__ = __webpack_require__(315);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getters__ = __webpack_require__(313);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(312);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mutations__ = __webpack_require__(314);





var servicerequests = {
  namespaced: true,
  state: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__state__["default"])(),
  getters: __WEBPACK_IMPORTED_MODULE_1__getters__["default"],
  actions: __WEBPACK_IMPORTED_MODULE_2__actions__["default"],
  mutations: __WEBPACK_IMPORTED_MODULE_3__mutations__["default"]
};

/***/ }),

/***/ 660:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "translation", function() { return translation; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__state__ = __webpack_require__(319);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getters__ = __webpack_require__(317);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(316);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mutations__ = __webpack_require__(318);





var translation = {
  namespaced: true,
  state: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__state__["default"])(),
  getters: __WEBPACK_IMPORTED_MODULE_1__getters__["default"],
  actions: __WEBPACK_IMPORTED_MODULE_2__actions__["default"],
  mutations: __WEBPACK_IMPORTED_MODULE_3__mutations__["default"]
};

/***/ }),

/***/ 661:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "users", function() { return users; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__state__ = __webpack_require__(324);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getters__ = __webpack_require__(322);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(321);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mutations__ = __webpack_require__(323);





var users = {
  namespaced: true,
  state: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__state__["default"])(),
  getters: __WEBPACK_IMPORTED_MODULE_1__getters__["default"],
  actions: __WEBPACK_IMPORTED_MODULE_2__actions__["default"],
  mutations: __WEBPACK_IMPORTED_MODULE_3__mutations__["default"]
};

/***/ }),

/***/ 662:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(226);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])('business', ['business'])),
  created: function created() {
    this.checkAuth();
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('authorize', ['checkAuth']))
});

/***/ }),

/***/ 8:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_properties__ = __webpack_require__(666);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_properties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_properties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__(581);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);







var http = __WEBPACK_IMPORTED_MODULE_4_axios___default.a.create();
__WEBPACK_IMPORTED_MODULE_4_axios___default.a.interceptors.request.use(function (config) {
  config.headers['Authorization'] = 'Bearer ' + localStorage.getItem('token');
  return config;
}, function (error) {
  return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.reject(error);
});

__WEBPACK_IMPORTED_MODULE_4_axios___default.a.interceptors.response.use(function (response) {
  return response;
}, function (error) {
  return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.reject(error);
});

/* harmony default export */ __webpack_exports__["a"] = ({
  auth: function auth(data, callback, error) {
    __WEBPACK_IMPORTED_MODULE_4_axios___default.a.post(window.config.authService, data).then(callback).catch(error);
  },
  get: function get(endpoint) {
    var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    return __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get('' + window.config.apiUrl + endpoint, data);
  },
  post: function post(endpoint) {
    var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var config = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    return __WEBPACK_IMPORTED_MODULE_4_axios___default.a.post('' + window.config.apiUrl + endpoint, data, config);
  },
  put: function put(endpoint) {
    var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var config = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    return __WEBPACK_IMPORTED_MODULE_4_axios___default.a.put('' + window.config.apiUrl + endpoint, data, config);
  },
  postWithJson: function postWithJson(endpoint) {
    var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var config = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    var json = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(data);
    return __WEBPACK_IMPORTED_MODULE_4_axios___default.a.post('' + window.config.apiUrl + endpoint, json, {
      headers: {
        'Content-Type': 'application/json'
      } });
  },
  delete: function _delete(endpoint) {
    var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    return __WEBPACK_IMPORTED_MODULE_4_axios___default.a.delete('' + window.config.apiUrl + endpoint, data);
  }
});

__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_properties___default()(__WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].prototype, {
  $http: {
    get: function get() {
      return http;
    }
  }
});

/***/ }),

/***/ 94:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(226);




__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* default */]);

var modules = {};
var files = __webpack_require__(1037);

files.keys().forEach(function (path, i) {
  var module = files(path);
  __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(module).forEach(function (lang) {
    modules[lang] = module[lang];
  });
});

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* default */].Store({ modules: modules }));

/***/ }),

/***/ 954:
/***/ (function(module, exports) {

module.exports = {"modp1":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a63a3620ffffffffffffffff"},"modp2":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece65381ffffffffffffffff"},"modp5":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca237327ffffffffffffffff"},"modp14":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aacaa68ffffffffffffffff"},"modp15":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a93ad2caffffffffffffffff"},"modp16":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c934063199ffffffffffffffff"},"modp17":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c93402849236c3fab4d27c7026c1d4dcb2602646dec9751e763dba37bdf8ff9406ad9e530ee5db382f413001aeb06a53ed9027d831179727b0865a8918da3edbebcf9b14ed44ce6cbaced4bb1bdb7f1447e6cc254b332051512bd7af426fb8f401378cd2bf5983ca01c64b92ecf032ea15d1721d03f482d7ce6e74fef6d55e702f46980c82b5a84031900b1c9e59e7c97fbec7e8f323a97a7e36cc88be0f1d45b7ff585ac54bd407b22b4154aacc8f6d7ebf48e1d814cc5ed20f8037e0a79715eef29be32806a1d58bb7c5da76f550aa3d8a1fbff0eb19ccb1a313d55cda56c9ec2ef29632387fe8d76e3c0468043e8f663f4860ee12bf2d5b0b7474d6e694f91e6dcc4024ffffffffffffffff"},"modp18":{"gen":"02","prime":"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"}}

/***/ }),

/***/ 965:
/***/ (function(module, exports) {

module.exports = {"_args":[["elliptic@6.5.4","D:\\a\\1\\s"]],"_development":true,"_from":"elliptic@6.5.4","_id":"elliptic@6.5.4","_inBundle":false,"_integrity":"sha512-iLhC6ULemrljPZb+QutR5TQGB+pdW6KGD5RSegS+8sorOZT+rdQFbsQFJgvN3eRqNALqJer4oQ16YvJHlU8hzQ==","_location":"/elliptic","_phantomChildren":{},"_requested":{"type":"version","registry":true,"raw":"elliptic@6.5.4","name":"elliptic","escapedName":"elliptic","rawSpec":"6.5.4","saveSpec":null,"fetchSpec":"6.5.4"},"_requiredBy":["/browserify-sign","/create-ecdh"],"_resolved":"https://registry.npmjs.org/elliptic/-/elliptic-6.5.4.tgz","_spec":"6.5.4","_where":"D:\\a\\1\\s","author":{"name":"Fedor Indutny","email":"fedor@indutny.com"},"bugs":{"url":"https://github.com/indutny/elliptic/issues"},"dependencies":{"bn.js":"^4.11.9","brorand":"^1.1.0","hash.js":"^1.0.0","hmac-drbg":"^1.0.1","inherits":"^2.0.4","minimalistic-assert":"^1.0.1","minimalistic-crypto-utils":"^1.0.1"},"description":"EC cryptography","devDependencies":{"brfs":"^2.0.2","coveralls":"^3.1.0","eslint":"^7.6.0","grunt":"^1.2.1","grunt-browserify":"^5.3.0","grunt-cli":"^1.3.2","grunt-contrib-connect":"^3.0.0","grunt-contrib-copy":"^1.0.0","grunt-contrib-uglify":"^5.0.0","grunt-mocha-istanbul":"^5.0.2","grunt-saucelabs":"^9.0.1","istanbul":"^0.4.5","mocha":"^8.0.1"},"files":["lib"],"homepage":"https://github.com/indutny/elliptic","keywords":["EC","Elliptic","curve","Cryptography"],"license":"MIT","main":"lib/elliptic.js","name":"elliptic","repository":{"type":"git","url":"git+ssh://git@github.com/indutny/elliptic.git"},"scripts":{"lint":"eslint lib test","lint:fix":"npm run lint -- --fix","test":"npm run lint && npm run unit","unit":"istanbul test _mocha --reporter=spec test/index.js","version":"grunt dist && git add dist/"},"version":"6.5.4"}

/***/ }),

/***/ 966:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 988:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 412,
	"./af.js": 412,
	"./ar": 419,
	"./ar-dz": 413,
	"./ar-dz.js": 413,
	"./ar-kw": 414,
	"./ar-kw.js": 414,
	"./ar-ly": 415,
	"./ar-ly.js": 415,
	"./ar-ma": 416,
	"./ar-ma.js": 416,
	"./ar-sa": 417,
	"./ar-sa.js": 417,
	"./ar-tn": 418,
	"./ar-tn.js": 418,
	"./ar.js": 419,
	"./az": 420,
	"./az.js": 420,
	"./be": 421,
	"./be.js": 421,
	"./bg": 422,
	"./bg.js": 422,
	"./bm": 423,
	"./bm.js": 423,
	"./bn": 425,
	"./bn-bd": 424,
	"./bn-bd.js": 424,
	"./bn.js": 425,
	"./bo": 426,
	"./bo.js": 426,
	"./br": 427,
	"./br.js": 427,
	"./bs": 428,
	"./bs.js": 428,
	"./ca": 429,
	"./ca.js": 429,
	"./cs": 430,
	"./cs.js": 430,
	"./cv": 431,
	"./cv.js": 431,
	"./cy": 432,
	"./cy.js": 432,
	"./da": 433,
	"./da.js": 433,
	"./de": 436,
	"./de-at": 434,
	"./de-at.js": 434,
	"./de-ch": 435,
	"./de-ch.js": 435,
	"./de.js": 436,
	"./dv": 437,
	"./dv.js": 437,
	"./el": 438,
	"./el.js": 438,
	"./en-au": 439,
	"./en-au.js": 439,
	"./en-ca": 440,
	"./en-ca.js": 440,
	"./en-gb": 441,
	"./en-gb.js": 441,
	"./en-ie": 442,
	"./en-ie.js": 442,
	"./en-il": 443,
	"./en-il.js": 443,
	"./en-in": 444,
	"./en-in.js": 444,
	"./en-nz": 445,
	"./en-nz.js": 445,
	"./en-sg": 446,
	"./en-sg.js": 446,
	"./eo": 447,
	"./eo.js": 447,
	"./es": 451,
	"./es-do": 448,
	"./es-do.js": 448,
	"./es-mx": 449,
	"./es-mx.js": 449,
	"./es-us": 450,
	"./es-us.js": 450,
	"./es.js": 451,
	"./et": 452,
	"./et.js": 452,
	"./eu": 453,
	"./eu.js": 453,
	"./fa": 454,
	"./fa.js": 454,
	"./fi": 455,
	"./fi.js": 455,
	"./fil": 456,
	"./fil.js": 456,
	"./fo": 457,
	"./fo.js": 457,
	"./fr": 460,
	"./fr-ca": 458,
	"./fr-ca.js": 458,
	"./fr-ch": 459,
	"./fr-ch.js": 459,
	"./fr.js": 460,
	"./fy": 461,
	"./fy.js": 461,
	"./ga": 462,
	"./ga.js": 462,
	"./gd": 463,
	"./gd.js": 463,
	"./gl": 464,
	"./gl.js": 464,
	"./gom-deva": 465,
	"./gom-deva.js": 465,
	"./gom-latn": 466,
	"./gom-latn.js": 466,
	"./gu": 467,
	"./gu.js": 467,
	"./he": 468,
	"./he.js": 468,
	"./hi": 469,
	"./hi.js": 469,
	"./hr": 470,
	"./hr.js": 470,
	"./hu": 471,
	"./hu.js": 471,
	"./hy-am": 472,
	"./hy-am.js": 472,
	"./id": 473,
	"./id.js": 473,
	"./is": 474,
	"./is.js": 474,
	"./it": 476,
	"./it-ch": 475,
	"./it-ch.js": 475,
	"./it.js": 476,
	"./ja": 477,
	"./ja.js": 477,
	"./jv": 478,
	"./jv.js": 478,
	"./ka": 479,
	"./ka.js": 479,
	"./kk": 480,
	"./kk.js": 480,
	"./km": 481,
	"./km.js": 481,
	"./kn": 482,
	"./kn.js": 482,
	"./ko": 483,
	"./ko.js": 483,
	"./ku": 484,
	"./ku.js": 484,
	"./ky": 485,
	"./ky.js": 485,
	"./lb": 486,
	"./lb.js": 486,
	"./lo": 487,
	"./lo.js": 487,
	"./lt": 488,
	"./lt.js": 488,
	"./lv": 489,
	"./lv.js": 489,
	"./me": 490,
	"./me.js": 490,
	"./mi": 491,
	"./mi.js": 491,
	"./mk": 492,
	"./mk.js": 492,
	"./ml": 493,
	"./ml.js": 493,
	"./mn": 494,
	"./mn.js": 494,
	"./mr": 495,
	"./mr.js": 495,
	"./ms": 497,
	"./ms-my": 496,
	"./ms-my.js": 496,
	"./ms.js": 497,
	"./mt": 498,
	"./mt.js": 498,
	"./my": 499,
	"./my.js": 499,
	"./nb": 500,
	"./nb.js": 500,
	"./ne": 501,
	"./ne.js": 501,
	"./nl": 503,
	"./nl-be": 502,
	"./nl-be.js": 502,
	"./nl.js": 503,
	"./nn": 504,
	"./nn.js": 504,
	"./oc-lnc": 505,
	"./oc-lnc.js": 505,
	"./pa-in": 506,
	"./pa-in.js": 506,
	"./pl": 507,
	"./pl.js": 507,
	"./pt": 509,
	"./pt-br": 508,
	"./pt-br.js": 508,
	"./pt.js": 509,
	"./ro": 510,
	"./ro.js": 510,
	"./ru": 511,
	"./ru.js": 511,
	"./sd": 512,
	"./sd.js": 512,
	"./se": 513,
	"./se.js": 513,
	"./si": 514,
	"./si.js": 514,
	"./sk": 515,
	"./sk.js": 515,
	"./sl": 516,
	"./sl.js": 516,
	"./sq": 517,
	"./sq.js": 517,
	"./sr": 519,
	"./sr-cyrl": 518,
	"./sr-cyrl.js": 518,
	"./sr.js": 519,
	"./ss": 520,
	"./ss.js": 520,
	"./sv": 521,
	"./sv.js": 521,
	"./sw": 522,
	"./sw.js": 522,
	"./ta": 523,
	"./ta.js": 523,
	"./te": 524,
	"./te.js": 524,
	"./tet": 525,
	"./tet.js": 525,
	"./tg": 526,
	"./tg.js": 526,
	"./th": 527,
	"./th.js": 527,
	"./tk": 528,
	"./tk.js": 528,
	"./tl-ph": 529,
	"./tl-ph.js": 529,
	"./tlh": 530,
	"./tlh.js": 530,
	"./tr": 531,
	"./tr.js": 531,
	"./tzl": 532,
	"./tzl.js": 532,
	"./tzm": 534,
	"./tzm-latn": 533,
	"./tzm-latn.js": 533,
	"./tzm.js": 534,
	"./ug-cn": 535,
	"./ug-cn.js": 535,
	"./uk": 536,
	"./uk.js": 536,
	"./ur": 537,
	"./ur.js": 537,
	"./uz": 539,
	"./uz-latn": 538,
	"./uz-latn.js": 538,
	"./uz.js": 539,
	"./vi": 540,
	"./vi.js": 540,
	"./x-pseudo": 541,
	"./x-pseudo.js": 541,
	"./yo": 542,
	"./yo.js": 542,
	"./zh-cn": 543,
	"./zh-cn.js": 543,
	"./zh-hk": 544,
	"./zh-hk.js": 544,
	"./zh-mo": 545,
	"./zh-mo.js": 545,
	"./zh-tw": 546,
	"./zh-tw.js": 546
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 988;

/***/ }),

/***/ 989:
/***/ (function(module, exports) {

module.exports = {"2.16.840.1.101.3.4.1.1":"aes-128-ecb","2.16.840.1.101.3.4.1.2":"aes-128-cbc","2.16.840.1.101.3.4.1.3":"aes-128-ofb","2.16.840.1.101.3.4.1.4":"aes-128-cfb","2.16.840.1.101.3.4.1.21":"aes-192-ecb","2.16.840.1.101.3.4.1.22":"aes-192-cbc","2.16.840.1.101.3.4.1.23":"aes-192-ofb","2.16.840.1.101.3.4.1.24":"aes-192-cfb","2.16.840.1.101.3.4.1.41":"aes-256-ecb","2.16.840.1.101.3.4.1.42":"aes-256-cbc","2.16.840.1.101.3.4.1.43":"aes-256-ofb","2.16.840.1.101.3.4.1.44":"aes-256-cfb"}

/***/ })

},[633]);


// WEBPACK FOOTER //
// static/js/app.ac93094f35c60feb11aa.js